
// // import { motion } from 'framer-motion';
// // import { getRegionBySlug } from './regionApi';
// // import { useEffect, useMemo, useRef, useState } from 'react';
// // import { useLocation, useParams } from 'react-router-dom';
// // import {
// //   FaAward,
// //   FaBolt,
// //   FaBuilding,
// //   FaCalendarAlt,
// //   FaCertificate,
// //   FaChartLine,
// //   FaCheck,
// //   FaCheckCircle,
// //   FaChevronLeft,
// //   FaChevronRight,
// //   FaDownload,
// //   FaEnvelope,
// //   FaExchangeAlt,
// //   FaFileSignature,
// //   FaGlobeAsia,
// //   FaHandshake,
// //   FaIndustry,
// //   FaLandmark,
// //   FaLaptopCode,
// //   FaLightbulb,
// //   FaMapMarkerAlt,
// //   FaMoneyBillWave,
// //   FaPaperPlane,
// //   FaPeopleArrows,
// //   FaPhone,
// //   FaPills,
// //   FaRocket,
// //   FaRss,
// //   FaSearch,
// //   FaSeedling,
// //   FaSlidersH,
// //   FaTag,
// //   FaTimes,
// //   FaUniversity,
// //   FaUserTie,
// //   FaWhatsapp,
// //   FaDirections,
// //   FaRegBuilding,
// // } from 'react-icons/fa';
// // import {
// //   statesData,
// //   stateNames,
// //   defaultOverview,
// //   defaultInitiatives,
// //   defaultPriorities,
// //   getStateHod,
// //   defaultHod,
// //   getStateOffice,
// //   defaultOffice,
// // } from './statesData';
// // import CouncilLeadership from './CouncilLeadership.jsx';
// // import QueryForm from '../components/Sectors/QueryForm.jsx';

// // const heroImage =
// //   'https://images.pexels.com/photos/17585996/pexels-photo-17585996.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200';
// // const overviewDefaultImg =
// //   'https://images.pexels.com/photos/3183197/pexels-photo-3183197.jpeg?auto=compress&cs=tinysrgb&w=1200';

// // // ---- Design constants — same for every state, sirf content data-driven hai ----
// // const mandates = [
// //   {
// //     title: 'Policy Advocacy',
// //     text: 'Public policy, regulatory reforms and Ease of Doing Business inputs with Central and State Governments.',
// //     icon: FaLandmark,
// //   },
// //   {
// //     title: 'Industry Competitiveness',
// //     text: 'Focused support for manufacturing, MSMEs, infrastructure, green growth and business competitiveness.',
// //     icon: FaChartLine,
// //   },
// //   {
// //     title: 'Stakeholder Platform',
// //     text: 'Conferences, seminars, business forums and government-industry interactions across the state.',
// //     icon: FaPeopleArrows,
// //   },
// // ];

// // const services = [
// //   { label: 'Investment facilitation', icon: FaBuilding },
// //   { label: 'Certificate of Origin service', icon: FaCertificate },
// //   { label: 'Overseas delegation support', icon: FaGlobeAsia },
// //   { label: 'Sector-specific MoU facilitation', icon: FaFileSignature },
// //   { label: 'Industry academia connect', icon: FaUniversity },
// //   { label: 'Local chamber collaboration', icon: FaHandshake },
// // ];

// // const fadeUp = {
// //   hidden: { opacity: 0, y: 28 },
// //   visible: { opacity: 1, y: 0 },
// // };

// // // Sector name se best-match icon nikalne ka helper, taaki naye sectors ke liye
// // // bhi manually icon map na karna pade.
// // const sectorIconRules = [
// //   [/agro|food|fisher/i, FaSeedling],
// //   [/renewable|energy|power/i, FaBolt],
// //   [/start-?up/i, FaRocket],
// //   [/intellectual|ipr/i, FaLightbulb],
// //   [/tax/i, FaMoneyBillWave],
// //   [/it\b|ites|e-commerce|digital|electronics|esdm/i, FaLaptopCode],
// //   [/msme|manufactur|mining|industr|engineering/i, FaIndustry],
// //   [/pharma|health|medical/i, FaPills],
// //   [/tourism|aviation|aerospace|hospitality/i, FaGlobeAsia],
// //   [/logistic|warehous|export/i, FaExchangeAlt],
// // ];

// // function iconForSector(name) {
// //   const match = sectorIconRules.find(([regex]) => regex.test(name));
// //   return match ? match[1] : FaIndustry;
// // }

// // function toTitleCase(slug) {
// //   return slug
// //     .split('-')
// //     .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
// //     .join(' ');
// // }

// // // ============================ date helpers ============================
// // function getDateParts(dateStr = '') {
// //   const parts = dateStr.split(' ');
// //   const dayPart = parts[0] || '--';
// //   const restPart = parts.slice(1).join(' ');
// //   const monthPart = (restPart.split(',')[0] || '').split('-')[0].trim();
// //   const yearMatch = dateStr.match(/(20\d{2})/);
// //   const year = yearMatch ? yearMatch[1] : '2026';
// //   return { dayPart, monthPart, year };
// // }

// // function toDateObj(dateStr = '') {
// //   const { dayPart, monthPart, year } = getDateParts(dateStr);
// //   const cleanDay = dayPart.replace(/[^0-9]/g, '') || '1';
// //   const d = new Date(`${monthPart} ${cleanDay}, ${year}`);
// //   return isNaN(d.getTime()) ? null : d;
// // }

// // function isEventUpcoming(dateStr) {
// //   const d = toDateObj(dateStr);
// //   if (!d) return true;
// //   const today = new Date();
// //   today.setHours(0, 0, 0, 0);
// //   return d.getTime() >= today.getTime();
// // }

// // function toTimestamp(dateStr = '') {
// //   const d = toDateObj(dateStr);
// //   return d ? d.getTime() : 0;
// // }

// // // ============================ contact helpers ============================
// // // "+91 98187 15550" jaise display number ko tel:/wa.me ke liye clean karta hai.
// // function telHref(phone = '') {
// //   const digits = String(phone).replace(/[^\d+]/g, '');
// //   if (!digits) return '';
// //   return digits.startsWith('+') ? digits : `+91${digits.replace(/^0+/, '')}`;
// // }

// // function whatsappHref(phone = '') {
// //   const digits = String(phone).replace(/\D/g, '');
// //   if (!digits) return '';
// //   return digits.length === 10 ? `91${digits}` : digits;
// // }

// // // Office ka Google Maps link. Agar office par exact pin (mapUrl) hai to wahi,
// // // warna address se search query bana do.
// // function mapsUrl(office) {
// //   if (office?.mapUrl) return office.mapUrl;
// //   const q = office?.mapQuery || (office?.lines || []).join(' ');
// //   return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;
// // }

// // // Generic fallbacks — jis state ka apna data nahi, usme yehi dikhega taaki
// // // Reports / Press / Events section har state page par dikhe, kabhi khaali na ho.
// // const defaultPublications = [];
// // const defaultPressReleases = [];
// // const defaultPressCoverage = [];
// // const defaultEvents = [];

// // const defaultStateContent = {
// //   focusItems: ['Viksit Bharat 2047', 'Ease of Doing Business', 'Sustainable Development'],
// //   intro:
// //     'A focused ASSOCHAM platform strengthening the state’s industrial ecosystem through policy advocacy, investment engagement, MSME growth, infrastructure dialogue, and sustainable development.',
// //   why:
// //     'This council works closely with the Government and industry stakeholders to advance policy clarity, sector action and long-term competitiveness for the state. Detailed content for this council is coming soon.',
// //   overview: defaultOverview,
// //   sectors: [],
// //   leadership: [],
// //   initiatives: [],
// //   priorities: [],
// //   publications: [],
// //   pressReleases: [],
// //   pressCoverage: [],
// //   events: [],
// // };

// // const SERIF = {
// //   fontFamily: 'Fraunces, Georgia, "Times New Roman", serif',
// // };

// // export default function StatePage() {
// //   // Route dono tarah se support: /:stateSlug (App.jsx me static path ke through)
// //   // ya agar kabhi /states/:stateSlug jaisa nested route use kiya toh useParams se bhi mil jayega.
// //   const { stateSlug } = useParams();
// //   const location = useLocation();
// //   const slug = stateSlug || location.pathname.replace(/^\//, '');
// //   const data = statesData[slug] || defaultStateContent;

// //   const name =
// //     data.name || `${stateNames[slug] || toTitleCase(slug)} State Development Council`;
// //   const stateLabel = stateNames[slug] || toTitleCase(slug || 'State');
// //   const overviewParagraphs =
// //     data.overview && data.overview.length > 0 ? data.overview : defaultOverview;
// //   const initiatives =
// //     data.initiatives && data.initiatives.length > 0 ? data.initiatives : defaultInitiatives;
// //   const priorities =
// //     data.priorities && data.priorities.length > 0 ? data.priorities : defaultPriorities;
// //   const PUBLICATIONS = data.publications || defaultPublications;
// //   const PRESS_RELEASES = data.pressReleases || defaultPressReleases;
// //   const PRESS_COVERAGE = data.pressCoverage || defaultPressCoverage;
// //   const EVENTS = data.events || defaultEvents;

// //   /* -------------------------- State ka ASSOCHAM HoD -------------------------- */
// //   // statesData[slug].hod > stateHods[slug] > defaultHod (secretariat)
// //   const hod = useMemo(() => getStateHod(slug), [slug]);
// //   const hasNamedHod = Boolean(hod && hod.name && hod.name !== defaultHod.name);
// //   const hodPhoneHref = telHref(hod?.phone || defaultHod.phone);
// //   const hodWaNumber = whatsappHref(hod?.phone || '');
// //   const hodEmail = hod?.email || defaultHod.email;

// //   /* -------------------------- State ka ASSOCHAM office -------------------------- */
// //   // statesData[slug].office > stateOffices[slug] > defaultOffice (HQ)
// //   // Jiska apna kuch nahi, uske page par poori HQ details chali jaati hain.
// //   const office = useMemo(() => getStateOffice(slug), [slug]);
// //   const officeIsHq = Boolean(office.usingHqAddress);
// //   const officePhone = office.phone || defaultOffice.phone;
// //   const officePhoneHref = office.phoneHref || `tel:${telHref(officePhone)}`;
// //   const officeEmail = office.email || defaultOffice.email;

// //   /* -------------------------- Events state -------------------------- */
// //   const [eventTab, setEventTab] = useState('all'); // "all" | "forthcoming" | "past"
// //   const [eventKeyword, setEventKeyword] = useState('');
// //   const [eventTag, setEventTag] = useState('');
// //   const [eventPlace, setEventPlace] = useState('');
// //   const [eventAnimKey, setEventAnimKey] = useState(0);
// //   const [eventsVisible, setEventsVisible] = useState(2);
// //   const EVENTS_STEP = 2;

// //   /* -------------------------- Press state -------------------------- */
// //   const [pressTab, setPressTab] = useState('releases'); // "releases" | "coverage"
// //   const [pressKeyword, setPressKeyword] = useState('');
// //   const [pressSort, setPressSort] = useState('newest'); // "newest" | "oldest"
// //   const [pressPage, setPressPage] = useState(1);
// //   const pressResultsRef = useRef(null);
// //   const PRESS_PAGE_SIZE = 5;

// //   /* -------------------------- Contact form -------------------------- */
// //   const [submitted, setSubmitted] = useState(false);

// //   /* -------------------------- Press derived state -------------------------- */
// //   const pressSource = pressTab === 'releases' ? PRESS_RELEASES : PRESS_COVERAGE;

// //   const pressFiltered = useMemo(() => {
// //     const kw = pressKeyword.trim().toLowerCase();
// //     let list = pressSource.filter((item) => {
// //       if (!kw) return true;
// //       const hay = `${item.title} ${item.excerpt || ''}`.toLowerCase();
// //       return hay.includes(kw);
// //     });
// //     list = [...list].sort((a, b) => {
// //       const ta = toTimestamp(a.date);
// //       const tb = toTimestamp(b.date);
// //       return pressSort === 'newest' ? tb - ta : ta - tb;
// //     });
// //     return list;
// //   }, [pressSource, pressKeyword, pressSort]);

// //   useEffect(() => setPressPage(1), [pressTab, pressKeyword, pressSort]);

// //   const pressTotalPages = Math.max(1, Math.ceil(pressFiltered.length / PRESS_PAGE_SIZE));
// //   const pressClampedPage = Math.min(pressPage, pressTotalPages);
// //   const pressStart = (pressClampedPage - 1) * PRESS_PAGE_SIZE;
// //   const pressPageItems = pressFiltered.slice(pressStart, pressStart + PRESS_PAGE_SIZE);

// //   const scrollToPressResults = () =>
// //     pressResultsRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });

// //   const changePressPage = (n) => {
// //     setPressPage(n);
// //     scrollToPressResults();
// //   };

// // const [regionData, setRegionData] = useState(null);

// // useEffect(() => {
// //   let active = true;
// //   getRegionBySlug(slug).then((res) => {
// //     if (active && res) setRegionData(res);
// //   });
// //   return () => { active = false; };
// // }, [slug]);

// // // API se aaya data local statesData.js par override karega — jo bhi field
// // // API se null/khaali aaye, wahan hardcoded statesData.js wala fallback rahega.
// // const heroImageFinal = regionData?.header_banner_img || heroImage;
// // const overviewImageFinal = regionData?.image || data.overviewImage || overviewDefaultImg;
// // const overviewTitleFinal = regionData?.title || name;
// // const overviewTextFinal = regionData?.long_description
// //   ? [regionData.long_description]
// //   : overviewParagraphs;


// //   /* -------------------------- Events derived state -------------------------- */
// //   const eventTags = useMemo(
// //     () => Array.from(new Set(EVENTS.map((e) => e.tag).filter(Boolean))),
// //     [EVENTS]
// //   );

// //   const eventPlaces = useMemo(
// //     () => Array.from(new Set(EVENTS.map((e) => e.place).filter(Boolean))),
// //     [EVENTS]
// //   );

// //   const filteredEvents = useMemo(() => {
// //     const kw = eventKeyword.trim().toLowerCase();
// //     return EVENTS.filter((e) => {
// //       const upcoming = isEventUpcoming(e.date);
// //       if (eventTab === 'forthcoming' && !upcoming) return false;
// //       if (eventTab === 'past' && upcoming) return false;
// //       if (eventTag && e.tag !== eventTag) return false;
// //       if (eventPlace && e.place !== eventPlace) return false;
// //       if (kw) {
// //         const hay = `${e.title} ${e.text} ${e.tag || ''} ${e.place || ''}`.toLowerCase();
// //         if (!hay.includes(kw)) return false;
// //       }
// //       return true;
// //     });
// //   }, [eventTab, eventTag, eventPlace, eventKeyword, EVENTS]);

// //   useEffect(() => {
// //     setEventAnimKey((k) => k + 1);
// //   }, [eventTab, eventTag, eventPlace]);

// //   useEffect(() => {
// //     setEventsVisible(2);
// //   }, [eventTab, eventTag, eventPlace, eventKeyword]);

// //   const clearEventFilters = () => {
// //     setEventKeyword('');
// //     setEventTag('');
// //     setEventPlace('');
// //     setEventTab('all');
// //     setEventAnimKey((k) => k + 1);
// //   };

// //   const visibleEvents = filteredEvents.slice(0, eventsVisible);
// //   const hasMoreEvents = eventsVisible < filteredEvents.length;
// //   const loadMoreEvents = () =>
// //     setEventsVisible((v) => Math.min(v + EVENTS_STEP, filteredEvents.length));

// //   /* -------------------------- Contact form handler -------------------------- */
// //   const handleSubmit = (e) => {
// //     e.preventDefault();
// //     setSubmitted(true);
// //     window.setTimeout(() => setSubmitted(false), 5000);
// //   };

// //   const sectionEyebrow = (label, color = '#DB6400') => (
// //     <p className="text-xs font-semibold uppercase tracking-[0.35em]" style={{ color }}>
// //       {label}
// //     </p>
// //   );

// //   return (
// //     <main className="min-h-screen overflow-hidden bg-[#FAF7F2] text-[#241A16] selection:bg-[#DA2128] selection:text-white">
// //       <style>{`
// //         .event-fade-up { animation: st-fade-up 0.6s cubic-bezier(.2,.8,.2,1) both; }
// //         @keyframes st-fade-up { 0% { opacity: 0; transform: translateY(22px); } 100% { opacity: 1; transform: translateY(0); } }
// //         .event-live-pill { animation: st-pulse-glow 2.4s infinite; }
// //         @keyframes st-pulse-glow { 0%, 100% { box-shadow: 0 0 0 0 rgba(245,156,0,0.3); } 50% { box-shadow: 0 0 0 10px rgba(245,156,0,0); } }
// //         .font-heading { font-family: 'Fraunces', Georgia, serif; }
// //         .sector-section { scroll-margin-top: 2rem; }
// //         @media (prefers-reduced-motion: reduce){*,*::before,*::after{animation-duration:.001ms!important;animation-iteration-count:1!important;transition-duration:.001ms!important}}
// //       `}</style>

// //       {/* ==================== HERO ==================== */}
// //       {/* <section id="top" className="relative isolate min-h-[400px] overflow-hidden bg-[#FEF7F4] text-[#12100E]">
// //         <motion.img
// //           src={heroImage}
// //           alt={`${name} banner`}
// //           className="absolute inset-0 h-full w-full object-cover opacity-20 mix-blend-multiply"
// //           initial={{ scale: 1.05 }}
// //           animate={{ scale: 1 }}
// //           transition={{ duration: 1.4, ease: 'easeOut' }}
// //         />
// //         <div className="absolute inset-0 bg-[linear-gradient(110deg,#FEF7F4_0%,rgba(254,247,244,0.92)_45%,rgba(218,33,40,0.15)_100%)]" />
// //         <motion.div
// //           aria-hidden="true"
// //           className="absolute -right-32 -top-40 h-[26rem] w-[26rem] rounded-full border-[40px] border-[#F59C00]/15 pointer-events-none"
// //           animate={{ rotate: 360 }}
// //           transition={{ duration: 35, repeat: Infinity, ease: 'linear' }}
// //         />
// //         <motion.div
// //           aria-hidden="true"
// //           className="absolute -bottom-36 left-[8%] h-[20rem] w-[20rem] rounded-full border-[28px] border-[#DA2128]/15 pointer-events-none"
// //           animate={{ y: [0, -20, 0], x: [0, 10, 0] }}
// //           transition={{ duration: 8, repeat: Infinity, ease: 'easeInOut' }}
// //         />
// //         <div className="relative mx-auto grid max-w-7xl items-end gap-12 px-6 py-12 lg:grid-cols-[1.15fr_0.85fr] lg:px-12 lg:py-16">
// //           <motion.div initial="hidden" animate="visible" variants={fadeUp} transition={{ duration: 0.7 }}>
// //             <p className="mb-3 text-xs font-semibold uppercase tracking-[0.35em] text-[#D98200]">
// //               Industry Policy Forum
// //             </p>
// //             <h1
// //               className="max-w-3xl text-3xl font-medium leading-[1.15] tracking-tight text-[#12100E] md:text-5xl"
// //               style={SERIF}
// //             >
// //               {name}
// //             </h1>
           
// //           </motion.div>
     
// //         </div>
// //       </section> */}
// //         <section id="top" className="relative isolate min-h-[400px] overflow-hidden bg-[#FEF7F4] text-[#12100E]">
// //           <motion.img
// //     src={heroImageFinal}
// //     alt={`${name} banner`}
// //     className="absolute inset-0 h-full w-full object-cover opacity-40"
// //     initial={{ scale: 1.05 }}
// //     animate={{ scale: 1 }}
// //     transition={{ duration: 1.4, ease: 'easeOut' }}
// //   />
  
// //   <div className="absolute inset-0 z-[1] bg-[linear-gradient(110deg,rgba(121, 117, 116, 0.46)_0%,rgba(78, 76, 75, 0.44)_45%,rgba(18,16,14,0.55)_100%)]" />

  
// //   <motion.div
// //     aria-hidden="true"
// //     className="absolute -right-32 -top-40 z-[1] h-[26rem] w-[26rem] rounded-full border-[40px] border-[#F59C00]/15 pointer-events-none"
// //     animate={{ rotate: 360 }}
// //     transition={{ duration: 35, repeat: Infinity, ease: 'linear' }}
// //   />

 
// //   <div className="relative z-10 mx-auto grid max-w-7xl items-end gap-12 px-6 py-12 lg:grid-cols-[1.15fr_0.85fr] lg:px-12 lg:py-16">
// //     <motion.div initial="hidden" animate="visible" variants={fadeUp} transition={{ duration: 0.7 }}>
// //       <p className="mb-3 text-xs font-semibold uppercase tracking-[0.35em] text-[#D98200]">
// //         Industry Policy Forum
// //       </p>
// //       <h1
// //         className="max-w-3xl text-3xl font-medium leading-[1.15] tracking-tight text-[#12100E] md:text-5xl"
// //         style={SERIF}
// //       >
// //         {overviewTitleFinal}
// //       </h1>
// //     </motion.div>
// //   </div>
// // </section>

// //       {/* ==================== OVERVIEW (SectorPage-style) ==================== */}
// //       <section
// //         id="overview"
// //         className="sector-section relative scroll-mt-6 overflow-hidden bg-white py-16 lg:py-24"
// //       >
// //         <div className="relative mx-auto max-w-7xl px-6 lg:px-12">
// //           <div className="grid items-center gap-14 lg:grid-cols-2 lg:gap-16">
// //             <motion.div
// //               initial="hidden"
// //               whileInView="visible"
// //               viewport={{ once: true }}
// //               variants={fadeUp}
// //               className="relative"
// //             >
// //               {/* <div className="overflow-hidden rounded-[32px] border-4 border-white shadow-2xl shadow-stone-900/15">
// //                 <img
// //                   src={data.overviewImage || overviewDefaultImg}
// //                   alt={name}
// //                   className="h-[380px] w-full object-cover transition-transform duration-[1400ms] hover:scale-105 sm:h-[420px]"
// //                   loading="lazy"
// //                 />
// //               </div> */}

// //               <div className="overflow-hidden rounded-[32px] border-4 border-white shadow-2xl shadow-stone-900/15">
// //                 <img
// //                   src={regionData?.image || data.overviewImage || overviewDefaultImg}
// //                   alt={name}
// //                   className="h-[380px] w-full object-cover transition-transform duration-[1400ms] hover:scale-105 sm:h-[420px]"
// //                   loading="lazy"
// //                 />
// //               </div>

// //               <div className="absolute -bottom-6 -right-4 w-60 rounded-2xl border border-stone-100 bg-white p-5 shadow-2xl">
// //                 <p className="text-[11px] font-extrabold uppercase tracking-[0.2em] text-[#DA2128]">
// //                   State Council
// //                 </p>
// //                 <p className="mt-1 text-[14.5px] font-bold leading-snug text-stone-900" style={SERIF}>
// //                   {name}
// //                 </p>
// //               </div>
// //             </motion.div>

// //             <div>
// //               <p className="text-xs font-semibold uppercase tracking-[0.35em] text-[#DB6400]">
// //                 Overview
// //               </p>
// //               <h2
// //                 className="mt-3 text-2xl font-medium leading-[1.25] tracking-tight text-[#241A16] md:text-4xl"
// //                 style={SERIF}
// //               >
// //                 Shaping India&apos;s{' '}
// //                 <span className="text-[#DA2128]">
// //                   {name.replace(/State (Development )?Council/i, '').trim()} Agenda
// //                 </span>
// //               </h2>

// //               {/* <div className="mt-6 space-y-4 border-l-2 border-[#DA2128]/20 pl-5">
// //                 {overviewParagraphs.map((p, i) => (
// //                   <motion.p
// //                     key={i}
// //                     initial={{ opacity: 0, x: 15 }}
// //                     whileInView={{ opacity: 1, x: 0 }}
// //                     viewport={{ once: true }}
// //                     transition={{ delay: 0.1 + i * 0.08 }}
// //                     className="text-[15.5px] leading-relaxed text-stone-600"
// //                   >
// //                     {i === 0 && p.includes('ASSOCHAM') ? (
// //                       <>
// //                         <span className="font-bold text-stone-900">ASSOCHAM</span>
// //                         {p.replace('ASSOCHAM', '')}
// //                       </>
// //                     ) : (
// //                       p
// //                     )}
// //                   </motion.p>
// //                 ))}
// //               </div> */}

// //                             <div className="mt-6 space-y-4 border-l-2 border-[#DA2128]/20 pl-5">
// //                 {regionData?.long_description ? (
// //                   <div
// //                     className="prose prose-stone max-w-none text-[15.5px] leading-relaxed text-stone-600 [&_p]:mb-4"
// //                     dangerouslySetInnerHTML={{ __html: regionData.long_description }}
// //                   />
// //                 ) : (
// //                   overviewParagraphs.map((p, i) => (
// //                     <motion.p
// //                       key={i}
// //                       initial={{ opacity: 0, x: 15 }}
// //                       whileInView={{ opacity: 1, x: 0 }}
// //                       viewport={{ once: true }}
// //                       transition={{ delay: 0.1 + i * 0.08 }}
// //                       className="text-[15.5px] leading-relaxed text-stone-600"
// //                     >
// //                       {i === 0 && p.includes('ASSOCHAM') ? (
// //                         <>
// //                           <span className="font-bold text-stone-900">ASSOCHAM</span>
// //                           {p.replace('ASSOCHAM', '')}
// //                         </>
// //                       ) : (
// //                         p
// //                       )}
// //                     </motion.p>
// //                   ))
// //                 )}
// //               </div>

// //               {data.sectors && data.sectors.length > 0 && (
// //                 <div className="mt-8 grid gap-3 sm:grid-cols-2">
// //                   {data.sectors.slice(0, 6).map((sectorName, i) => (
// //                     <div
// //                       key={i}
// //                       className="flex items-start gap-2.5 rounded-2xl bg-[#FAF7F2] p-3.5 ring-1 ring-stone-200"
// //                     >
// //                       <FaCheck className="mt-1 h-3.5 w-3.5 shrink-0 text-[#DA2128]" />
// //                       <p className="text-[13px] font-medium leading-relaxed text-stone-700">
// //                         {sectorName}
// //                       </p>
// //                     </div>
// //                   ))}
// //                 </div>
// //               )}
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* ==================== MANDATE ==================== */}
// //       {/* <section id="mandate" className="mx-auto max-w-7xl px-6 py-16 lg:px-12 lg:py-20">
// //         <div className="grid gap-12 lg:grid-cols-[0.85fr_1.15fr]">
// //           <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeUp}>
// //             <p className="text-xs font-semibold uppercase tracking-[0.35em] text-[#DB6400]">
// //               Why the council exists
// //             </p>
// //             <h2
// //               className="mt-3 text-2xl font-medium leading-[1.25] tracking-tight text-[#241A16] md:text-4xl"
// //               style={SERIF}
// //             >
// //               Government, industry and chambers on one operating table.
// //             </h2>
// //             <p className="mt-4 text-base leading-relaxed text-[#241A16]/75 font-normal">
// //               {data.why || defaultStateContent.why}
// //             </p>
// //           </motion.div>
// //           <div className="relative border-l border-[#DA2128]/20 pl-8 font-sans">
// //             {mandates.map((item, index) => {
// //               const Icon = item.icon;
// //               return (
// //                 <motion.div
// //                   key={item.title}
// //                   className="relative pb-8 last:pb-0"
// //                   initial={{ opacity: 0, x: 20 }}
// //                   whileInView={{ opacity: 1, x: 0 }}
// //                   viewport={{ once: true }}
// //                   transition={{ delay: index * 0.12 }}
// //                 >
// //                   <span className="absolute -left-[2.5rem] top-0.5 flex h-7 w-7 items-center justify-center rounded-sm bg-[#DA2128] text-white shadow-sm">
// //                     <Icon className="text-xs" />
// //                   </span>
// //                   <h3 className="text-lg font-medium tracking-tight text-[#DA2128]" style={SERIF}>
// //                     {item.title}
// //                   </h3>
// //                   <p className="mt-1.5 max-w-2xl text-sm leading-relaxed text-[#241A16]/75 font-normal">
// //                     {item.text}
// //                   </p>
// //                 </motion.div>
// //               );
// //             })}
// //           </div>
// //         </div>
// //       </section> */}

// //       {/* ==================== COUNCIL LEADERSHIP (Sector-style) ==================== */}
// //       <section
// //         id="councils"
// //         className="sector-section relative scroll-mt-6 overflow-hidden bg-white py-20 lg:py-24"
// //       >
// //         <div className="pointer-events-none absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-[#FAF7F2] to-transparent" />
// //         <div className="relative mx-auto max-w-7xl px-6 lg:px-12">
// //           <div className="mb-2">
// //             <p className="text-xs font-semibold uppercase tracking-[0.35em] text-[#DB6400]">
// //               Councils
// //             </p>
// //             <h2
// //               className="mt-3 text-2xl font-medium leading-[1.25] tracking-tight text-[#241A16] md:text-4xl"
// //               style={SERIF}
// //             >
// //               Council Leadership
// //             </h2>
// //           </div>
// //           <CouncilLeadership members={data.leadership} councilName={name} />
// //         </div>
// //       </section>

// //       {/* ==================== SECTORS ==================== */}
// //       {data.sectors && data.sectors.length > 0 && (
// //         <section id="sectors" className="relative bg-[#FEF7F4] py-16 lg:py-20">
// //           <div className="mx-auto max-w-7xl px-6 lg:px-12">
// //             <div className="mb-12 flex flex-col justify-between gap-6 md:flex-row md:items-end">
// //               <div>
// //                 <p className="text-xs font-semibold uppercase tracking-[0.35em] text-[#DB6400]">
// //                   Sectoral Engine
// //                 </p>
// //                 <h2
// //                   className="mt-3 text-2xl font-medium leading-[1.25] tracking-tight text-[#241A16] md:text-4xl"
// //                   style={SERIF}
// //                 >
// //                   Focused committees for focused outcomes.
// //                 </h2>
// //               </div>
// //               <p className="max-w-md text-sm leading-relaxed text-[#241A16]/75 font-normal">
// //                 Sector sub-committees help convert member inputs into state-specific policy recommendations,
// //                 promotion opportunities and business interactions.
// //               </p>
// //             </div>
// //             <div className="grid border-t border-l border-[#241A16]/10 sm:grid-cols-2 lg:grid-cols-4">
// //               {data.sectors.map((sectorName, index) => {
// //                 const Icon = iconForSector(sectorName);
// //                 return (
// //                   <motion.div
// //                     key={sectorName}
// //                     className="group relative flex min-h-[160px] flex-col justify-between border-r border-b border-[#241A16]/10 bg-white/60 p-6 transition-all duration-300 hover:bg-[#DA2128]"
// //                     initial={{ opacity: 0, y: 20 }}
// //                     whileInView={{ opacity: 1, y: 0 }}
// //                     viewport={{ once: true }}
// //                     transition={{ delay: index * 0.04 }}
// //                   >
// //                     <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-[#DA2128]/10 text-[#DA2128] transition-all duration-300 group-hover:bg-white/20 group-hover:text-white group-hover:scale-105">
// //                       <Icon className="text-xl" />
// //                     </div>
// //                     <p
// //                       className="mt-6 text-base font-medium tracking-tight text-[#241A16] transition-colors duration-300 group-hover:text-white"
// //                       style={SERIF}
// //                     >
// //                       {sectorName}
// //                     </p>
// //                   </motion.div>
// //                 );
// //               })}
// //             </div>
// //           </div>
// //         </section>
// //       )}

// //       {/* ==================== SERVICES ==================== */}
// //       {/* <section className="mx-auto max-w-7xl px-6 py-16 lg:px-12 lg:py-20">
// //         <div className="grid gap-12 lg:grid-cols-[0.85fr_1.15fr]">
// //           <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeUp}>
// //             <p className="text-xs font-semibold uppercase tracking-[0.35em] text-[#DB6400]">
// //               Services
// //             </p>
// //             <h2
// //               className="mt-3 text-2xl font-medium leading-[1.25] tracking-tight text-[#241A16] md:text-4xl"
// //               style={SERIF}
// //             >
// //               A chamber desk for companies operating in the state.
// //             </h2>
// //             <p className="mt-4 text-base leading-relaxed text-[#241A16]/75 font-normal">
// //               From investment confidence and policy submissions to delegations, certificates and MoU facilitation,
// //               the council supports member companies with practical industry services.
// //             </p>
// //           </motion.div>
// //           <div className="grid gap-x-8 gap-y-6 sm:grid-cols-2">
// //             {services.map((service, index) => {
// //               const Icon = service.icon;
// //               return (
// //                 <motion.div
// //                   key={service.label}
// //                   className="group flex items-start gap-4 border-b border-[#241A16]/10 pb-5"
// //                   initial={{ opacity: 0, y: 16 }}
// //                   whileInView={{ opacity: 1, y: 0 }}
// //                   viewport={{ once: true }}
// //                   transition={{ delay: index * 0.06 }}
// //                 >
// //                   <span className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-[#DA2128]/10 text-[#DA2128] transition-all duration-300 group-hover:bg-[#DA2128] group-hover:text-white group-hover:scale-105">
// //                     <Icon className="text-lg" />
// //                   </span>
// //                   <p
// //                     className="text-base font-medium leading-snug tracking-tight text-[#241A16]"
// //                     style={SERIF}
// //                   >
// //                     {service.label}
// //                   </p>
// //                 </motion.div>
// //               );
// //             })}
// //           </div>
// //         </div>
// //       </section> */}

// //       {/* ==================== INITIATIVES ==================== */}
// //       {/* <section id="initiatives" className="relative overflow-hidden bg-[#FFFBF7] text-[#12100E]">
// //         <div className="pointer-events-none absolute -right-20 -top-20 h-96 w-96 rounded-full bg-[#F59C00]/10 blur-3xl" />
// //         <div className="pointer-events-none absolute -bottom-20 -left-20 h-96 w-96 rounded-full bg-[#DA2128]/5 blur-3xl" />
// //         <div className="relative mx-auto max-w-7xl px-6 py-16 lg:px-12 lg:py-20">
// //           <div className="mb-12 max-w-2xl">
// //             <p className="text-xs font-semibold uppercase tracking-[0.35em] text-[#D98200]">
// //               Flagship Initiatives
// //             </p>
// //             <h2
// //               className="mt-3 text-2xl font-semibold leading-[1.25] tracking-tight text-[#12100E] md:text-4xl"
// //               style={SERIF}
// //             >
// //               Where the council creates momentum.
// //             </h2>
// //           </div>
// //           <div className="divide-y divide-black/10 border-y border-black/10">
// //             {initiatives.map((initiative, index) => (
// //               <motion.div
// //                 key={initiative}
// //                 className="group grid gap-4 py-5 md:grid-cols-[70px_1fr_32px] md:items-center"
// //                 initial={{ opacity: 0, y: 16 }}
// //                 whileInView={{ opacity: 1, y: 0 }}
// //                 viewport={{ once: true }}
// //                 transition={{ delay: index * 0.04 }}
// //               >
// //                 <p className="text-xs font-bold uppercase tracking-widest text-[#D98200]">
                
// //                 </p>
// //                 <p
// //                   className="text-base font-semibold tracking-tight text-[#12100E]/85 transition-colors duration-300 group-hover:text-[#12100E]"
// //                   style={SERIF}
// //                 >
// //                   {initiative}
// //                 </p>
// //                 <div className="hidden h-8 w-8 items-center justify-center rounded-md border border-black/10 bg-black/5 text-[#DA2128] transition-all duration-300 group-hover:bg-[#DA2128] group-hover:border-[#DA2128] group-hover:text-white md:flex">
// //                   <FaExchangeAlt className="text-xs" />
// //                 </div>
// //               </motion.div>
// //             ))}
// //           </div>
// //         </div>
// //       </section> */}

// //       {/* ==================== STRATEGIC PRIORITIES ==================== */}
// //       {/* <section className="relative bg-[#FFFFFF] py-16 lg:py-20">
// //         <div className="absolute left-0 top-0 h-full w-1/3 bg-[#DA2128]" />
// //         <div className="relative mx-auto grid max-w-7xl gap-8 px-6 lg:grid-cols-[0.72fr_1.28fr] lg:px-12">
// //           <motion.div
// //             initial="hidden"
// //             whileInView="visible"
// //             viewport={{ once: true }}
// //             variants={fadeUp}
// //             className="flex flex-col justify-center py-4 text-white"
// //           >
// //             <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-lg bg-white/10 text-[#F59C00]">
// //               <FaAward className="text-xl" />
// //             </div>
// //             <h2
// //               className="text-2xl font-medium leading-[1.25] tracking-tight text-white md:text-4xl"
// //               style={SERIF}
// //             >
// //               Strategic Priorities
// //             </h2>
// //             <p className="mt-3 text-sm font-normal text-white/80">
// //               Current direction for deeper state impact.
// //             </p>
// //           </motion.div>
// //           <div className="rounded-r-lg bg-[#FAF7F2] p-6 shadow-sm lg:p-10">
// //             {priorities.map((priority, index) => (
// //               <motion.div
// //                 key={priority}
// //                 className="flex items-baseline gap-4 border-b border-[#241A16]/10 py-5 first:pt-0 last:border-b-0 last:pb-0"
// //                 initial={{ opacity: 0, x: 20 }}
// //                 whileInView={{ opacity: 1, x: 0 }}
// //                 viewport={{ once: true }}
// //                 transition={{ delay: index * 0.1 }}
// //               >
// //                 <span className="text-xs font-semibold uppercase tracking-widest text-[#DA2128]">
// //                   0{index + 1}
// //                 </span>
// //                 <p className="text-lg font-medium tracking-tight text-[#241A16]" style={SERIF}>
// //                   {priority}
// //                 </p>
// //               </motion.div>
// //             ))}
// //           </div>
// //         </div>
// //       </section> */}

// //       {/* ==================== EVENTS (Upcoming & Past) ==================== */}
// //       <section id="events" className="relative scroll-mt-20 overflow-hidden bg-white py-16 lg:py-20">
// //         <div className="pointer-events-none absolute -right-24 top-10 h-72 w-72 rounded-full bg-[#F59C00]/10 blur-3xl" />
// //         <div className="pointer-events-none absolute -left-24 bottom-0 h-72 w-72 rounded-full bg-[#DA2128]/10 blur-3xl" />
// //         <div className="relative mx-auto max-w-7xl px-6 lg:px-12">
// //           <div className="mb-10 max-w-2xl">
// //             {sectionEyebrow('Engagements & Events', '#DB6400')}
// //             <h2
// //               className="mt-3 text-2xl font-medium leading-[1.25] tracking-tight text-[#241A16] md:text-4xl"
// //               style={SERIF}
// //             >
// //               Recent &amp; Upcoming Initiatives
// //             </h2>
// //           </div>
// //           <div className="grid gap-6 lg:grid-cols-[300px_minmax(0,1fr)] xl:grid-cols-[320px_minmax(0,1fr)]">
// //             {/* Sidebar */}
// //             <motion.aside
// //               initial={{ opacity: 0, x: -20 }}
// //               whileInView={{ opacity: 1, x: 0 }}
// //               viewport={{ once: true }}
// //               className="rounded-[26px] border border-[#DA2128]/10 bg-[#FAF7F2] p-5 shadow-[0_18px_44px_rgba(218,33,40,0.08)] lg:sticky lg:top-24 lg:h-fit"
// //             >
// //               <div className="mb-5 flex items-center justify-between border-b border-[#DA2128]/10 pb-3.5">
// //                 <div>
// //                   <p className="text-[0.7rem] font-semibold uppercase tracking-[0.22em] text-[#DB6400]">
// //                     Filter by
// //                   </p>
// //                   <h3 className="mt-1 text-xl font-bold text-stone-900" style={SERIF}>
// //                     Events Search
// //                   </h3>
// //                 </div>
// //                 <div className="rounded-xl bg-gradient-to-br from-[#FFE3DA] to-[#FFE7CF] p-2 text-[#DA2128]">
// //                   <FaSlidersH className="h-4 w-4" />
// //                 </div>
// //               </div>
// //               <div className="space-y-3.5">
// //                 <div className="space-y-1.5">
// //                   <label className="text-[0.8rem] font-bold text-stone-700">Keywords</label>
// //                   <div className="relative">
// //                     <FaSearch className="pointer-events-none absolute left-3.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-[#DA2128]" />
// //                     <input
// //                       type="text"
// //                       value={eventKeyword}
// //                       onChange={(e) => setEventKeyword(e.target.value)}
// //                       placeholder="Search by title, place..."
// //                       className="w-full rounded-xl border border-[#DA2128]/10 bg-white py-2.5 pl-10 pr-3.5 text-[0.8rem] font-medium text-stone-700 transition duration-300 placeholder:text-stone-400 hover:border-[#DA2128]/30 focus:border-[#DA2128] focus:outline-none focus:ring-2 focus:ring-[#DA2128]/10"
// //                     />
// //                   </div>
// //                 </div>
// //                 <div className="space-y-1.5">
// //                   <label className="text-[0.8rem] font-bold text-stone-700">Status</label>
// //                   <div className="flex gap-1.5 rounded-xl border border-[#DA2128]/10 bg-white p-1">
// //                     {[
// //                       ['all', 'All'],
// //                       ['forthcoming', 'Upcoming'],
// //                       ['past', 'Past'],
// //                     ].map(([v, l]) => (
// //                       <button
// //                         key={v}
// //                         type="button"
// //                         onClick={() => setEventTab(v)}
// //                         className={`flex-1 rounded-lg px-2 py-2 text-[0.75rem] font-bold transition duration-300 ${
// //                           eventTab === v
// //                             ? 'bg-gradient-to-r from-[#DA2128] to-[#F59C00] text-white shadow-md'
// //                             : 'text-stone-500 hover:bg-[#FAF7F2]'
// //                         }`}
// //                       >
// //                         {l}
// //                       </button>
// //                     ))}
// //                   </div>
// //                 </div>
// //                 {eventTags.length > 0 && (
// //                   <div className="space-y-1.5">
// //                     <label className="text-[0.8rem] font-bold text-stone-700">Category</label>
// //                     <div className="relative">
// //                       <FaTag className="pointer-events-none absolute left-3.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-[#DA2128]" />
// //                       <select
// //                         value={eventTag}
// //                         onChange={(e) => setEventTag(e.target.value)}
// //                         className="w-full appearance-none rounded-xl border border-[#DA2128]/10 bg-white py-2.5 pl-10 pr-9 text-[0.8rem] font-medium text-stone-700 transition duration-300 hover:border-[#DA2128]/30 focus:border-[#DA2128] focus:outline-none focus:ring-2 focus:ring-[#DA2128]/10"
// //                       >
// //                         <option value="">All categories</option>
// //                         {eventTags.map((t) => (
// //                           <option key={t} value={t}>
// //                             {t}
// //                           </option>
// //                         ))}
// //                       </select>
// //                     </div>
// //                   </div>
// //                 )}
// //                 {eventPlaces.length > 0 && (
// //                   <div className="space-y-1.5">
// //                     <label className="text-[0.8rem] font-bold text-stone-700">Location</label>
// //                     <div className="relative">
// //                       <FaMapMarkerAlt className="pointer-events-none absolute left-3.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-[#DA2128]" />
// //                       <select
// //                         value={eventPlace}
// //                         onChange={(e) => setEventPlace(e.target.value)}
// //                         className="w-full appearance-none rounded-xl border border-[#DA2128]/10 bg-white py-2.5 pl-10 pr-9 text-[0.8rem] font-medium text-stone-700 transition duration-300 hover:border-[#DA2128]/30 focus:border-[#DA2128] focus:outline-none focus:ring-2 focus:ring-[#DA2128]/10"
// //                       >
// //                         <option value="">All locations</option>
// //                         {eventPlaces.map((p) => (
// //                           <option key={p} value={p}>
// //                             {p}
// //                           </option>
// //                         ))}
// //                       </select>
// //                     </div>
// //                   </div>
// //                 )}
// //               </div>
// //               <button
// //                 type="button"
// //                 onClick={clearEventFilters}
// //                 className="mt-5 inline-flex w-full items-center justify-center gap-1.5 rounded-xl border border-[#DA2128]/20 bg-white px-4 py-2.5 text-[0.8rem] font-bold text-[#DA2128] transition duration-300 hover:bg-[#FEF7F4]"
// //               >
// //                 <FaTimes className="h-3.5 w-3.5" />
// //                 Clear filters
// //               </button>
// //             </motion.aside>
// //             {/* Main list */}
// //             <div>
// //               <div className="flex flex-wrap items-center justify-between gap-3 pb-5">
// //                 <span className="text-[12.5px] font-semibold text-stone-500">
// //                   {filteredEvents.length === 0
// //                     ? EVENTS.length === 0
// //                       ? 'No events published yet for this council'
// //                       : 'No events match your filters'
// //                     : `Showing ${Math.min(eventsVisible, filteredEvents.length)} of ${filteredEvents.length} event${
// //                         filteredEvents.length > 1 ? 's' : ''
// //                       }`}
// //                 </span>
// //               </div>
// //               <div key={eventAnimKey} className="grid gap-6">
// //                 {filteredEvents.length === 0 ? (
// //                   <div className="rounded-[24px] border border-dashed border-[#DA2128]/25 bg-[#FAF7F2] p-10 text-center">
// //                     <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-gradient-to-br from-[#DA2128] to-[#F59C00] text-white shadow-lg shadow-[#DA2128]/25">
// //                       <FaSearch className="h-6 w-6" />
// //                     </div>
// //                     <h4 className="mt-4 text-lg font-bold text-stone-900" style={SERIF}>
// //                       {EVENTS.length === 0 ? 'No engagements published yet' : 'No matching events found'}
// //                     </h4>
// //                     <p className="mx-auto mt-2 max-w-sm text-[13px] leading-relaxed text-stone-500">
// //                       {EVENTS.length === 0
// //                         ? "Check back soon for this council's upcoming and past engagements."
// //                         : 'Try clearing a filter or switching the status tab to see more initiatives.'}
// //                     </p>
// //                     {EVENTS.length > 0 && (
// //                       <button
// //                         type="button"
// //                         onClick={clearEventFilters}
// //                         className="mt-5 inline-flex items-center gap-1.5 rounded-full bg-gradient-to-r from-[#DA2128] to-[#F59C00] px-5 py-2.5 text-[12.5px] font-bold text-white shadow-lg shadow-[#DA2128]/25 transition hover:shadow-[#DA2128]/40"
// //                       >
// //                         Reset all filters
// //                       </button>
// //                     )}
// //                   </div>
// //                 ) : (
// //                   visibleEvents.map((event, i) => (
// //                     <StateEventCard key={`${event.title}-${eventAnimKey}-${i}`} event={event} index={i} />
// //                   ))
// //                 )}
// //               </div>
// //               {hasMoreEvents && (
// //                 <div className="mt-8 text-center">
// //                   <button
// //                     type="button"
// //                     onClick={loadMoreEvents}
// //                     className="inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-[#DA2128] to-[#F59C00] px-8 py-3 text-[13px] font-bold text-white shadow-lg shadow-[#DA2128]/30 transition-all hover:-translate-y-0.5 hover:shadow-[#DA2128]/45"
// //                   >
// //                     Load More Events
// //                   </button>
// //                 </div>
// //               )}
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* ==================== REPORTS (Publications) ==================== */}
// //       <section
// //         id="reports"
// //         className="relative overflow-hidden bg-gradient-to-b from-[#FEF7F4] via-[#FAF7F2] to-[#FEF7F4] py-16 lg:py-20"
// //       >
// //         <div className="pointer-events-none absolute -right-24 top-10 h-72 w-72 rounded-full bg-[#F59C00]/10 blur-3xl" />
// //         <div className="relative mx-auto max-w-7xl px-6 lg:px-12">
// //           <div className="mb-12 max-w-2xl">
// //             {sectionEyebrow('Reports & Knowledge Hub', '#DB6400')}
// //             <h2
// //               className="mt-3 text-2xl font-medium leading-[1.25] tracking-tight text-[#241A16] md:text-4xl"
// //               style={SERIF}
// //             >
// //               Publications &amp; Reports
// //             </h2>
// //             <p className="mt-4 text-base leading-relaxed text-[#241A16]/75 font-normal">
// //               Research, policy notes and sector reports prepared by the council to inform decisions and shape the
// //               state&apos;s growth agenda.
// //             </p>
// //           </div>
// //           {PUBLICATIONS.length > 0 ? (
// //             <div className="mt-6 grid gap-7 lg:grid-cols-3">
// //               {PUBLICATIONS.map((p, i) => (
// //                 <motion.article
// //                   key={p.title}
// //                   initial={{ opacity: 0, y: 20 }}
// //                   whileInView={{ opacity: 1, y: 0 }}
// //                   viewport={{ once: true }}
// //                   transition={{ delay: i * 0.08 }}
// //                   className="group relative flex h-full flex-col overflow-hidden rounded-3xl border border-stone-200 bg-white transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl hover:shadow-[#DA2128]/10"
// //                 >
// //                   <div className="relative h-36 overflow-hidden bg-gradient-to-br from-[#DA2128] via-[#DB2628] to-[#DB6400]">
// //                     <svg
// //                       className="absolute inset-0 h-full w-full text-white/20"
// //                       viewBox="0 0 400 160"
// //                       preserveAspectRatio="none"
// //                       aria-hidden="true"
// //                     >
// //                       <path d="M0 120 Q60 90 120 118 T240 116 T400 96 L400 160 L0 160Z" fill="currentColor" />
// //                       <path d="M0 138 Q80 112 160 136 T320 130 T400 124 L400 160 L0 160Z" fill="currentColor" opacity="0.6" />
// //                     </svg>
// //                     <div className="absolute left-6 top-5 flex flex-col gap-2">
// //                       <span className="w-max rounded-full bg-white/20 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.14em] text-white backdrop-blur">
// //                         {p.date}
// //                       </span>
// //                       <span className="w-max rounded-full bg-white px-3 py-1 text-[11px] font-bold text-[#DA2128]">
// //                         {p.partner}
// //                       </span>
// //                     </div>
// //                   </div>
// //                   <div className="flex flex-1 flex-col p-7">
// //                     <h3
// //                       className="text-[19px] font-bold leading-snug text-stone-900 transition-colors group-hover:text-[#DA2128]"
// //                       style={SERIF}
// //                     >
// //                       {p.title}
// //                     </h3>
// //                     <p className="mt-3 flex-1 text-[14px] leading-relaxed text-stone-600">{p.text}</p>
// //                     <div className="mt-6 flex items-center justify-between gap-3">
// //                       <button
// //                         type="button"
// //                         className="inline-flex items-center gap-2 rounded-full border border-[#DA2128]/25 bg-[#FEF7F4] px-5 py-2.5 text-[12.5px] font-bold text-[#DA2128] transition-all duration-300 hover:bg-[#DA2128] hover:text-white"
// //                       >
// //                         Download PDF
// //                         <FaDownload className="h-3.5 w-3.5" />
// //                       </button>
// //                       <span className="text-[11.5px] font-semibold uppercase tracking-wide text-stone-400">
// //                         {p.pages}
// //                       </span>
// //                     </div>
// //                   </div>
// //                 </motion.article>
// //               ))}
// //             </div>
// //           ) : (
// //             <div className="mt-6 flex flex-col items-center rounded-[24px] border border-dashed border-[#DA2128]/25 bg-white/60 py-16 text-center">
// //               <div className="grid h-16 w-16 place-items-center rounded-3xl bg-[#FEF7F4]">
// //                 <FaLightbulb className="h-7 w-7 text-[#DA2128]" />
// //               </div>
// //               <h4 className="mt-5 text-lg font-bold text-stone-900" style={SERIF}>
// //                 Publications coming soon
// //               </h4>
// //               <p className="mt-2 max-w-sm text-[13px] text-stone-500">
// //                 This council hasn&apos;t published a report yet. Check back soon, or explore other sections above.
// //               </p>
// //             </div>
// //           )}
// //         </div>
// //       </section>

// //       {/* ==================== PRESS RELEASES & COVERAGE ==================== */}
// //       <section id="press" className="relative scroll-mt-20 overflow-hidden bg-[#FAF7F2] py-16 lg:py-20">
// //         <div className="pointer-events-none absolute -left-24 bottom-0 h-72 w-72 rounded-full bg-[#DA2128]/10 blur-3xl" />
// //         <div className="relative mx-auto max-w-7xl px-6 lg:px-12">
// //           <div className="mb-10 max-w-2xl">
// //             {sectionEyebrow('Newsroom', '#DB6400')}
// //             <h2
// //               className="mt-3 text-2xl font-medium leading-[1.25] tracking-tight text-[#241A16] md:text-4xl"
// //               style={SERIF}
// //             >
// //               Press Release &amp; <span className="text-[#DA2128]">Press Coverage</span>
// //             </h2>
// //           </div>
// //           {/* Filter bar */}
// //           <motion.div
// //             initial={{ opacity: 0, y: 16 }}
// //             whileInView={{ opacity: 1, y: 0 }}
// //             viewport={{ once: true }}
// //             className="rounded-2xl border border-stone-200 bg-white p-4 shadow-[0_10px_40px_-24px_rgba(218,33,40,0.35)] sm:p-5"
// //           >
// //             <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
// //               {/* Type toggle */}
// //               <div className="inline-flex w-fit rounded-full bg-stone-100 p-1">
// //                 {[
// //                   { key: 'releases', label: 'Press Releases', count: PRESS_RELEASES.length },
// //                   { key: 'coverage', label: 'Press Coverage', count: PRESS_COVERAGE.length },
// //                 ].map((t) => (
// //                   <button
// //                     key={t.key}
// //                     type="button"
// //                     onClick={() => setPressTab(t.key)}
// //                     className={`relative rounded-full px-5 py-2.5 text-[12.5px] font-bold uppercase tracking-[0.06em] transition-all duration-300 ${
// //                       pressTab === t.key
// //                         ? 'bg-white text-[#DA2128] shadow-md'
// //                         : 'text-stone-500 hover:text-stone-700'
// //                     }`}
// //                   >
// //                     {t.label}
// //                     <span
// //                       className={`ml-2 rounded-full px-2 py-0.5 text-[10px] ${
// //                         pressTab === t.key ? 'bg-[#DA2128]/10 text-[#DA2128]' : 'bg-stone-200 text-stone-500'
// //                       }`}
// //                     >
// //                       {t.count}
// //                     </span>
// //                   </button>
// //                 ))}
// //               </div>
// //               {/* Keyword + sort */}
// //               <div className="flex flex-1 flex-col gap-3 sm:flex-row sm:items-center lg:max-w-xl">
// //                 <div className="relative flex-1">
// //                   <FaSearch
// //                     className="pointer-events-none absolute left-3.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-[#DA2128]"
// //                   />
// //                   <input
// //                     type="text"
// //                     value={pressKeyword}
// //                     onChange={(e) => setPressKeyword(e.target.value)}
// //                     placeholder="Search press releases & coverage..."
// //                     className="w-full rounded-xl border border-stone-200 bg-[#FAF7F2] py-2.5 pl-10 pr-3.5 text-[13px] font-medium text-stone-700 transition duration-300 placeholder:text-stone-400 hover:border-[#DA2128]/30 focus:border-[#DA2128] focus:bg-white focus:outline-none focus:ring-2 focus:ring-[#DA2128]/10"
// //                   />
// //                 </div>
// //                 <div className="flex shrink-0 items-center gap-2">
// //                   <div className="flex overflow-hidden rounded-xl text-[11.5px] font-bold ring-1 ring-stone-200">
// //                     {[
// //                       ['newest', 'Newest'],
// //                       ['oldest', 'Oldest'],
// //                     ].map(([v, l]) => (
// //                       <button
// //                         key={v}
// //                         type="button"
// //                         onClick={() => setPressSort(v)}
// //                         className={`px-3.5 py-2.5 transition-colors ${
// //                           pressSort === v
// //                             ? 'bg-gradient-to-r from-[#DA2128] to-[#DB6400] text-white'
// //                             : 'bg-white text-stone-500 hover:text-[#DA2128]'
// //                         }`}
// //                       >
// //                         {l}
// //                       </button>
// //                     ))}
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </motion.div>
// //           {/* Results */}
// //           <div ref={pressResultsRef} className="mt-10 scroll-mt-32">
// //             <div className="flex flex-wrap items-center justify-between gap-3 border-b-2 border-stone-900/90 pb-4">
// //               <h3 className="flex items-center gap-2.5 text-xl font-bold text-stone-900 sm:text-2xl" style={SERIF}>
// //                 {pressTab === 'releases' ? 'Press Releases' : 'Press Coverage'}
// //                 <button
// //                   type="button"
// //                   title="Subscribe via RSS"
// //                   className="text-[#DA2128] transition-colors hover:text-[#DB6400]"
// //                   onClick={(e) => e.preventDefault()}
// //                 >
// //                   <FaRss className="h-4 w-4" />
// //                 </button>
// //               </h3>
// //               <span className="text-[12.5px] font-semibold text-stone-400">
// //                 {pressFiltered.length === 0
// //                   ? 'No matching results'
// //                   : `Showing ${pressStart + 1}–${Math.min(
// //                       pressStart + PRESS_PAGE_SIZE,
// //                       pressFiltered.length
// //                     )} of ${pressFiltered.length}`}
// //               </span>
// //             </div>
// //             {pressPageItems.length > 0 ? (
// //               pressPageItems.map((item, i) => (
// //                 <motion.article
// //                   key={`${pressTab}-${item.title}-${i}`}
// //                   layout
// //                   initial={{ opacity: 0, y: 18 }}
// //                   whileInView={{ opacity: 1, y: 0 }}
// //                   viewport={{ once: true }}
// //                   transition={{ duration: 0.35, delay: i * 0.05 }}
// //                   className="group flex flex-col gap-4 border-b border-stone-200 py-6 sm:flex-row sm:items-center sm:justify-between"
// //                 >
// //                   <div className="min-w-0 flex-1">
// //                     <div className="flex flex-wrap items-center gap-2.5">
// //                       <span className="inline-flex items-center gap-1.5 rounded-full bg-[#FEF7F4] px-2.5 py-1 text-[10.5px] font-extrabold uppercase tracking-[0.14em] text-[#DA2128]">
// //                         <FaCalendarAlt className="h-3 w-3" />
// //                         {item.date}
// //                       </span>
// //                       <span className="inline-flex rounded-full border border-stone-200 px-2.5 py-1 text-[10.5px] font-bold uppercase tracking-[0.1em] text-stone-500">
// //                         {pressTab === 'releases' ? 'Release' : 'Coverage'}
// //                       </span>
// //                     </div>
// //                     <h4
// //                       className="mt-3 text-[17px] font-bold leading-snug text-stone-900 transition-colors group-hover:text-[#DA2128] sm:text-[18px]"
// //                       style={SERIF}
// //                     >
// //                       {item.title}
// //                     </h4>
// //                     <p className="mt-2 text-[13.5px] leading-relaxed text-stone-600">{item.excerpt}</p>
// //                   </div>
// //                   <a
// //                     href="#"
// //                     className="inline-flex shrink-0 items-center gap-1.5 self-start rounded-full border border-[#DA2128]/25 px-4 py-2 text-[12.5px] font-bold text-[#DA2128] transition-all duration-300 hover:bg-[#DA2128] hover:text-white sm:self-center"
// //                   >
// //                     Read more
// //                   </a>
// //                 </motion.article>
// //               ))
// //             ) : (
// //               <div className="flex flex-col items-center py-16 text-center">
// //                 <div className="grid h-16 w-16 place-items-center rounded-3xl bg-[#FEF7F4]">
// //                   <FaSearch className="h-7 w-7 text-[#DA2128]" />
// //                 </div>
// //                 <h4 className="mt-5 text-lg font-bold text-stone-900" style={SERIF}>
// //                   {pressSource.length === 0 ? 'Nothing published yet' : 'No results found'}
// //                 </h4>
// //                 <p className="mt-2 max-w-sm text-[13px] text-stone-500">
// //                   {pressSource.length === 0
// //                     ? "This council hasn't shared a press release or coverage item yet."
// //                     : 'Nothing matches your search. Try a different keyword or clear it to see everything.'}
// //                 </p>
// //                 {pressKeyword && (
// //                   <button
// //                     type="button"
// //                     onClick={() => setPressKeyword('')}
// //                     className="mt-5 rounded-full bg-gradient-to-r from-[#DA2128] to-[#DB6400] px-6 py-2.5 text-[12.5px] font-bold text-white shadow-lg shadow-[#DA2128]/25 transition-all hover:shadow-[#DA2128]/40"
// //                   >
// //                     Clear search
// //                   </button>
// //                 )}
// //               </div>
// //             )}
// //             {/* Pagination */}
// //             {pressTotalPages > 1 && (
// //               <div className="mt-10 flex items-center justify-center gap-2">
// //                 <button
// //                   disabled={pressClampedPage === 1}
// //                   onClick={() => changePressPage(pressClampedPage - 1)}
// //                   className="grid h-10 w-10 place-items-center rounded-xl text-stone-500 ring-1 ring-stone-200 transition-all hover:text-[#DA2128] hover:ring-[#DA2128] disabled:pointer-events-none disabled:opacity-35"
// //                   aria-label="Previous page"
// //                 >
// //                   <FaChevronLeft className="h-4 w-4" />
// //                 </button>
// //                 {Array.from({ length: pressTotalPages }, (_, i) => i + 1).map((n) => (
// //                   <button
// //                     key={n}
// //                     onClick={() => changePressPage(n)}
// //                     className={`relative h-10 w-10 rounded-xl text-[13px] font-extrabold transition-all ${
// //                       n === pressClampedPage
// //                         ? 'text-white'
// //                         : 'text-stone-500 ring-1 ring-stone-200 hover:text-[#DA2128] hover:ring-[#DA2128]'
// //                     }`}
// //                   >
// //                     {n === pressClampedPage && (
// //                       <motion.span
// //                         layoutId="press-page-pill"
// //                         className="absolute inset-0 rounded-xl bg-gradient-to-br from-[#DA2128] to-[#DB6400] shadow-lg shadow-[#DA2128]/30"
// //                         transition={{ type: 'spring', stiffness: 420, damping: 32 }}
// //                       />
// //                     )}
// //                     <span className="relative">{n}</span>
// //                   </button>
// //                 ))}
// //                 <button
// //                   disabled={pressClampedPage === pressTotalPages}
// //                   onClick={() => changePressPage(pressClampedPage + 1)}
// //                   className="grid h-10 w-10 place-items-center rounded-xl text-stone-500 ring-1 ring-stone-200 transition-all hover:text-[#DA2128] hover:ring-[#DA2128] disabled:pointer-events-none disabled:opacity-35"
// //                   aria-label="Next page"
// //                 >
// //                   <FaChevronRight className="h-4 w-4" />
// //                 </button>
// //               </div>
// //             )}
// //           </div>
// //         </div>
// //       </section>

// //       {/* ==================== CONTACT US ==================== */}
// //       <section id="contact" className="relative scroll-mt-20 overflow-hidden bg-gradient-to-b from-[#FAF7F2] to-[#FFFBF7] py-16 lg:py-20">
// //         <div className="pointer-events-none absolute -right-24 top-10 h-72 w-72 rounded-full bg-[#F59C00]/10 blur-3xl" />
// //         <div className="relative mx-auto max-w-7xl px-6 lg:px-12">
// //           <div className="grid gap-10 lg:grid-cols-2">
// //             {/* Left - Contact info */}
// //             <div>
// //               <motion.div
// //                 initial={{ opacity: 0, y: 20 }}
// //                 whileInView={{ opacity: 1, y: 0 }}
// //                 viewport={{ once: true }}
// //                 className="mb-3 inline-flex items-center gap-2"
// //               >
// //                 <div className="h-[2px] w-6 rounded-full bg-[#DA2128]" />
// //                 <span className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#DA2128]">
// //                   Contact
// //                 </span>
// //               </motion.div>
// //               <motion.h2
// //                 initial={{ opacity: 0, y: 20 }}
// //                 whileInView={{ opacity: 1, y: 0 }}
// //                 viewport={{ once: true }}
// //                 transition={{ delay: 0.1 }}
// //                 className="mb-3 text-3xl font-bold leading-[1.1] tracking-tight sm:text-4xl text-stone-900"
// //                 style={SERIF}
// //               >
// //                 Contact <span className="text-[#DA2128]">Us</span>
// //               </motion.h2>
// //               <p className="mb-6 text-base leading-relaxed text-[#241A16]/75 font-normal">
// //                 For queries related to the {name}, reach out to the secretariat. Our team will respond within 48
// //                 hours.
// //               </p>

// //               {/* ---------- ASSOCHAM HoD / Nodal Officer card (state-wise) ---------- */}
// //               {/* <motion.div
// //                 initial={{ opacity: 0, y: 18 }}
// //                 whileInView={{ opacity: 1, y: 0 }}
// //                 viewport={{ once: true }}
// //                 transition={{ delay: 0.15 }}
// //                 className="mb-8 overflow-hidden rounded-2xl border border-[#DA2128]/15 bg-white shadow-[0_18px_44px_-28px_rgba(218,33,40,0.55)]"
// //               >
// //                 <div className="flex items-center justify-between gap-3 border-b border-[#DA2128]/10 bg-gradient-to-r from-[#FEF7F4] to-[#FFF7EC] px-5 py-3">
// //                   <p className="text-[10.5px] font-extrabold uppercase tracking-[0.22em] text-[#DA2128]">
// //                     {hasNamedHod ? 'ASSOCHAM  Head of Department' : 'Council Secretariat'}
// //                   </p>
// //                   <span className="rounded-full bg-white px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-[#DB6400] ring-1 ring-[#DB6400]/20">
// //                     {stateLabel}
// //                   </span>
// //                 </div>

// //                 <div className="flex flex-col gap-4 p-5 sm:flex-row sm:items-start">
// //                   <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-[#DA2128] to-[#F59C00] text-white shadow-lg shadow-[#DA2128]/25">
// //                     <FaUserTie className="h-5 w-5" />
// //                   </div>

// //                   <div className="min-w-0 flex-1">
// //                     <h3 className="text-[19px] font-bold leading-tight text-stone-900" style={SERIF}>
// //                       {hod?.name || defaultHod.name}
// //                     </h3>
// //                     <p className="mt-0.5 text-[12.5px] font-semibold text-stone-500">
// //                       {hod?.title || `Nodal Officer — ${name}`}
// //                     </p>

// //                     <div className="mt-4 grid gap-2.5">
                      
// //                       <a
// //                         href={mapsUrl(office)}
// //                         target="_blank"
// //                         rel="noopener noreferrer"
// //                         className="group/addr flex items-start gap-3 rounded-xl border border-stone-200 bg-[#FAF7F2] px-3.5 py-2.5 transition-all duration-300 hover:border-[#DA2128]/30 hover:bg-white"
// //                       >
// //                         <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-[#DA2128]/10 text-[#DA2128] transition-colors group-hover/addr:bg-[#DA2128] group-hover/addr:text-white">
// //                           <FaRegBuilding className="h-3.5 w-3.5" />
// //                         </span>
// //                         <span className="min-w-0">
// //                           <span className="block text-[10px] font-bold uppercase tracking-[0.16em] text-stone-400">
// //                             {office.city ? `Office — ${office.city}` : 'Office'}
// //                           </span>
// //                           <span className="block text-[13px] font-semibold leading-relaxed text-stone-800 transition-colors group-hover/addr:text-[#DA2128]">
// //                             {office.lines.map((line, i) => (
// //                               <span key={i} className="block">
// //                                 {line}
// //                               </span>
// //                             ))}
// //                           </span>
// //                         </span>
// //                       </a>

                    
// //                       <a
// //                         href={`mailto:${hodEmail}?subject=${encodeURIComponent(
// //                           `Query — ${name}`
// //                         )}`}
// //                         className="group flex items-center gap-3 rounded-xl border border-stone-200 bg-[#FAF7F2] px-3.5 py-2.5 transition-all duration-300 hover:border-[#DA2128]/30 hover:bg-white"
// //                       >
// //                         <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-[#DA2128]/10 text-[#DA2128] transition-colors group-hover:bg-[#DA2128] group-hover:text-white">
// //                           <FaEnvelope className="h-3.5 w-3.5" />
// //                         </span>
// //                         <span className="min-w-0">
// //                           <span className="block text-[10px] font-bold uppercase tracking-[0.16em] text-stone-400">
// //                             Email
// //                           </span>
// //                           <span className="block truncate text-[13.5px] font-semibold text-stone-800 transition-colors group-hover:text-[#DA2128]">
// //                             {hodEmail}
// //                           </span>
// //                         </span>
// //                       </a>

                      
// //                       <a
// //                         href={`tel:${hodPhoneHref}`}
// //                         className="group flex items-center gap-3 rounded-xl border border-stone-200 bg-[#FAF7F2] px-3.5 py-2.5 transition-all duration-300 hover:border-[#DA2128]/30 hover:bg-white"
// //                       >
// //                         <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-[#DA2128]/10 text-[#DA2128] transition-colors group-hover:bg-[#DA2128] group-hover:text-white">
// //                           <FaPhone className="h-3.5 w-3.5" />
// //                         </span>
// //                         <span className="min-w-0">
// //                           <span className="block text-[10px] font-bold uppercase tracking-[0.16em] text-stone-400">
// //                             Mobile
// //                           </span>
// //                           <span className="block truncate text-[13.5px] font-semibold text-stone-800 transition-colors group-hover:text-[#DA2128]">
// //                             {hod?.phone || defaultHod.phone}
// //                           </span>
// //                         </span>
// //                       </a>
// //                     </div>

                
// //                     <div className="mt-4 flex flex-wrap gap-2">
// //                       <a
// //                         href={`mailto:${hodEmail}?subject=${encodeURIComponent(`Query — ${name}`)}`}
// //                         className="inline-flex items-center gap-1.5 rounded-full bg-gradient-to-r from-[#DA2128] to-[#F59C00] px-4 py-2 text-[12px] font-bold text-white shadow-md shadow-[#DA2128]/25 transition-all hover:-translate-y-0.5 hover:shadow-[#DA2128]/40"
// //                       >
// //                         <FaEnvelope className="h-3 w-3" />
// //                         Email HoD
// //                       </a>
// //                       <a
// //                         href={`tel:${hodPhoneHref}`}
// //                         className="inline-flex items-center gap-1.5 rounded-full border border-[#DA2128]/25 bg-white px-4 py-2 text-[12px] font-bold text-[#DA2128] transition-all hover:bg-[#FEF7F4]"
// //                       >
// //                         <FaPhone className="h-3 w-3" />
// //                         Call
// //                       </a>
// //                       {hodWaNumber && hasNamedHod && (
// //                         <a
// //                           href={`https://wa.me/${hodWaNumber}`}
// //                           target="_blank"
// //                           rel="noopener noreferrer"
// //                           className="inline-flex items-center gap-1.5 rounded-full border border-emerald-500/30 bg-emerald-50 px-4 py-2 text-[12px] font-bold text-emerald-700 transition-all hover:bg-emerald-100"
// //                         >
// //                           <FaWhatsapp className="h-3.5 w-3.5" />
// //                           WhatsApp
// //                         </a>
// //                       )}
// //                       <a
// //                         href={mapsUrl(office)}
// //                         target="_blank"
// //                         rel="noopener noreferrer"
// //                         className="inline-flex items-center gap-1.5 rounded-full border border-stone-300 bg-white px-4 py-2 text-[12px] font-bold text-stone-600 transition-all hover:border-[#DB6400]/40 hover:text-[#DB6400]"
// //                       >
// //                         <FaDirections className="h-3.5 w-3.5" />
// //                         Directions
// //                       </a>
// //                     </div>
// //                   </div>
// //                 </div>
// //               </motion.div> */}

// //               <motion.div
// //   initial={{ opacity: 0, y: 18 }}
// //   whileInView={{ opacity: 1, y: 0 }}
// //   viewport={{ once: true }}
// //   transition={{ delay: 0.15 }}
// //   className="w-full max-w-md rounded-2xl border border-stone-100 bg-white p-5 shadow-sm font-sans"
// // >
// //   <div className="space-y-5">
    
// //     {/* 1. Council / HoD Name */}
// //     <div className="flex items-start gap-3.5">
// //       <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#FDF2F2] text-sm font-bold text-[#C0262D]">
// //         {(hod?.name || defaultHod?.name || 'H').charAt(0).toUpperCase()}
// //       </div>
// //       <div className="min-w-0 flex-1">
// //         <h4 className="text-[14px] font-extrabold text-stone-900 leading-snug">
// //           {hasNamedHod ? 'ASSOCHAM State Head' : 'Council Secretariat'}
// //         </h4>
// //         <p className="text-[14px] font-bold text-[#C0262D]">
// //           {hod?.name || defaultHod.name}
// //         </p>
// //         <p className="text-[12px] text-stone-500">
// //           {hod?.title || `Nodal Officer — ${name}`}
// //         </p>
// //       </div>
// //     </div>

// //     {/* 2. Address Block */}
// //     <div className="flex items-start gap-3.5">
// //       <a
// //         href={mapsUrl(office)}
// //         target="_blank"
// //         rel="noopener noreferrer"
// //         className="group flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#FDF2F2] text-[#C0262D] transition-colors hover:bg-[#C0262D] hover:text-white"
// //       >
// //         <FaRegBuilding className="h-4 w-4" />
// //       </a>
// //       <div className="min-w-0 flex-1">
// //         <h4 className="text-[14px] font-extrabold text-stone-900 leading-snug">
// //           {office.city ? `Address (${office.city})` : 'Address'}
// //         </h4>
// //         <div className="text-[12.5px] leading-relaxed text-stone-600">
// //           {office.lines.map((line, i) => (
// //             <span key={i} className="block">
// //               {line}
// //             </span>
// //           ))}
// //         </div>
// //       </div>
// //     </div>

// //     {/* 3. Email Block */}
// //     <div className="flex items-start gap-3.5">
// //       <a
// //         href={`mailto:${hodEmail}?subject=${encodeURIComponent(`Query — ${name}`)}`}
// //         className="group flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#FDF2F2] text-[#C0262D] transition-colors hover:bg-[#C0262D] hover:text-white"
// //       >
// //         <FaEnvelope className="h-4 w-4" />
// //       </a>
// //       <div className="min-w-0 flex-1">
// //         <h4 className="text-[14px] font-extrabold text-stone-900 leading-snug">
// //           Email
// //         </h4>
// //         <a
// //           href={`mailto:${hodEmail}?subject=${encodeURIComponent(`Query — ${name}`)}`}
// //           className="block truncate text-[13px] font-bold text-[#C0262D] hover:underline"
// //         >
// //           {hodEmail}
// //         </a>
// //         <p className="text-[11.5px] text-stone-500">
// //           For queries related to {stateLabel || 'Council'}.
// //         </p>
// //       </div>
// //     </div>

// //     {/* 4. Phone Block */}
// //     <div className="flex items-start gap-3.5">
// //       <a
// //         href={`tel:${hodPhoneHref}`}
// //         className="group flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#FDF2F2] text-[#C0262D] transition-colors hover:bg-[#C0262D] hover:text-white"
// //       >
// //         <FaPhone className="h-4 w-4" />
// //       </a>
// //       <div className="min-w-0 flex-1">
// //         <h4 className="text-[14px] font-extrabold text-stone-900 leading-snug">
// //           Phone Number
// //         </h4>
// //         <a
// //           href={`tel:${hodPhoneHref}`}
// //           className="block text-[13px] font-bold text-[#C0262D] hover:underline"
// //         >
// //           {hod?.phone || defaultHod.phone}
// //         </a>
// //         <p className="text-[11.5px] text-stone-500">
// //           Mon–Fri, 9:30 AM – 6:00 PM IST
// //         </p>
// //       </div>
// //     </div>

// //     {/* WhatsApp optional action */}
// //     {hodWaNumber && hasNamedHod && (
// //       <div className="pt-1 pl-[50px]">
// //         <a
// //           href={`https://wa.me/${hodWaNumber}`}
// //           target="_blank"
// //           rel="noopener noreferrer"
// //           className="inline-flex items-center gap-1.5 text-[12px] font-bold text-emerald-600 hover:underline"
// //         >
// //           <FaWhatsapp className="h-3.5 w-3.5" /> WhatsApp
// //         </a>
// //       </div>
// //     )}

// //   </div>
// // </motion.div>

// //             </div>

// //             {/* Right - Contact form */}
// //             {/* self-center + h-fit => card sirf apne content jitna tall rahega
// //                 (grid ki default stretch height nahi lega) aur vertically
// //                 left column ke center me align hoga. */}
// //             {/* <motion.div
// //               initial={{ opacity: 0, x: 30 }}
// //               whileInView={{ opacity: 1, x: 0 }}
// //               viewport={{ once: true }}
// //               className="h-fit self-center rounded-2xl bg-white p-6 shadow-xl border border-stone-200"
// //             >
// //               {submitted ? (
// //                 <div className="flex flex-col items-center justify-center py-10 text-center">
// //                   <div className="mb-3 flex h-16 w-16 items-center justify-center rounded-full bg-green-100">
// //                     <FaCheckCircle className="h-8 w-8 text-green-500" />
// //                   </div>
// //                   <h3 className="mb-1 text-xl font-bold text-stone-900" style={SERIF}>
// //                     Query Submitted!
// //                   </h3>
// //                   <p className="text-sm text-gray-500">
// //                     {hasNamedHod ? `${hod.name} ` : 'Our team '}
// //                     will respond within 48 hours.
// //                   </p>
// //                 </div>
// //               ) : (
// //                 <form onSubmit={handleSubmit} className="space-y-3">
// //                   <h3 className="text-xl font-bold text-stone-900" style={SERIF}>
// //                     Send us a <span className="text-[#DA2128]">Message</span>
// //                   </h3>
// //                   <p className="text-[12px] text-stone-500">
// //                     This query goes to{' '}
// //                     <span className="font-semibold text-stone-700">
// //                       {hod?.name || defaultHod.name}
// //                     </span>
// //                     , {stateLabel} council desk.
// //                   </p>
// //                   <div className="grid gap-3 sm:grid-cols-2">
// //                     <input
// //                       type="text"
// //                       placeholder="Full Name"
// //                       required
// //                       className="w-full rounded-lg border border-gray-200 px-3 py-2.5 text-xs transition-all focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-100"
// //                     />
// //                     <input
// //                       type="email"
// //                       placeholder="Email"
// //                       required
// //                       className="w-full rounded-lg border border-gray-200 px-3 py-2.5 text-xs transition-all focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-100"
// //                     />
// //                   </div>
// //                   <input
// //                     type="text"
// //                     placeholder="Organization"
// //                     className="w-full rounded-lg border border-gray-200 px-3 py-2.5 text-xs transition-all focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-100"
// //                   />
// //                   <select
// //                     required
// //                     defaultValue=""
// //                     className="w-full rounded-lg border border-gray-200 px-3 py-2.5 text-xs transition-all focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-100"
// //                   >
// //                     <option value="">Select a category</option>
// //                     <option>Policy &amp; Schemes</option>
// //                     <option>Investment Opportunities</option>
// //                     <option>Regulatory Compliance</option>
// //                     <option>Technology &amp; Innovation</option>
// //                     <option>Market Access</option>
// //                     <option>Other</option>
// //                   </select>
// //                   <textarea
// //                     rows={4}
// //                     placeholder="Describe your query..."
// //                     required
// //                     className="w-full rounded-lg border border-gray-200 px-3 py-2.5 text-xs transition-all focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-100"
// //                   />
// //                   <motion.button
// //                     whileHover={{ scale: 1.02 }}
// //                     whileTap={{ scale: 0.98 }}
// //                     type="submit"
// //                     className="flex w-full items-center justify-center gap-2 rounded-lg py-3 text-xs font-bold text-white shadow-lg"
// //                     style={{ background: 'linear-gradient(135deg, #DA2128, #F59C00)' }}
// //                   >
// //                     <FaPaperPlane className="h-3.5 w-3.5" />
// //                     Submit Query
// //                   </motion.button>
// //                 </form>
// //               )}
// //             </motion.div> */}
// //             <QueryForm />
// //           </div>
// //         </div>
// //       </section>
// //     </main>
// //   );
// // }

// // /* ========================== EVENT CALENDAR BADGE ========================== */
// // function StateCalendarBadge({ date, active }) {
// //   const { dayPart, monthPart, year } = getDateParts(date);
// //   return (
// //     <div className="relative mx-auto flex w-[88px] shrink-0 flex-col overflow-hidden rounded-[18px] border border-white/80 bg-white shadow-[0_10px_28px_rgba(219,38,40,0.12)] transition-all duration-500 group-hover:-translate-y-1.5 group-hover:rotate-[-1deg] group-hover:shadow-[0_18px_40px_rgba(219,38,40,0.18)] sm:mx-0">
// //       <div className="absolute left-3 top-0 h-2.5 w-2.5 -translate-y-1/2 rounded-full border border-[#DA2128]/30 bg-[#FEF7F4] transition duration-500 group-hover:bg-[#F59C00]" />
// //       <div className="absolute right-3 top-0 h-2.5 w-2.5 -translate-y-1/2 rounded-full border border-[#DA2128]/30 bg-[#FEF7F4] transition duration-500 group-hover:bg-[#F59C00]" />
// //       <div className="relative bg-gradient-to-br from-white to-[#FAF7F2] px-2.5 py-3 text-center">
// //         <div className="font-heading text-[1.55rem] font-black leading-none text-stone-900" style={SERIF}>
// //           {dayPart}
// //         </div>
// //         <div className="mt-1.5 text-[0.65rem] font-extrabold uppercase tracking-[0.22em] text-[#DB6400]">
// //           {monthPart}
// //         </div>
// //       </div>
// //       <div
// //         className={`relative px-2.5 py-2 text-center text-[0.7rem] font-extrabold tracking-[0.18em] text-white ${
// //           active ? 'bg-gradient-to-r from-[#DA2128] to-[#F59C00]' : 'bg-gradient-to-r from-stone-500 to-stone-600'
// //         }`}
// //       >
// //         <span className="relative z-10">{year}</span>
// //       </div>
// //     </div>
// //   );
// // }

// // /* ========================== EVENT CARD ========================== */
// // function StateEventCard({ event, index }) {
// //   const active = isEventUpcoming(event.date);
// //   const delay = `${Math.min(index * 70, 600)}ms`;
// //   return (
// //     <article
// //       style={{ animationDelay: delay }}
// //       className="event-fade-up group relative overflow-hidden rounded-[24px] border border-[#DA2128]/10 bg-white p-4 shadow-[0_12px_32px_rgba(218,33,40,0.07)] transition-all duration-500 hover:-translate-y-1.5 hover:border-[#DA2128]/25 hover:shadow-[0_20px_48px_rgba(218,33,40,0.14)] sm:p-5"
// //     >
// //       <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(245,156,0,0.12),transparent_32%),radial-gradient(circle_at_bottom_left,rgba(218,33,40,0.1),transparent_35%)] opacity-80 transition-opacity duration-500 group-hover:opacity-100" />
// //       <div className="relative flex flex-col gap-4 sm:flex-row sm:items-start">
// //         <StateCalendarBadge date={event.date} active={active} />
// //         <div className="min-w-0 flex-1 space-y-3">
// //           <div className="flex flex-wrap items-center gap-2">
// //             <span className="inline-flex rounded-full bg-[#FAF7F2] px-2.5 py-1 text-[0.65rem] font-extrabold uppercase tracking-[0.18em] text-[#DA2128] transition duration-300 group-hover:scale-105">
// //               {event.tag || 'Event'}
// //             </span>
// //             {event.place && (
// //               <span className="inline-flex rounded-full border border-[#DB6400]/25 bg-[#FEF7F4] px-2.5 py-1 text-[0.7rem] font-bold text-[#DB6400] transition duration-300 group-hover:-translate-y-0.5">
// //                 {event.place}
// //               </span>
// //             )}
// //             {active ? (
// //               <span className="event-live-pill inline-flex items-center gap-1.5 rounded-full bg-[#FFF0EC] px-2.5 py-1 text-[0.65rem] font-extrabold uppercase tracking-[0.18em] text-[#DA2128]">
// //                 <span className="relative flex h-2 w-2">
// //                   <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#DA2128] opacity-75" />
// //                   <span className="relative inline-flex h-2 w-2 rounded-full bg-[#DA2128]" />
// //                 </span>
// //                 Upcoming
// //               </span>
// //             ) : (
// //               <span className="inline-flex items-center gap-1.5 rounded-full border border-stone-300 bg-stone-50 px-2.5 py-1 text-[0.65rem] font-extrabold uppercase tracking-[0.18em] text-stone-500">
// //                 Archived
// //               </span>
// //             )}
// //           </div>
// //           <h3
// //             className="text-[1.05rem] font-extrabold leading-snug text-stone-900 transition-all duration-500 group-hover:translate-x-0.5 group-hover:text-[#DA2128] sm:text-[1.15rem]"
// //             style={SERIF}
// //           >
// //             {event.title}
// //           </h3>
// //           <p className="text-[13.5px] leading-relaxed text-stone-600">{event.text}</p>
// //           {event.highlight && (
// //             <div className="flex items-start gap-3 rounded-2xl bg-[#FAF7F2] p-3.5">
// //               <FaCheck className="mt-0.5 h-4 w-4 shrink-0 text-[#DA2128]" />
// //               <p className="text-[13px] font-medium leading-relaxed text-stone-700">{event.highlight}</p>
// //             </div>
// //           )}
// //           <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
// //             <div className="flex items-center gap-2.5 rounded-full bg-[#FFFDFC] px-3 py-1.5 text-[0.8rem] font-semibold text-stone-600 shadow-sm transition duration-300 group-hover:shadow-md">
// //               <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-gradient-to-br from-[#DA2128] to-[#F59C00] text-white shadow-[0_6px_14px_rgba(218,33,40,0.22)]">
// //                 <FaCalendarAlt className="h-3.5 w-3.5" />
// //               </span>
// //               <span>{event.date}</span>
// //             </div>
// //             <button
// //               type="button"
// //               className="inline-flex w-fit items-center gap-1.5 rounded-full bg-gradient-to-r from-[#DA2128] to-[#F59C00] px-4 py-2 text-[0.8rem] font-bold text-white shadow-[0_10px_22px_rgba(218,33,40,0.22)] transition-all duration-300 hover:scale-[1.03] hover:shadow-[0_14px_28px_rgba(218,33,40,0.3)] active:scale-[0.98]"
// //             >
// //               {active ? 'Register Interest' : 'View Highlights'}
// //             </button>
// //           </div>
// //         </div>
// //       </div>
// //     </article>
// //   );
// // }





// // new new code 




// import { motion } from 'framer-motion';
// import { getRegionBySlug } from './regionApi';
// import { useEffect, useMemo, useRef, useState } from 'react';
// import { Link, useLocation, useParams } from 'react-router-dom';
// import {
//   FaAward,
//   FaBolt,
//   FaBuilding,
//   FaCalendarAlt,
//   FaCertificate,
//   FaChartLine,
//   FaCheck,
//   FaCheckCircle,
//   FaChevronLeft,
//   FaChevronRight,
//   FaDownload,
//   FaEnvelope,
//   FaExchangeAlt,
//   FaFileSignature,
//   FaGlobeAsia,
//   FaHandshake,
//   FaHome,
//   FaIndustry,
//   FaLandmark,
//   FaLaptopCode,
//   FaLightbulb,
//   FaMapMarkerAlt,
//   FaMoneyBillWave,
//   FaPaperPlane,
//   FaPeopleArrows,
//   FaPhone,
//   FaPills,
//   FaRocket,
//   FaRss,
//   FaSearch,
//   FaSeedling,
//   FaSlidersH,
//   FaTag,
//   FaTimes,
//   FaUniversity,
//   FaUserTie,
//   FaWhatsapp,
//   FaDirections,
//   FaRegBuilding,
//   FaArrowUp,
// } from 'react-icons/fa';
// import {
//   statesData,
//   stateNames,
//   defaultOverview,
//   defaultInitiatives,
//   defaultPriorities,
//   getStateHod,
//   defaultHod,
//   getStateOffice,
//   defaultOffice,
// } from './statesData';
// import CouncilLeadership from './CouncilLeadership.jsx';
// import QueryForm from '../components/Sectors/QueryForm.jsx';

// const heroImage =
//   'https://images.pexels.com/photos/17585996/pexels-photo-17585996.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200';
// const overviewDefaultImg =
//   'https://images.pexels.com/photos/3183197/pexels-photo-3183197.jpeg?auto=compress&cs=tinysrgb&w=1200';

// // ---- Design constants — same for every state, sirf content data-driven hai ----
// const mandates = [
//   {
//     title: 'Policy Advocacy',
//     text: 'Public policy, regulatory reforms and Ease of Doing Business inputs with Central and State Governments.',
//     icon: FaLandmark,
//   },
//   {
//     title: 'Industry Competitiveness',
//     text: 'Focused support for manufacturing, MSMEs, infrastructure, green growth and business competitiveness.',
//     icon: FaChartLine,
//   },
//   {
//     title: 'Stakeholder Platform',
//     text: 'Conferences, seminars, business forums and government-industry interactions across the state.',
//     icon: FaPeopleArrows,
//   },
// ];

// const services = [
//   { label: 'Investment facilitation', icon: FaBuilding },
//   { label: 'Certificate of Origin service', icon: FaCertificate },
//   { label: 'Overseas delegation support', icon: FaGlobeAsia },
//   { label: 'Sector-specific MoU facilitation', icon: FaFileSignature },
//   { label: 'Industry academia connect', icon: FaUniversity },
//   { label: 'Local chamber collaboration', icon: FaHandshake },
// ];

// const fadeUp = {
//   hidden: { opacity: 0, y: 28 },
//   visible: { opacity: 1, y: 0 },
// };

// /* ============================ hero motion variants ============================ */

// const HERO_CONTAINER = {
//   hidden: {},
//   show: { transition: { staggerChildren: 0.12, delayChildren: 0.15 } },
// };

// const HERO_ITEM = {
//   hidden: { opacity: 0, y: 30 },
//   show: {
//     opacity: 1,
//     y: 0,
//     transition: { duration: 0.75, ease: [0.22, 1, 0.36, 1] },
//   },
// };

// // Sector name se best-match icon nikalne ka helper, taaki naye sectors ke liye
// // bhi manually icon map na karna pade.
// const sectorIconRules = [
//   [/agro|food|fisher/i, FaSeedling],
//   [/renewable|energy|power/i, FaBolt],
//   [/start-?up/i, FaRocket],
//   [/intellectual|ipr/i, FaLightbulb],
//   [/tax/i, FaMoneyBillWave],
//   [/it\b|ites|e-commerce|digital|electronics|esdm/i, FaLaptopCode],
//   [/msme|manufactur|mining|industr|engineering/i, FaIndustry],
//   [/pharma|health|medical/i, FaPills],
//   [/tourism|aviation|aerospace|hospitality/i, FaGlobeAsia],
//   [/logistic|warehous|export/i, FaExchangeAlt],
// ];

// function iconForSector(name) {
//   const match = sectorIconRules.find(([regex]) => regex.test(name));
//   return match ? match[1] : FaIndustry;
// }

// function toTitleCase(slug) {
//   return slug
//     .split('-')
//     .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
//     .join(' ');
// }

// // ============================ date helpers ============================
// function getDateParts(dateStr = '') {
//   const parts = dateStr.split(' ');
//   const dayPart = parts[0] || '--';
//   const restPart = parts.slice(1).join(' ');
//   const monthPart = (restPart.split(',')[0] || '').split('-')[0].trim();
//   const yearMatch = dateStr.match(/(20\d{2})/);
//   const year = yearMatch ? yearMatch[1] : '2026';
//   return { dayPart, monthPart, year };
// }

// function toDateObj(dateStr = '') {
//   const { dayPart, monthPart, year } = getDateParts(dateStr);
//   const cleanDay = dayPart.replace(/[^0-9]/g, '') || '1';
//   const d = new Date(`${monthPart} ${cleanDay}, ${year}`);
//   return isNaN(d.getTime()) ? null : d;
// }

// function isEventUpcoming(dateStr) {
//   const d = toDateObj(dateStr);
//   if (!d) return true;
//   const today = new Date();
//   today.setHours(0, 0, 0, 0);
//   return d.getTime() >= today.getTime();
// }

// function toTimestamp(dateStr = '') {
//   const d = toDateObj(dateStr);
//   return d ? d.getTime() : 0;
// }

// // ============================ contact helpers ============================
// // "+91 98187 15550" jaise display number ko tel:/wa.me ke liye clean karta hai.
// function telHref(phone = '') {
//   const digits = String(phone).replace(/[^\d+]/g, '');
//   if (!digits) return '';
//   return digits.startsWith('+') ? digits : `+91${digits.replace(/^0+/, '')}`;
// }

// function whatsappHref(phone = '') {
//   const digits = String(phone).replace(/\D/g, '');
//   if (!digits) return '';
//   return digits.length === 10 ? `91${digits}` : digits;
// }

// // Office ka Google Maps link. Agar office par exact pin (mapUrl) hai to wahi,
// // warna address se search query bana do.
// function mapsUrl(office) {
//   if (office?.mapUrl) return office.mapUrl;
//   const q = office?.mapQuery || (office?.lines || []).join(' ');
//   return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;
// }

// // Generic fallbacks — jis state ka apna data nahi, usme yehi dikhega taaki
// // Reports / Press / Events section har state page par dikhe, kabhi khaali na ho.
// const defaultPublications = [];
// const defaultPressReleases = [];
// const defaultPressCoverage = [];
// const defaultEvents = [];

// const defaultStateContent = {
//   focusItems: ['Viksit Bharat 2047', 'Ease of Doing Business', 'Sustainable Development'],
//   intro:
//     'A focused ASSOCHAM platform strengthening the state’s industrial ecosystem through policy advocacy, investment engagement, MSME growth, infrastructure dialogue, and sustainable development.',
//   why:
//     'This council works closely with the Government and industry stakeholders to advance policy clarity, sector action and long-term competitiveness for the state. Detailed content for this council is coming soon.',
//   overview: defaultOverview,
//   sectors: [],
//   leadership: [],
//   initiatives: [],
//   priorities: [],
//   publications: [],
//   pressReleases: [],
//   pressCoverage: [],
//   events: [],
// };

// const SERIF = {
//   fontFamily: 'Fraunces, Georgia, "Times New Roman", serif',
// };

// /* ========================== BREADCRUMB ========================== */
// function StateBreadcrumb({ stateLabel }) {
//   return (
//     <nav
//       aria-label="Breadcrumb"
//       className="absolute left-4 top-4 z-20 hidden sm:left-8 sm:top-6 sm:block"
//     >
//       <ol className="flex flex-wrap items-center gap-2 rounded-full border border-white/15 bg-white/80 px-4 py-2 text-[11px] font-bold uppercase tracking-wide text-[#141419] shadow-lg shadow-black/10 backdrop-blur-md">
//         <li>
//           <Link
//             to="/"
//             className="inline-flex items-center gap-1.5 transition-colors hover:text-[#DA2128]"
//           >
//             <svg
//               viewBox="0 0 24 24"
//               className="h-3.5 w-3.5"
//               fill="none"
//               stroke="currentColor"
//               strokeWidth={2.2}
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             >
//               <path d="M3 10.5 12 3l9 7.5" />
//               <path d="M5 10v10h14V10" />
//               <path d="M9 20v-6h6v6" />
//             </svg>
//             Home
//           </Link>
//         </li>
//         <li className="text-black/30">&rsaquo;</li>
//         <li>
//           <Link to="/states" className="transition-colors hover:text-[#DA2128]">
//             States
//           </Link>
//         </li>
//         <li className="text-black/30">&rsaquo;</li>
//         <li className="rounded-full bg-[#DA2128] px-3 py-1 text-white">{stateLabel}</li>
//       </ol>
//     </nav>
//   );
// }


// export default function StatePage() {
//   // Route dono tarah se support: /:stateSlug (App.jsx me static path ke through)
//   // ya agar kabhi /states/:stateSlug jaisa nested route use kiya toh useParams se bhi mil jayega.
//   const { stateSlug } = useParams();
//   const location = useLocation();
//   const slug = stateSlug || location.pathname.replace(/^\//, '');
//   const data = statesData[slug] || defaultStateContent;

//   const name =
//     data.name || `${stateNames[slug] || toTitleCase(slug)} State Development Council`;
//   const stateLabel = stateNames[slug] || toTitleCase(slug || 'State');
//   const overviewParagraphs =
//     data.overview && data.overview.length > 0 ? data.overview : defaultOverview;
//   const initiatives =
//     data.initiatives && data.initiatives.length > 0 ? data.initiatives : defaultInitiatives;
//   const priorities =
//     data.priorities && data.priorities.length > 0 ? data.priorities : defaultPriorities;
//   const PUBLICATIONS = data.publications || defaultPublications;
//   const PRESS_RELEASES = data.pressReleases || defaultPressReleases;
//   const PRESS_COVERAGE = data.pressCoverage || defaultPressCoverage;
//   const EVENTS = data.events || defaultEvents;

//   /* -------------------------- State ka ASSOCHAM HoD -------------------------- */
//   // statesData[slug].hod > stateHods[slug] > defaultHod (secretariat)
//   const hod = useMemo(() => getStateHod(slug), [slug]);
//   const hasNamedHod = Boolean(hod && hod.name && hod.name !== defaultHod.name);
//   const hodPhoneHref = telHref(hod?.phone || defaultHod.phone);
//   const hodWaNumber = whatsappHref(hod?.phone || '');
//   const hodEmail = hod?.email || defaultHod.email;

//   /* -------------------------- State ka ASSOCHAM office -------------------------- */
//   // statesData[slug].office > stateOffices[slug] > defaultOffice (HQ)
//   // Jiska apna kuch nahi, uske page par poori HQ details chali jaati hain.
//   const office = useMemo(() => getStateOffice(slug), [slug]);
//   const officeIsHq = Boolean(office.usingHqAddress);
//   const officePhone = office.phone || defaultOffice.phone;
//   const officePhoneHref = office.phoneHref || `tel:${telHref(officePhone)}`;
//   const officeEmail = office.email || defaultOffice.email;

//   /* -------------------------- Events state -------------------------- */
//   const [eventTab, setEventTab] = useState('all'); // "all" | "forthcoming" | "past"
//   const [eventKeyword, setEventKeyword] = useState('');
//   const [eventTag, setEventTag] = useState('');
//   const [eventPlace, setEventPlace] = useState('');
//   const [eventAnimKey, setEventAnimKey] = useState(0);
//   const [eventsVisible, setEventsVisible] = useState(2);
//   const EVENTS_STEP = 2;

//   /* -------------------------- Press state -------------------------- */
//   const [pressTab, setPressTab] = useState('releases'); // "releases" | "coverage"
//   const [pressKeyword, setPressKeyword] = useState('');
//   const [pressSort, setPressSort] = useState('newest'); // "newest" | "oldest"
//   const [pressPage, setPressPage] = useState(1);
//   const pressResultsRef = useRef(null);
//   const PRESS_PAGE_SIZE = 5;

//   /* -------------------------- Contact form -------------------------- */
//   const [submitted, setSubmitted] = useState(false);

//   /* -------------------------- Scroll progress (SectorPage-style) -------------------------- */
//   const [progress, setProgress] = useState(0);

//   useEffect(() => {
//     const onScroll = () => {
//       const h = document.documentElement.scrollHeight - window.innerHeight;
//       setProgress(h > 0 ? (window.scrollY / h) * 100 : 0);
//     };
//     onScroll();
//     window.addEventListener('scroll', onScroll, { passive: true });
//     return () => window.removeEventListener('scroll', onScroll);
//   }, []);

//   const scrollToOverview = (e) => {
//     e?.preventDefault();
//     document.getElementById('overview')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
//   };

//   /* -------------------------- Press derived state -------------------------- */
//   const pressSource = pressTab === 'releases' ? PRESS_RELEASES : PRESS_COVERAGE;

//   const pressFiltered = useMemo(() => {
//     const kw = pressKeyword.trim().toLowerCase();
//     let list = pressSource.filter((item) => {
//       if (!kw) return true;
//       const hay = `${item.title} ${item.excerpt || ''}`.toLowerCase();
//       return hay.includes(kw);
//     });
//     list = [...list].sort((a, b) => {
//       const ta = toTimestamp(a.date);
//       const tb = toTimestamp(b.date);
//       return pressSort === 'newest' ? tb - ta : ta - tb;
//     });
//     return list;
//   }, [pressSource, pressKeyword, pressSort]);

//   useEffect(() => setPressPage(1), [pressTab, pressKeyword, pressSort]);

//   const pressTotalPages = Math.max(1, Math.ceil(pressFiltered.length / PRESS_PAGE_SIZE));
//   const pressClampedPage = Math.min(pressPage, pressTotalPages);
//   const pressStart = (pressClampedPage - 1) * PRESS_PAGE_SIZE;
//   const pressPageItems = pressFiltered.slice(pressStart, pressStart + PRESS_PAGE_SIZE);

//   const scrollToPressResults = () =>
//     pressResultsRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });

//   const changePressPage = (n) => {
//     setPressPage(n);
//     scrollToPressResults();
//   };

//   const [regionData, setRegionData] = useState(null);

//   useEffect(() => {
//     let active = true;
//     getRegionBySlug(slug).then((res) => {
//       if (active && res) setRegionData(res);
//     });
//     return () => {
//       active = false;
//     };
//   }, [slug]);

//   // API se aaya data local statesData.js par override karega — jo bhi field
//   // API se null/khaali aaye, wahan hardcoded statesData.js wala fallback rahega.
//   const heroImageFinal = regionData?.header_banner_img || heroImage;
//   const overviewImageFinal = regionData?.image || data.overviewImage || overviewDefaultImg;
//   const overviewTitleFinal = regionData?.title || name;
//   const overviewTextFinal = regionData?.long_description
//     ? [regionData.long_description]
//     : overviewParagraphs;

//   /* Animated "at a glance" counters shown in the hero */
//   const heroStats = [
//     { label: 'Leadership', value: (data.leadership || []).length },
//     { label: 'Sectors', value: (data.sectors || []).length },
//     { label: 'Events', value: EVENTS.length },
//     { label: 'Publications', value: PUBLICATIONS.length },
//   ];

//   /* -------------------------- Events derived state -------------------------- */
//   const eventTags = useMemo(
//     () => Array.from(new Set(EVENTS.map((e) => e.tag).filter(Boolean))),
//     [EVENTS]
//   );

//   const eventPlaces = useMemo(
//     () => Array.from(new Set(EVENTS.map((e) => e.place).filter(Boolean))),
//     [EVENTS]
//   );

//   const filteredEvents = useMemo(() => {
//     const kw = eventKeyword.trim().toLowerCase();
//     return EVENTS.filter((e) => {
//       const upcoming = isEventUpcoming(e.date);
//       if (eventTab === 'forthcoming' && !upcoming) return false;
//       if (eventTab === 'past' && upcoming) return false;
//       if (eventTag && e.tag !== eventTag) return false;
//       if (eventPlace && e.place !== eventPlace) return false;
//       if (kw) {
//         const hay = `${e.title} ${e.text} ${e.tag || ''} ${e.place || ''}`.toLowerCase();
//         if (!hay.includes(kw)) return false;
//       }
//       return true;
//     });
//   }, [eventTab, eventTag, eventPlace, eventKeyword, EVENTS]);

//   useEffect(() => {
//     setEventAnimKey((k) => k + 1);
//   }, [eventTab, eventTag, eventPlace]);

//   useEffect(() => {
//     setEventsVisible(2);
//   }, [eventTab, eventTag, eventPlace, eventKeyword]);

//   const clearEventFilters = () => {
//     setEventKeyword('');
//     setEventTag('');
//     setEventPlace('');
//     setEventTab('all');
//     setEventAnimKey((k) => k + 1);
//   };

//   const visibleEvents = filteredEvents.slice(0, eventsVisible);
//   const hasMoreEvents = eventsVisible < filteredEvents.length;
//   const loadMoreEvents = () =>
//     setEventsVisible((v) => Math.min(v + EVENTS_STEP, filteredEvents.length));

//   /* -------------------------- Contact form handler -------------------------- */
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setSubmitted(true);
//     window.setTimeout(() => setSubmitted(false), 5000);
//   };

//   const sectionEyebrow = (label, color = '#DB6400') => (
//     <p className="text-xs font-semibold uppercase tracking-[0.35em]" style={{ color }}>
//       {label}
//     </p>
//   );

//   return (
//     <main className="min-h-screen overflow-hidden bg-[#FAF7F2] text-[#241A16] selection:bg-[#DA2128] selection:text-white">
//       <style>{`
//         html { scroll-behavior: smooth; }
//         ::selection { background:#DA2128; color:#fff; }
//         ::-webkit-scrollbar { width:10px; height:10px; }
//         ::-webkit-scrollbar-track { background:#FEF7F4; }
//         ::-webkit-scrollbar-thumb { background:linear-gradient(#DA2128,#DB6400); border-radius:9999px; }
//         .event-fade-up { animation: st-fade-up 0.6s cubic-bezier(.2,.8,.2,1) both; }
//         @keyframes st-fade-up { 0% { opacity: 0; transform: translateY(22px); } 100% { opacity: 1; transform: translateY(0); } }
//         .event-live-pill { animation: st-pulse-glow 2.4s infinite; }
//         @keyframes st-pulse-glow { 0%, 100% { box-shadow: 0 0 0 0 rgba(245,156,0,0.3); } 50% { box-shadow: 0 0 0 10px rgba(245,156,0,0); } }
//         @keyframes st-float { 0%,100%{transform:translateY(0) rotate(0)} 50%{transform:translateY(-16px) rotate(3deg)} }
//         @keyframes st-float-slow { 0%,100%{transform:translate(0,0)} 50%{transform:translate(10px,-22px)} }
//         @keyframes st-blob { 0%,100%{border-radius:62% 38% 46% 54% / 55% 48% 52% 45%} 50%{border-radius:42% 58% 66% 34% / 38% 62% 38% 62%} }
//         @keyframes st-pulse-ring { 0%{transform:scale(.85);opacity:.7} 70%{transform:scale(1.5);opacity:0} 100%{opacity:0} }
//         @keyframes st-kenburns { 0%{transform:scale(1.02) translate(0,0)} 100%{transform:scale(1.16) translate(1.2%,-1.2%)} }
//         @keyframes st-scroll-dot { 0%{transform:translateY(0);opacity:.9} 70%{transform:translateY(14px);opacity:0} 100%{transform:translateY(0);opacity:0} }
//         @keyframes st-pub-slide { 0%,100%{background-position:0% 50%} 50%{background-position:100% 50%} }
//         @keyframes st-shine { 0%{transform:translateX(-120%) skewX(-20deg)} 60%,100%{transform:translateX(240%) skewX(-20deg)} }
//         .anim-st-float{animation:st-float 7s ease-in-out infinite}
//         .anim-st-float-slow{animation:st-float-slow 11s ease-in-out infinite}
//         .anim-st-blob{animation:st-blob 14s ease-in-out infinite}
//         .anim-st-pulse-ring{animation:st-pulse-ring 2.6s cubic-bezier(.22,.61,.36,1) infinite}
//         .anim-st-kenburns{animation:st-kenburns 26s ease-in-out infinite alternate;will-change:transform}
//         .anim-st-scroll-dot{animation:st-scroll-dot 1.8s cubic-bezier(.45,.05,.55,.95) infinite}
//         .st-pub-card-bg{background:linear-gradient(120deg,#DA2128 0%,#C81E24 18%,#DB6400 42%,#F59C00 62%,#DB6400 82%,#DA2128 100%);background-size:300% 100%;animation:st-pub-slide 9s ease-in-out infinite}
//         .st-shine-parent{position:relative;overflow:hidden}
//         .st-shine-parent::after{content:"";position:absolute;top:0;bottom:0;left:0;width:45%;background:linear-gradient(90deg,transparent,rgba(255,255,255,.45),transparent);transform:translateX(-120%) skewX(-20deg)}
//         .st-shine-parent:hover::after{animation:st-shine 1s ease-out}
//         .font-heading { font-family: 'Fraunces', Georgia, serif; }
//         .sector-section { scroll-margin-top: 2rem; }
//         @media (prefers-reduced-motion: reduce){*,*::before,*::after{animation-duration:.001ms!important;animation-iteration-count:1!important;transition-duration:.001ms!important}}
//       `}</style>

//       {/* Scroll progress bar */}
//       <div className="fixed inset-x-0 top-0 z-[60] h-1">
//         <div
//           className="h-full bg-gradient-to-r from-[#DA2128] via-[#DB6400] to-[#F59C00] transition-[width] duration-150"
//           style={{ width: `${progress}%` }}
//         />
//       </div>

//       {/* Back to top */}
//       <button
//         type="button"
//         onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
//         aria-label="Back to top"
//         className={`fixed bottom-7 right-7 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-[#DA2128] text-white shadow-xl shadow-[#DA2128]/35 transition-all duration-300 hover:-translate-y-1 hover:bg-[#DB6400] ${
//           progress > 8 ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-6 opacity-0'
//         }`}
//       >
//         <FaArrowUp className="h-4 w-4" />
//       </button>

//       {/* ==================== HERO ==================== */}
//       <section
//         id="top"
//         className="relative isolate flex min-h-[70vh] flex-col overflow-hidden bg-stone-900"
//       >
//         {/* --- Background image (brightness boosted) --- */}
//         <div className="absolute inset-0">
//           <img
//             src={heroImageFinal}
//             alt={`${name} banner`}
//             className="anim-st-kenburns h-full w-full object-cover brightness-[1.25] saturate-[1.05]"
//           />
//           {/* Light overlays — image stays bright, text stays readable */}
//           <div className="absolute inset-0 bg-black/20" />
//           {/* Soft radial scrim only behind the centered text block */}
//           <div className="absolute inset-0 bg-[radial-gradient(60%_50%_at_50%_45%,rgba(0,0,0,0.45),transparent_75%)]" />
//           <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-black/30" />
//         </div>

//         {/* Decorative rotating ring + ambient shapes */}
//         <motion.div
//           aria-hidden="true"
//           className="pointer-events-none absolute -right-32 -top-40 h-[26rem] w-[26rem] rounded-full border-[40px] border-[#F59C00]/20"
//           animate={{ rotate: 360 }}
//           transition={{ duration: 35, repeat: Infinity, ease: 'linear' }}
//         />
//         <div className="anim-st-blob anim-st-float pointer-events-none absolute -left-24 bottom-10 h-72 w-72 bg-[#DA2128]/25 blur-3xl" />
//         <div className="anim-st-blob anim-st-float-slow pointer-events-none absolute right-[12%] top-[18%] h-64 w-64 bg-[#F59C00]/20 blur-3xl" />
//         <div className="anim-st-pulse-ring pointer-events-none absolute right-[16%] top-[30%] h-24 w-24 rounded-full border border-white/20" />
//         <div className="anim-st-pulse-ring pointer-events-none absolute left-[11%] top-[42%] h-14 w-14 rounded-full border border-[#F59C00]/40" />

//         {/* --- Breadcrumb (hero top par) --- */}
//         <StateBreadcrumb stateLabel={stateLabel} />

//         {/* --- Centered hero content --- */}
//         <motion.div
//           variants={HERO_CONTAINER}
//           initial="hidden"
//           animate="show"
//           className="relative z-10 mx-auto flex w-full max-w-7xl flex-1 flex-col items-center justify-center px-6 py-24 text-center"
//         >
//           <motion.div variants={HERO_ITEM}>
//             <span className="inline-flex items-center gap-2.5 rounded-full border border-white/25 bg-white/10 px-5 py-2 text-[10.5px] font-bold uppercase tracking-[0.28em] text-white shadow-lg backdrop-blur-md">
//               <span className="relative flex h-2 w-2">
//                 <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#F59C00] opacity-80" />
//                 <span className="relative inline-flex h-2 w-2 rounded-full bg-[#F59C00]" />
//               </span>
//               Industry Policy Forum
//             </span>
//           </motion.div>

//           <motion.h1
//             variants={HERO_ITEM}
//             style={SERIF}
//             className="mt-7 max-w-4xl text-3xl font-medium leading-[1.12] tracking-tight text-white drop-shadow-[0_4px_24px_rgba(0,0,0,0.35)] md:text-5xl lg:text-6xl"
//           >
//             {overviewTitleFinal}
//           </motion.h1>

//           {/* Ornamental divider */}
//           <motion.div variants={HERO_ITEM} className="mt-8 flex items-center justify-center gap-3">
//             <span className="h-px w-16 bg-gradient-to-r from-transparent to-white/70" />
//             <motion.span
//               animate={{ rotate: 360 }}
//               transition={{ duration: 14, repeat: Infinity, ease: 'linear' }}
//               className="h-2.5 w-2.5 rotate-45 bg-gradient-to-br from-[#F59C00] to-[#DA2128]"
//             />
//             <span className="h-px w-16 bg-gradient-to-l from-transparent to-white/70" />
//           </motion.div>

//           {/* Animated "at a glance" counters */}
//           {/* <motion.div
//             variants={HERO_ITEM}
//             className="mt-10 grid w-full max-w-3xl grid-cols-2 gap-3 sm:grid-cols-4 sm:gap-4"
//           >
//             {heroStats.map((s) => (
//               <div
//                 key={s.label}
//                 className="group rounded-2xl border border-white/15 bg-white/10 px-4 py-4 shadow-[0_12px_36px_rgba(0,0,0,0.18)] backdrop-blur-md transition-all duration-300 hover:-translate-y-1 hover:border-white/30 hover:bg-white/15"
//               >
//                 <p style={SERIF} className="text-2xl font-black text-white sm:text-3xl">
//                   <CountUp value={s.value} />
//                 </p>
//                 <p className="mt-1 text-[9.5px] font-bold uppercase tracking-[0.22em] text-white/70">
//                   {s.label}
//                 </p>
//               </div>
//             ))}
//           </motion.div> */}

//           {/* Scroll cue */}
//           <motion.div variants={HERO_ITEM} className="mt-12">
//             <button
//               type="button"
//               onClick={scrollToOverview}
//               aria-label="Scroll to overview"
//               className="flex flex-col items-center gap-1.5 text-white/60 transition-colors duration-300 hover:text-white"
//             >
//               <span className="text-[9px] font-extrabold uppercase tracking-[0.34em]">Scroll</span>
//               <span className="flex h-9 w-[22px] items-start justify-center rounded-full border-2 border-white/40 p-1">
//                 <span className="anim-st-scroll-dot h-2 w-[5px] rounded-full bg-gradient-to-b from-[#F59C00] to-[#DA2128]" />
//               </span>
//             </button>
//           </motion.div>
//         </motion.div>
//       </section>

//       {/* ==================== OVERVIEW (SectorPage magazine-style) ====================
//           Image floats left; heading + text start beside it and — once the text
//           exceeds the image height — continue FULL WIDTH under the image. */}
//       <section
//         id="overview"
//         className="sector-section relative z-10 -mt-10 scroll-mt-6 rounded-t-[44px] bg-white py-16 lg:py-24"
//       >
//         <div className="relative mx-auto max-w-7xl px-6 lg:px-12">
//           {/* Floating image column */}
//           <motion.div
//             initial="hidden"
//             whileInView="visible"
//             viewport={{ once: true }}
//             variants={fadeUp}
//             className="mb-8 w-full lg:float-left lg:mb-8 lg:mr-10 lg:w-[340px]"
//           >
//             <div className="relative">
//               <div className="overflow-hidden rounded-[28px] border-4 border-white bg-white shadow-2xl shadow-stone-900/15">
//                 <img
//                   src={overviewImageFinal}
//                   alt={name}
//                   className="h-[360px] w-full object-cover transition-transform duration-[1400ms] hover:scale-105"
//                   loading="lazy"
//                 />
//               </div>

//               {/* Floating state badge */}
//               <div className="anim-st-float absolute -bottom-6 -right-3 w-56 rounded-2xl border border-stone-100 bg-white p-4 shadow-2xl">
//                 <p className="text-[11px] font-extrabold uppercase tracking-[0.2em] text-[#DA2128]">
//                   State Council
//                 </p>
//                 <p className="mt-1 text-[14.5px] font-bold leading-snug text-stone-900" style={SERIF}>
//                   {name}
//                 </p>
//               </div>

//               {/* Floating accent tile (gradient chip with sector icon) */}
//               <div className="anim-st-float-slow absolute -left-5 -top-6 hidden w-32 overflow-hidden rounded-2xl border-4 border-white shadow-xl sm:block">
//                 <div className="st-pub-card-bg flex h-20 w-full items-center justify-center text-white">
//                   <FaIndustry className="h-6 w-6 opacity-90" />
//                 </div>
//               </div>
//             </div>
//           </motion.div>

//           {/* Heading + text flow beside the image, then under it */}
//           <p className="text-xs font-semibold uppercase tracking-[0.35em] text-[#DB6400]">
//             Overview
//           </p>
//           <h2
//             className="mt-3 text-2xl font-medium leading-[1.25] tracking-tight text-[#241A16] md:text-4xl"
//             style={SERIF}
//           >
//             Shaping India&apos;s{' '}
//             <span className="text-[#DA2128]">
//               {name.replace(/State (Development )?Council/i, '').trim()} Agenda
//             </span>
//           </h2>

//           <div className="mt-6 space-y-4 border-l-2 border-[#DA2128]/20 pl-5">
//             {regionData?.long_description ? (
//               <div
//                 className="prose prose-stone max-w-none text-[15.5px] leading-relaxed text-stone-600 [&_p]:mb-4"
//                 dangerouslySetInnerHTML={{ __html: regionData.long_description }}
//               />
//             ) : (
//               overviewParagraphs.map((p, i) => (
//                 <motion.p
//                   key={i}
//                   initial={{ opacity: 0, x: 15 }}
//                   whileInView={{ opacity: 1, x: 0 }}
//                   viewport={{ once: true }}
//                   transition={{ delay: 0.1 + i * 0.08 }}
//                   className="text-[15.5px] leading-relaxed text-stone-600"
//                 >
//                   {i === 0 && p.includes('ASSOCHAM') ? (
//                     <>
//                       <span className="font-bold text-stone-900">ASSOCHAM</span>
//                       {p.replace('ASSOCHAM', '')}
//                     </>
//                   ) : (
//                     p
//                   )}
//                 </motion.p>
//               ))
//             )}
//           </div>

//           {data.sectors && data.sectors.length > 0 && (
//             <div className="mt-8 grid gap-3 sm:grid-cols-2">
//               {data.sectors.slice(0, 6).map((sectorName, i) => (
//                 <div
//                   key={i}
//                   className="flex items-start gap-2.5 rounded-2xl bg-[#FAF7F2] p-3.5 ring-1 ring-stone-200 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-[#DA2128]/5 hover:ring-[#DA2128]/30"
//                 >
//                   <FaCheck className="mt-1 h-3.5 w-3.5 shrink-0 text-[#DA2128]" />
//                   <p className="text-[13px] font-medium leading-relaxed text-stone-700">
//                     {sectorName}
//                   </p>
//                 </div>
//               ))}
//             </div>
//           )}

//           {/* Clear the float so following sections don't get affected */}
//           <div className="clear-both" />
//         </div>
//       </section>

//       {/* ==================== COUNCIL LEADERSHIP (Sector-style) ==================== */}
//       <section
//         id="councils"
//         className="sector-section relative scroll-mt-6 overflow-hidden bg-white py-20 lg:py-24"
//       >
//         <div className="pointer-events-none absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-[#FAF7F2] to-transparent" />
//         <div className="anim-st-blob anim-st-float-slow pointer-events-none absolute -right-32 bottom-0 h-80 w-80 bg-[#F59C00]/10 blur-3xl" />
//         <div className="relative mx-auto max-w-7xl px-6 lg:px-12">
//           <div className="mb-2">
//             <p className="text-xs font-semibold uppercase tracking-[0.35em] text-[#DB6400]">
//               Councils
//             </p>
//             <h2
//               className="mt-3 text-2xl font-medium leading-[1.25] tracking-tight text-[#241A16] md:text-4xl"
//               style={SERIF}
//             >
//               Council Leadership
//             </h2>
//           </div>
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.6 }}
//           >
//             <CouncilLeadership members={data.leadership} councilName={name} />
//           </motion.div>
//         </div>
//       </section>

//       {/* ==================== SECTORS ==================== */}
//       {data.sectors && data.sectors.length > 0 && (
//         <section id="sectors" className="relative bg-[#FEF7F4] py-16 lg:py-20">
//           <div className="mx-auto max-w-7xl px-6 lg:px-12">
//             <div className="mb-12 flex flex-col justify-between gap-6 md:flex-row md:items-end">
//               <div>
//                 <p className="text-xs font-semibold uppercase tracking-[0.35em] text-[#DB6400]">
//                   Sectoral Engine
//                 </p>
//                 <h2
//                   className="mt-3 text-2xl font-medium leading-[1.25] tracking-tight text-[#241A16] md:text-4xl"
//                   style={SERIF}
//                 >
//                   Focused committees for focused outcomes.
//                 </h2>
//               </div>
//               <p className="max-w-md text-sm leading-relaxed text-[#241A16]/75 font-normal">
//                 Sector sub-committees help convert member inputs into state-specific policy recommendations,
//                 promotion opportunities and business interactions.
//               </p>
//             </div>
//             <div className="grid border-t border-l border-[#241A16]/10 sm:grid-cols-2 lg:grid-cols-4">
//               {data.sectors.map((sectorName, index) => {
//                 const Icon = iconForSector(sectorName);
//                 return (
//                   <motion.div
//                     key={sectorName}
//                     className="group relative flex min-h-[160px] flex-col justify-between border-r border-b border-[#241A16]/10 bg-white/60 p-6 transition-all duration-300 hover:bg-[#DA2128]"
//                     initial={{ opacity: 0, y: 20 }}
//                     whileInView={{ opacity: 1, y: 0 }}
//                     viewport={{ once: true }}
//                     transition={{ delay: index * 0.04 }}
//                   >
//                     <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-[#DA2128]/10 text-[#DA2128] transition-all duration-300 group-hover:bg-white/20 group-hover:text-white group-hover:scale-105">
//                       <Icon className="text-xl" />
//                     </div>
//                     <p
//                       className="mt-6 text-base font-medium tracking-tight text-[#241A16] transition-colors duration-300 group-hover:text-white"
//                       style={SERIF}
//                     >
//                       {sectorName}
//                     </p>
//                   </motion.div>
//                 );
//               })}
//             </div>
//           </div>
//         </section>
//       )}

//       {/* ==================== EVENTS (Upcoming & Past) ==================== */}
//       <section id="events" className="relative scroll-mt-20 overflow-hidden bg-white py-16 lg:py-20">
//         <div className="pointer-events-none absolute -right-24 top-10 h-72 w-72 rounded-full bg-[#F59C00]/10 blur-3xl" />
//         <div className="pointer-events-none absolute -left-24 bottom-0 h-72 w-72 rounded-full bg-[#DA2128]/10 blur-3xl" />
//         <div className="relative mx-auto max-w-7xl px-6 lg:px-12">
//           <div className="mb-10 max-w-2xl">
//             {sectionEyebrow('Engagements & Events', '#DB6400')}
//             <h2
//               className="mt-3 text-2xl font-medium leading-[1.25] tracking-tight text-[#241A16] md:text-4xl"
//               style={SERIF}
//             >
//               Recent &amp; Upcoming Initiatives
//             </h2>
//           </div>
//           <div className="grid gap-6 lg:grid-cols-[300px_minmax(0,1fr)] xl:grid-cols-[320px_minmax(0,1fr)]">
//             {/* Sidebar */}
//             <motion.aside
//               initial={{ opacity: 0, x: -20 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               viewport={{ once: true }}
//               className="rounded-[26px] border border-[#DA2128]/10 bg-[#FAF7F2] p-5 shadow-[0_18px_44px_rgba(218,33,40,0.08)] lg:sticky lg:top-24 lg:h-fit"
//             >
//               <div className="mb-5 flex items-center justify-between border-b border-[#DA2128]/10 pb-3.5">
//                 <div>
//                   <p className="text-[0.7rem] font-semibold uppercase tracking-[0.22em] text-[#DB6400]">
//                     Filter by
//                   </p>
//                   <h3 className="mt-1 text-xl font-bold text-stone-900" style={SERIF}>
//                     Events Search
//                   </h3>
//                 </div>
//                 <div className="rounded-xl bg-gradient-to-br from-[#FFE3DA] to-[#FFE7CF] p-2 text-[#DA2128]">
//                   <FaSlidersH className="h-4 w-4" />
//                 </div>
//               </div>
//               <div className="space-y-3.5">
//                 <div className="space-y-1.5">
//                   <label className="text-[0.8rem] font-bold text-stone-700">Keywords</label>
//                   <div className="relative">
//                     <FaSearch className="pointer-events-none absolute left-3.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-[#DA2128]" />
//                     <input
//                       type="text"
//                       value={eventKeyword}
//                       onChange={(e) => setEventKeyword(e.target.value)}
//                       placeholder="Search by title, place..."
//                       className="w-full rounded-xl border border-[#DA2128]/10 bg-white py-2.5 pl-10 pr-3.5 text-[0.8rem] font-medium text-stone-700 transition duration-300 placeholder:text-stone-400 hover:border-[#DA2128]/30 focus:border-[#DA2128] focus:outline-none focus:ring-2 focus:ring-[#DA2128]/10"
//                     />
//                   </div>
//                 </div>
//                 <div className="space-y-1.5">
//                   <label className="text-[0.8rem] font-bold text-stone-700">Status</label>
//                   <div className="flex gap-1.5 rounded-xl border border-[#DA2128]/10 bg-white p-1">
//                     {[
//                       ['all', 'All'],
//                       ['forthcoming', 'Upcoming'],
//                       ['past', 'Past'],
//                     ].map(([v, l]) => (
//                       <button
//                         key={v}
//                         type="button"
//                         onClick={() => setEventTab(v)}
//                         className={`flex-1 rounded-lg px-2 py-2 text-[0.75rem] font-bold transition duration-300 ${
//                           eventTab === v
//                             ? 'bg-gradient-to-r from-[#DA2128] to-[#F59C00] text-white shadow-md'
//                             : 'text-stone-500 hover:bg-[#FAF7F2]'
//                         }`}
//                       >
//                         {l}
//                       </button>
//                     ))}
//                   </div>
//                 </div>
//                 {eventTags.length > 0 && (
//                   <div className="space-y-1.5">
//                     <label className="text-[0.8rem] font-bold text-stone-700">Category</label>
//                     <div className="relative">
//                       <FaTag className="pointer-events-none absolute left-3.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-[#DA2128]" />
//                       <select
//                         value={eventTag}
//                         onChange={(e) => setEventTag(e.target.value)}
//                         className="w-full appearance-none rounded-xl border border-[#DA2128]/10 bg-white py-2.5 pl-10 pr-9 text-[0.8rem] font-medium text-stone-700 transition duration-300 hover:border-[#DA2128]/30 focus:border-[#DA2128] focus:outline-none focus:ring-2 focus:ring-[#DA2128]/10"
//                       >
//                         <option value="">All categories</option>
//                         {eventTags.map((t) => (
//                           <option key={t} value={t}>
//                             {t}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                   </div>
//                 )}
//                 {eventPlaces.length > 0 && (
//                   <div className="space-y-1.5">
//                     <label className="text-[0.8rem] font-bold text-stone-700">Location</label>
//                     <div className="relative">
//                       <FaMapMarkerAlt className="pointer-events-none absolute left-3.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-[#DA2128]" />
//                       <select
//                         value={eventPlace}
//                         onChange={(e) => setEventPlace(e.target.value)}
//                         className="w-full appearance-none rounded-xl border border-[#DA2128]/10 bg-white py-2.5 pl-10 pr-9 text-[0.8rem] font-medium text-stone-700 transition duration-300 hover:border-[#DA2128]/30 focus:border-[#DA2128] focus:outline-none focus:ring-2 focus:ring-[#DA2128]/10"
//                       >
//                         <option value="">All locations</option>
//                         {eventPlaces.map((p) => (
//                           <option key={p} value={p}>
//                             {p}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                   </div>
//                 )}
//               </div>
//               <button
//                 type="button"
//                 onClick={clearEventFilters}
//                 className="mt-5 inline-flex w-full items-center justify-center gap-1.5 rounded-xl border border-[#DA2128]/20 bg-white px-4 py-2.5 text-[0.8rem] font-bold text-[#DA2128] transition duration-300 hover:bg-[#FEF7F4]"
//               >
//                 <FaTimes className="h-3.5 w-3.5" />
//                 Clear filters
//               </button>
//             </motion.aside>
//             {/* Main list */}
//             <div>
//               <div className="flex flex-wrap items-center justify-between gap-3 pb-5">
//                 <span className="text-[12.5px] font-semibold text-stone-500">
//                   {filteredEvents.length === 0
//                     ? EVENTS.length === 0
//                       ? 'No events published yet for this council'
//                       : 'No events match your filters'
//                     : `Showing ${Math.min(eventsVisible, filteredEvents.length)} of ${filteredEvents.length} event${
//                         filteredEvents.length > 1 ? 's' : ''
//                       }`}
//                 </span>
//               </div>
//               <div key={eventAnimKey} className="grid gap-6">
//                 {filteredEvents.length === 0 ? (
//                   <div className="rounded-[24px] border border-dashed border-[#DA2128]/25 bg-[#FAF7F2] p-10 text-center">
//                     <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-gradient-to-br from-[#DA2128] to-[#F59C00] text-white shadow-lg shadow-[#DA2128]/25">
//                       <FaSearch className="h-6 w-6" />
//                     </div>
//                     <h4 className="mt-4 text-lg font-bold text-stone-900" style={SERIF}>
//                       {EVENTS.length === 0 ? 'No engagements published yet' : 'No matching events found'}
//                     </h4>
//                     <p className="mx-auto mt-2 max-w-sm text-[13px] leading-relaxed text-stone-500">
//                       {EVENTS.length === 0
//                         ? "Check back soon for this council's upcoming and past engagements."
//                         : 'Try clearing a filter or switching the status tab to see more initiatives.'}
//                     </p>
//                     {EVENTS.length > 0 && (
//                       <button
//                         type="button"
//                         onClick={clearEventFilters}
//                         className="mt-5 inline-flex items-center gap-1.5 rounded-full bg-gradient-to-r from-[#DA2128] to-[#F59C00] px-5 py-2.5 text-[12.5px] font-bold text-white shadow-lg shadow-[#DA2128]/25 transition hover:shadow-[#DA2128]/40"
//                       >
//                         Reset all filters
//                       </button>
//                     )}
//                   </div>
//                 ) : (
//                   visibleEvents.map((event, i) => (
//                     <StateEventCard key={`${event.title}-${eventAnimKey}-${i}`} event={event} index={i} />
//                   ))
//                 )}
//               </div>
//               {hasMoreEvents && (
//                 <div className="mt-8 text-center">
//                   <button
//                     type="button"
//                     onClick={loadMoreEvents}
//                     className="st-shine-parent inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-[#DA2128] to-[#F59C00] px-8 py-3 text-[13px] font-bold text-white shadow-lg shadow-[#DA2128]/30 transition-all hover:-translate-y-0.5 hover:shadow-[#DA2128]/45"
//                   >
//                     Load More Events
//                   </button>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </section>


//       {/* ==================== PRESS RELEASES & COVERAGE ==================== */}
//       <section
//         id="press"
//         className="relative z-10 -mt-10 scroll-mt-20 overflow-hidden rounded-t-[44px] bg-[#FAF7F2] py-16 lg:py-20"
//       >
//         <div className="pointer-events-none absolute -left-24 bottom-0 h-72 w-72 rounded-full bg-[#DA2128]/10 blur-3xl" />
//         <div className="relative mx-auto max-w-7xl px-6 lg:px-12">
//           <div className="mb-10 max-w-2xl">
//             {sectionEyebrow('Newsroom', '#DB6400')}
//             <h2
//               className="mt-3 text-2xl font-medium leading-[1.25] tracking-tight text-[#241A16] md:text-4xl"
//               style={SERIF}
//             >
//               Press Release &amp; <span className="text-[#DA2128]">Press Coverage</span>
//             </h2>
//           </div>
//           {/* Filter bar */}
//           <motion.div
//             initial={{ opacity: 0, y: 16 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             className="rounded-2xl border border-stone-200 bg-white p-4 shadow-[0_10px_40px_-24px_rgba(218,33,40,0.35)] sm:p-5"
//           >
//             <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
//               {/* Type toggle */}
//               <div className="inline-flex w-fit rounded-full bg-stone-100 p-1">
//                 {[
//                   { key: 'releases', label: 'Press Releases', count: PRESS_RELEASES.length },
//                   { key: 'coverage', label: 'Press Coverage', count: PRESS_COVERAGE.length },
//                 ].map((t) => (
//                   <button
//                     key={t.key}
//                     type="button"
//                     onClick={() => setPressTab(t.key)}
//                     className={`relative rounded-full px-5 py-2.5 text-[12.5px] font-bold uppercase tracking-[0.06em] transition-all duration-300 ${
//                       pressTab === t.key
//                         ? 'bg-white text-[#DA2128] shadow-md'
//                         : 'text-stone-500 hover:text-stone-700'
//                     }`}
//                   >
//                     {t.label}
//                     <span
//                       className={`ml-2 rounded-full px-2 py-0.5 text-[10px] ${
//                         pressTab === t.key ? 'bg-[#DA2128]/10 text-[#DA2128]' : 'bg-stone-200 text-stone-500'
//                       }`}
//                     >
//                       {t.count}
//                     </span>
//                   </button>
//                 ))}
//               </div>
//               {/* Keyword + sort */}
//               <div className="flex flex-1 flex-col gap-3 sm:flex-row sm:items-center lg:max-w-xl">
//                 <div className="relative flex-1">
//                   <FaSearch
//                     className="pointer-events-none absolute left-3.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-[#DA2128]"
//                   />
//                   <input
//                     type="text"
//                     value={pressKeyword}
//                     onChange={(e) => setPressKeyword(e.target.value)}
//                     placeholder="Search press releases & coverage..."
//                     className="w-full rounded-xl border border-stone-200 bg-[#FAF7F2] py-2.5 pl-10 pr-3.5 text-[13px] font-medium text-stone-700 transition duration-300 placeholder:text-stone-400 hover:border-[#DA2128]/30 focus:border-[#DA2128] focus:bg-white focus:outline-none focus:ring-2 focus:ring-[#DA2128]/10"
//                   />
//                 </div>
//                 <div className="flex shrink-0 items-center gap-2">
//                   <div className="flex overflow-hidden rounded-xl text-[11.5px] font-bold ring-1 ring-stone-200">
//                     {[
//                       ['newest', 'Newest'],
//                       ['oldest', 'Oldest'],
//                     ].map(([v, l]) => (
//                       <button
//                         key={v}
//                         type="button"
//                         onClick={() => setPressSort(v)}
//                         className={`px-3.5 py-2.5 transition-colors ${
//                           pressSort === v
//                             ? 'bg-gradient-to-r from-[#DA2128] to-[#DB6400] text-white'
//                             : 'bg-white text-stone-500 hover:text-[#DA2128]'
//                         }`}
//                       >
//                         {l}
//                       </button>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </motion.div>
//           {/* Results */}
//           <div ref={pressResultsRef} className="mt-10 scroll-mt-32">
//             <div className="flex flex-wrap items-center justify-between gap-3 border-b-2 border-stone-900/90 pb-4">
//               <h3 className="flex items-center gap-2.5 text-xl font-bold text-stone-900 sm:text-2xl" style={SERIF}>
//                 {pressTab === 'releases' ? 'Press Releases' : 'Press Coverage'}
//                 <button
//                   type="button"
//                   title="Subscribe via RSS"
//                   className="text-[#DA2128] transition-colors hover:text-[#DB6400]"
//                   onClick={(e) => e.preventDefault()}
//                 >
//                   <FaRss className="h-4 w-4" />
//                 </button>
//               </h3>
//               <span className="text-[12.5px] font-semibold text-stone-400">
//                 {pressFiltered.length === 0
//                   ? 'No matching results'
//                   : `Showing ${pressStart + 1}–${Math.min(
//                       pressStart + PRESS_PAGE_SIZE,
//                       pressFiltered.length
//                     )} of ${pressFiltered.length}`}
//               </span>
//             </div>
//             {pressPageItems.length > 0 ? (
//               pressPageItems.map((item, i) => (
//                 <motion.article
//                   key={`${pressTab}-${item.title}-${i}`}
//                   layout
//                   initial={{ opacity: 0, y: 18 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   viewport={{ once: true }}
//                   transition={{ duration: 0.35, delay: i * 0.05 }}
//                   className="group flex flex-col gap-4 border-b border-stone-200 py-6 sm:flex-row sm:items-center sm:justify-between"
//                 >
//                   <div className="min-w-0 flex-1">
//                     <div className="flex flex-wrap items-center gap-2.5">
//                       <span className="inline-flex items-center gap-1.5 rounded-full bg-[#FEF7F4] px-2.5 py-1 text-[10.5px] font-extrabold uppercase tracking-[0.14em] text-[#DA2128]">
//                         <FaCalendarAlt className="h-3 w-3" />
//                         {item.date}
//                       </span>
//                       <span className="inline-flex rounded-full border border-stone-200 px-2.5 py-1 text-[10.5px] font-bold uppercase tracking-[0.1em] text-stone-500">
//                         {pressTab === 'releases' ? 'Release' : 'Coverage'}
//                       </span>
//                     </div>
//                     <h4
//                       className="mt-3 text-[17px] font-bold leading-snug text-stone-900 transition-colors group-hover:text-[#DA2128] sm:text-[18px]"
//                       style={SERIF}
//                     >
//                       {item.title}
//                     </h4>
//                     <p className="mt-2 text-[13.5px] leading-relaxed text-stone-600">{item.excerpt}</p>
//                   </div>
//                   <a
//                     href="#"
//                     className="inline-flex shrink-0 items-center gap-1.5 self-start rounded-full border border-[#DA2128]/25 px-4 py-2 text-[12.5px] font-bold text-[#DA2128] transition-all duration-300 hover:bg-[#DA2128] hover:text-white sm:self-center"
//                   >
//                     Read more
//                   </a>
//                 </motion.article>
//               ))
//             ) : (
//               <div className="flex flex-col items-center py-16 text-center">
//                 <div className="grid h-16 w-16 place-items-center rounded-3xl bg-[#FEF7F4]">
//                   <FaSearch className="h-7 w-7 text-[#DA2128]" />
//                 </div>
//                 <h4 className="mt-5 text-lg font-bold text-stone-900" style={SERIF}>
//                   {pressSource.length === 0 ? 'Nothing published yet' : 'No results found'}
//                 </h4>
//                 <p className="mt-2 max-w-sm text-[13px] text-stone-500">
//                   {pressSource.length === 0
//                     ? "This council hasn't shared a press release or coverage item yet."
//                     : 'Nothing matches your search. Try a different keyword or clear it to see everything.'}
//                 </p>
//                 {pressKeyword && (
//                   <button
//                     type="button"
//                     onClick={() => setPressKeyword('')}
//                     className="mt-5 rounded-full bg-gradient-to-r from-[#DA2128] to-[#DB6400] px-6 py-2.5 text-[12.5px] font-bold text-white shadow-lg shadow-[#DA2128]/25 transition-all hover:shadow-[#DA2128]/40"
//                   >
//                     Clear search
//                   </button>
//                 )}
//               </div>
//             )}
//             {/* Pagination */}
//             {pressTotalPages > 1 && (
//               <div className="mt-10 flex items-center justify-center gap-2">
//                 <button
//                   disabled={pressClampedPage === 1}
//                   onClick={() => changePressPage(pressClampedPage - 1)}
//                   className="grid h-10 w-10 place-items-center rounded-xl text-stone-500 ring-1 ring-stone-200 transition-all hover:text-[#DA2128] hover:ring-[#DA2128] disabled:pointer-events-none disabled:opacity-35"
//                   aria-label="Previous page"
//                 >
//                   <FaChevronLeft className="h-4 w-4" />
//                 </button>
//                 {Array.from({ length: pressTotalPages }, (_, i) => i + 1).map((n) => (
//                   <button
//                     key={n}
//                     onClick={() => changePressPage(n)}
//                     className={`relative h-10 w-10 rounded-xl text-[13px] font-extrabold transition-all ${
//                       n === pressClampedPage
//                         ? 'text-white'
//                         : 'text-stone-500 ring-1 ring-stone-200 hover:text-[#DA2128] hover:ring-[#DA2128]'
//                     }`}
//                   >
//                     {n === pressClampedPage && (
//                       <motion.span
//                         layoutId="press-page-pill"
//                         className="absolute inset-0 rounded-xl bg-gradient-to-br from-[#DA2128] to-[#DB6400] shadow-lg shadow-[#DA2128]/30"
//                         transition={{ type: 'spring', stiffness: 420, damping: 32 }}
//                       />
//                     )}
//                     <span className="relative">{n}</span>
//                   </button>
//                 ))}
//                 <button
//                   disabled={pressClampedPage === pressTotalPages}
//                   onClick={() => changePressPage(pressClampedPage + 1)}
//                   className="grid h-10 w-10 place-items-center rounded-xl text-stone-500 ring-1 ring-stone-200 transition-all hover:text-[#DA2128] hover:ring-[#DA2128] disabled:pointer-events-none disabled:opacity-35"
//                   aria-label="Next page"
//                 >
//                   <FaChevronRight className="h-4 w-4" />
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>
//       </section>



//             {/* ==================== REPORTS (Publications) ==================== */}
//       <section
//         id="reports"
//         className="relative overflow-hidden bg-gradient-to-b from-[#FEF7F4] via-[#FAF7F2] to-[#FEF7F4] py-16 lg:py-20"
//       >
//         <div className="pointer-events-none absolute -right-24 top-10 h-72 w-72 rounded-full bg-[#F59C00]/10 blur-3xl" />
//         <div className="anim-st-blob anim-st-float pointer-events-none absolute -left-24 bottom-10 h-64 w-64 bg-[#DA2128]/10 blur-3xl" />
//         <div className="relative mx-auto max-w-7xl px-6 lg:px-12">
//           <div className="mb-12 max-w-2xl">
//             {sectionEyebrow('Reports & Knowledge Hub', '#DB6400')}
//             <h2
//               className="mt-3 text-2xl font-medium leading-[1.25] tracking-tight text-[#241A16] md:text-4xl"
//               style={SERIF}
//             >
//               Publications &amp; Reports
//             </h2>
//             <p className="mt-4 text-base leading-relaxed text-[#241A16]/75 font-normal">
//               Research, policy notes and sector reports prepared by the council to inform decisions and shape the
//               state&apos;s growth agenda.
//             </p>
//           </div>
//           {PUBLICATIONS.length > 0 ? (
//             <div className="mt-6 grid gap-7 lg:grid-cols-3">
//               {PUBLICATIONS.map((p, i) => (
//                 <motion.article
//                   key={p.title}
//                   initial={{ opacity: 0, y: 20 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   viewport={{ once: true }}
//                   transition={{ delay: i * 0.08 }}
//                   className="group relative flex h-full flex-col overflow-hidden rounded-3xl border border-stone-200 bg-white transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl hover:shadow-[#DA2128]/10"
//                 >
//                   {/* Animated gradient header */}
//                   <div className="st-pub-card-bg relative h-36 overflow-hidden">
//                     <svg
//                       className="absolute inset-0 h-full w-full text-white/20"
//                       viewBox="0 0 400 160"
//                       preserveAspectRatio="none"
//                       aria-hidden="true"
//                     >
//                       <path d="M0 120 Q60 90 120 118 T240 116 T400 96 L400 160 L0 160Z" fill="currentColor" />
//                       <path d="M0 138 Q80 112 160 136 T320 130 T400 124 L400 160 L0 160Z" fill="currentColor" opacity="0.6" />
//                     </svg>
//                     <div className="absolute left-6 top-5 flex flex-col gap-2">
//                       <span className="w-max rounded-full bg-white/20 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.14em] text-white backdrop-blur">
//                         {p.date}
//                       </span>
//                       <span className="w-max rounded-full bg-white px-3 py-1 text-[11px] font-bold text-[#DA2128]">
//                         {p.partner}
//                       </span>
//                     </div>
//                   </div>
//                   <div className="flex flex-1 flex-col p-7">
//                     <h3
//                       className="text-[19px] font-bold leading-snug text-stone-900 transition-colors group-hover:text-[#DA2128]"
//                       style={SERIF}
//                     >
//                       {p.title}
//                     </h3>
//                     <p className="mt-3 flex-1 text-[14px] leading-relaxed text-stone-600">{p.text}</p>
//                     <div className="mt-6 flex items-center justify-between gap-3">
//                       <button
//                         type="button"
//                         className="st-shine-parent inline-flex items-center gap-2 rounded-full border border-[#DA2128]/25 bg-[#FEF7F4] px-5 py-2.5 text-[12.5px] font-bold text-[#DA2128] transition-all duration-300 hover:bg-[#DA2128] hover:text-white"
//                       >
//                         Download PDF
//                         <FaDownload className="h-3.5 w-3.5" />
//                       </button>
//                       <span className="text-[11.5px] font-semibold uppercase tracking-wide text-stone-400">
//                         {p.pages}
//                       </span>
//                     </div>
//                   </div>
//                 </motion.article>
//               ))}
//             </div>
//           ) : (
//             <div className="mt-6 flex flex-col items-center rounded-[24px] border border-dashed border-[#DA2128]/25 bg-white/60 py-16 text-center">
//               <div className="grid h-16 w-16 place-items-center rounded-3xl bg-[#FEF7F4]">
//                 <FaLightbulb className="h-7 w-7 text-[#DA2128]" />
//               </div>
//               <h4 className="mt-5 text-lg font-bold text-stone-900" style={SERIF}>
//                 Publications coming soon
//               </h4>
//               <p className="mt-2 max-w-sm text-[13px] text-stone-500">
//                 This council hasn&apos;t published a report yet. Check back soon, or explore other sections above.
//               </p>
//             </div>
//           )}
//         </div>
//       </section>

//       {/* ==================== CONTACT US ==================== */}
//       <section id="contact" className="relative scroll-mt-20 overflow-hidden bg-gradient-to-b from-[#FAF7F2] to-[#FFFBF7] py-16 lg:py-20">
//         <div className="pointer-events-none absolute -right-24 top-10 h-72 w-72 rounded-full bg-[#F59C00]/10 blur-3xl" />
//         <div className="anim-st-blob anim-st-float-slow pointer-events-none absolute -left-24 bottom-8 h-64 w-64 bg-[#DA2128]/10 blur-3xl" />
//         <div className="relative mx-auto max-w-7xl px-6 lg:px-12">
//           <div className="grid gap-10 lg:grid-cols-2">
//             {/* Left - Contact info */}
//             <div>
//               <motion.div
//                 initial={{ opacity: 0, y: 20 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 viewport={{ once: true }}
//                 className="mb-3 inline-flex items-center gap-2"
//               >
//                 <div className="h-[2px] w-6 rounded-full bg-[#DA2128]" />
//                 <span className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#DA2128]">
//                   Contact
//                 </span>
//               </motion.div>
//               <motion.h2
//                 initial={{ opacity: 0, y: 20 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 viewport={{ once: true }}
//                 transition={{ delay: 0.1 }}
//                 className="mb-3 text-3xl font-bold leading-[1.1] tracking-tight sm:text-4xl text-stone-900"
//                 style={SERIF}
//               >
//                 Contact <span className="text-[#DA2128]">Us</span>
//               </motion.h2>
//               <p className="mb-6 text-base leading-relaxed text-[#241A16]/75 font-normal">
//                 For queries related to the {name}, reach out to the secretariat. Our team will respond within 48
//                 hours.
//               </p>

//               {/* ---------- ASSOCHAM HoD / Nodal Officer compact card ---------- */}
//               <motion.div
//                 initial={{ opacity: 0, y: 18 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 viewport={{ once: true }}
//                 transition={{ delay: 0.15 }}
//                 className="w-full max-w-md rounded-2xl border border-stone-100 bg-white p-5 shadow-sm font-sans"
//               >
//                 <div className="space-y-5">
//                   {/* 1. Council / HoD Name */}
//                   <div className="flex items-start gap-3.5">
//                     <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#FDF2F2] text-sm font-bold text-[#C0262D]">
//                       {(hod?.name || defaultHod?.name || 'H').charAt(0).toUpperCase()}
//                     </div>
//                     <div className="min-w-0 flex-1">
//                       <h4 className="text-[14px] font-extrabold text-stone-900 leading-snug">
//                         {hasNamedHod ? 'ASSOCHAM State Head' : 'Council Secretariat'}
//                       </h4>
//                       <p className="text-[14px] font-bold text-[#C0262D]">
//                         {hod?.name || defaultHod.name}
//                       </p>
//                       <p className="text-[12px] text-stone-500">
//                         {hod?.title || `Nodal Officer — ${name}`}
//                       </p>
//                     </div>
//                   </div>

//                   {/* 2. Address Block */}
//                   <div className="flex items-start gap-3.5">
//                     <a
//                       href={mapsUrl(office)}
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="group flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#FDF2F2] text-[#C0262D] transition-colors hover:bg-[#C0262D] hover:text-white"
//                     >
//                       <FaRegBuilding className="h-4 w-4" />
//                     </a>
//                     <div className="min-w-0 flex-1">
//                       <h4 className="text-[14px] font-extrabold text-stone-900 leading-snug">
//                         {office.city ? `Address (${office.city})` : 'Address'}
//                       </h4>
//                       <div className="text-[12.5px] leading-relaxed text-stone-600">
//                         {office.lines.map((line, i) => (
//                           <span key={i} className="block">
//                             {line}
//                           </span>
//                         ))}
//                       </div>
//                     </div>
//                   </div>

//                   {/* 3. Email Block */}
//                   <div className="flex items-start gap-3.5">
//                     <a
//                       href={`mailto:${hodEmail}?subject=${encodeURIComponent(`Query — ${name}`)}`}
//                       className="group flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#FDF2F2] text-[#C0262D] transition-colors hover:bg-[#C0262D] hover:text-white"
//                     >
//                       <FaEnvelope className="h-4 w-4" />
//                     </a>
//                     <div className="min-w-0 flex-1">
//                       <h4 className="text-[14px] font-extrabold text-stone-900 leading-snug">
//                         Email
//                       </h4>
//                       <a
//                         href={`mailto:${hodEmail}?subject=${encodeURIComponent(`Query — ${name}`)}`}
//                         className="block truncate text-[13px] font-bold text-[#C0262D] hover:underline"
//                       >
//                         {hodEmail}
//                       </a>
//                       <p className="text-[11.5px] text-stone-500">
//                         For queries related to {stateLabel || 'Council'}.
//                       </p>
//                     </div>
//                   </div>

//                   {/* 4. Phone Block */}
//                   <div className="flex items-start gap-3.5">
//                     <a
//                       href={`tel:${hodPhoneHref}`}
//                       className="group flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#FDF2F2] text-[#C0262D] transition-colors hover:bg-[#C0262D] hover:text-white"
//                     >
//                       <FaPhone className="h-4 w-4" />
//                     </a>
//                     <div className="min-w-0 flex-1">
//                       <h4 className="text-[14px] font-extrabold text-stone-900 leading-snug">
//                         Phone Number
//                       </h4>
//                       <a
//                         href={`tel:${hodPhoneHref}`}
//                         className="block text-[13px] font-bold text-[#C0262D] hover:underline"
//                       >
//                         {hod?.phone || defaultHod.phone}
//                       </a>
//                       <p className="text-[11.5px] text-stone-500">
//                         Mon–Fri, 9:30 AM – 6:00 PM IST
//                       </p>
//                     </div>
//                   </div>

//                   {/* WhatsApp optional action */}
//                   {hodWaNumber && hasNamedHod && (
//                     <div className="pt-1 pl-[50px]">
//                       <a
//                         href={`https://wa.me/${hodWaNumber}`}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="inline-flex items-center gap-1.5 text-[12px] font-bold text-emerald-600 hover:underline"
//                       >
//                         <FaWhatsapp className="h-3.5 w-3.5" /> WhatsApp
//                       </a>
//                     </div>
//                   )}
//                 </div>
//               </motion.div>
//             </div>

//             {/* Right - Contact form (shared QueryForm component) */}
//             <QueryForm />
//           </div>
//         </div>
//       </section>
//     </main>
//   );
// }

// /* ========================== ANIMATED COUNTER ========================== */

// function CountUp({ value, duration = 1500 }) {
//   const [display, setDisplay] = useState(0);
//   const ref = useRef(null);

//   useEffect(() => {
//     const el = ref.current;
//     if (!el) return;

//     let started = false;
//     const obs = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (!entry.isIntersecting || started) return;
//           started = true;
//           const start = performance.now();
//           const tick = (now) => {
//             const p = Math.min((now - start) / duration, 1);
//             const eased = 1 - Math.pow(1 - p, 3);
//             setDisplay(Math.round(eased * value));
//             if (p < 1) requestAnimationFrame(tick);
//           };
//           requestAnimationFrame(tick);
//         });
//       },
//       { threshold: 0.4 }
//     );

//     obs.observe(el);
//     return () => obs.disconnect();
//   }, [value, duration]);

//   return <span ref={ref}>{display}</span>;
// }

// /* ========================== EVENT CALENDAR BADGE ========================== */
// function StateCalendarBadge({ date, active }) {
//   const { dayPart, monthPart, year } = getDateParts(date);
//   return (
//     <div className="relative mx-auto flex w-[88px] shrink-0 flex-col overflow-hidden rounded-[18px] border border-white/80 bg-white shadow-[0_10px_28px_rgba(219,38,40,0.12)] transition-all duration-500 group-hover:-translate-y-1.5 group-hover:rotate-[-1deg] group-hover:shadow-[0_18px_40px_rgba(219,38,40,0.18)] sm:mx-0">
//       <div className="absolute left-3 top-0 h-2.5 w-2.5 -translate-y-1/2 rounded-full border border-[#DA2128]/30 bg-[#FEF7F4] transition duration-500 group-hover:bg-[#F59C00]" />
//       <div className="absolute right-3 top-0 h-2.5 w-2.5 -translate-y-1/2 rounded-full border border-[#DA2128]/30 bg-[#FEF7F4] transition duration-500 group-hover:bg-[#F59C00]" />
//       <div className="relative bg-gradient-to-br from-white to-[#FAF7F2] px-2.5 py-3 text-center">
//         <div className="font-heading text-[1.55rem] font-black leading-none text-stone-900" style={SERIF}>
//           {dayPart}
//         </div>
//         <div className="mt-1.5 text-[0.65rem] font-extrabold uppercase tracking-[0.22em] text-[#DB6400]">
//           {monthPart}
//         </div>
//       </div>
//       <div
//         className={`relative px-2.5 py-2 text-center text-[0.7rem] font-extrabold tracking-[0.18em] text-white ${
//           active ? 'bg-gradient-to-r from-[#DA2128] to-[#F59C00]' : 'bg-gradient-to-r from-stone-500 to-stone-600'
//         }`}
//       >
//         <span className="relative z-10">{year}</span>
//       </div>
//     </div>
//   );
// }

// /* ========================== EVENT CARD ========================== */
// function StateEventCard({ event, index }) {
//   const active = isEventUpcoming(event.date);
//   const delay = `${Math.min(index * 70, 600)}ms`;
//   return (
//     <article
//       style={{ animationDelay: delay }}
//       className="event-fade-up group relative overflow-hidden rounded-[24px] border border-[#DA2128]/10 bg-white p-4 shadow-[0_12px_32px_rgba(218,33,40,0.07)] transition-all duration-500 hover:-translate-y-1.5 hover:border-[#DA2128]/25 hover:shadow-[0_20px_48px_rgba(218,33,40,0.14)] sm:p-5"
//     >
//       <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(245,156,0,0.12),transparent_32%),radial-gradient(circle_at_bottom_left,rgba(218,33,40,0.1),transparent_35%)] opacity-80 transition-opacity duration-500 group-hover:opacity-100" />
//       <div className="relative flex flex-col gap-4 sm:flex-row sm:items-start">
//         <StateCalendarBadge date={event.date} active={active} />
//         <div className="min-w-0 flex-1 space-y-3">
//           <div className="flex flex-wrap items-center gap-2">
//             <span className="inline-flex rounded-full bg-[#FAF7F2] px-2.5 py-1 text-[0.65rem] font-extrabold uppercase tracking-[0.18em] text-[#DA2128] transition duration-300 group-hover:scale-105">
//               {event.tag || 'Event'}
//             </span>
//             {event.place && (
//               <span className="inline-flex rounded-full border border-[#DB6400]/25 bg-[#FEF7F4] px-2.5 py-1 text-[0.7rem] font-bold text-[#DB6400] transition duration-300 group-hover:-translate-y-0.5">
//                 {event.place}
//               </span>
//             )}
//             {active ? (
//               <span className="event-live-pill inline-flex items-center gap-1.5 rounded-full bg-[#FFF0EC] px-2.5 py-1 text-[0.65rem] font-extrabold uppercase tracking-[0.18em] text-[#DA2128]">
//                 <span className="relative flex h-2 w-2">
//                   <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#DA2128] opacity-75" />
//                   <span className="relative inline-flex h-2 w-2 rounded-full bg-[#DA2128]" />
//                 </span>
//                 Upcoming
//               </span>
//             ) : (
//               <span className="inline-flex items-center gap-1.5 rounded-full border border-stone-300 bg-stone-50 px-2.5 py-1 text-[0.65rem] font-extrabold uppercase tracking-[0.18em] text-stone-500">
//                 Archived
//               </span>
//             )}
//           </div>
//           <h3
//             className="text-[1.05rem] font-extrabold leading-snug text-stone-900 transition-all duration-500 group-hover:translate-x-0.5 group-hover:text-[#DA2128] sm:text-[1.15rem]"
//             style={SERIF}
//           >
//             {event.title}
//           </h3>
//           <p className="text-[13.5px] leading-relaxed text-stone-600">{event.text}</p>
//           {event.highlight && (
//             <div className="flex items-start gap-3 rounded-2xl bg-[#FAF7F2] p-3.5">
//               <FaCheck className="mt-0.5 h-4 w-4 shrink-0 text-[#DA2128]" />
//               <p className="text-[13px] font-medium leading-relaxed text-stone-700">{event.highlight}</p>
//             </div>
//           )}
//           <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
//             <div className="flex items-center gap-2.5 rounded-full bg-[#FFFDFC] px-3 py-1.5 text-[0.8rem] font-semibold text-stone-600 shadow-sm transition duration-300 group-hover:shadow-md">
//               <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-gradient-to-br from-[#DA2128] to-[#F59C00] text-white shadow-[0_6px_14px_rgba(218,33,40,0.22)]">
//                 <FaCalendarAlt className="h-3.5 w-3.5" />
//               </span>
//               <span>{event.date}</span>
//             </div>
//             <button
//               type="button"
//               className="inline-flex w-fit items-center gap-1.5 rounded-full bg-gradient-to-r from-[#DA2128] to-[#F59C00] px-4 py-2 text-[0.8rem] font-bold text-white shadow-[0_10px_22px_rgba(218,33,40,0.22)] transition-all duration-300 hover:scale-[1.03] hover:shadow-[0_14px_28px_rgba(218,33,40,0.3)] active:scale-[0.98]"
//             >
//               {active ? 'Register Interest' : 'View Highlights'}
//             </button>
//           </div>
//         </div>
//       </div>
//     </article>
//   );
// }





// new new code 





import { motion } from 'framer-motion';
import { getRegionBySlug, getCouncilLeadership } from './regionApi'; // <-- added getCouncilLeadership
import { useEffect, useMemo, useRef, useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import {
  FaAward, FaBolt, FaBuilding, FaCalendarAlt, FaCertificate,
  FaChartLine, FaCheck, FaCheckCircle, FaChevronLeft, FaChevronRight,
  FaDownload, FaEnvelope, FaExchangeAlt, FaFileSignature, FaGlobeAsia,
  FaHandshake, FaHome, FaIndustry, FaLandmark, FaLaptopCode, FaLightbulb,
  FaMapMarkerAlt, FaMoneyBillWave, FaPaperPlane, FaPeopleArrows,
  FaPhone, FaPills, FaRocket, FaRss, FaSearch, FaSeedling, FaSlidersH,
  FaTag, FaTimes, FaUniversity, FaUserTie, FaWhatsapp, FaDirections,
  FaRegBuilding, FaArrowUp,
} from 'react-icons/fa';
import {
  statesData,
  stateNames,
  defaultOverview,
  defaultInitiatives,
  defaultPriorities,
  getStateHod,
  defaultHod,
  getStateOffice,
  defaultOffice,
} from './statesData';
import CouncilLeadership from './CouncilLeadership.jsx';
import QueryForm from '../components/Sectors/QueryForm.jsx';

// ---- constants ----
const heroImage = 'https://images.pexels.com/photos/17585996/pexels-photo-17585996.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200';
const overviewDefaultImg = 'https://images.pexels.com/photos/3183197/pexels-photo-3183197.jpeg?auto=compress&cs=tinysrgb&w=1200';

const mandates = [
  {
    title: 'Policy Advocacy',
    text: 'Public policy, regulatory reforms and Ease of Doing Business inputs with Central and State Governments.',
    icon: FaLandmark,
  },
  {
    title: 'Industry Competitiveness',
    text: 'Focused support for manufacturing, MSMEs, infrastructure, green growth and business competitiveness.',
    icon: FaChartLine,
  },
  {
    title: 'Stakeholder Platform',
    text: 'Conferences, seminars, business forums and government-industry interactions across the state.',
    icon: FaPeopleArrows,
  },
];

const services = [
  { label: 'Investment facilitation', icon: FaBuilding },
  { label: 'Certificate of Origin service', icon: FaCertificate },
  { label: 'Overseas delegation support', icon: FaGlobeAsia },
  { label: 'Sector-specific MoU facilitation', icon: FaFileSignature },
  { label: 'Industry academia connect', icon: FaUniversity },
  { label: 'Local chamber collaboration', icon: FaHandshake },
];

const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  visible: { opacity: 1, y: 0 },
};

const HERO_CONTAINER = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12, delayChildren: 0.15 } },
};

const HERO_ITEM = {
  hidden: { opacity: 0, y: 30 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.75, ease: [0.22, 1, 0.36, 1] },
  },
};

// sector icon mapping
const sectorIconRules = [
  [/agro|food|fisher/i, FaSeedling],
  [/renewable|energy|power/i, FaBolt],
  [/start-?up/i, FaRocket],
  [/intellectual|ipr/i, FaLightbulb],
  [/tax/i, FaMoneyBillWave],
  [/it\b|ites|e-commerce|digital|electronics|esdm/i, FaLaptopCode],
  [/msme|manufactur|mining|industr|engineering/i, FaIndustry],
  [/pharma|health|medical/i, FaPills],
  [/tourism|aviation|aerospace|hospitality/i, FaGlobeAsia],
  [/logistic|warehous|export/i, FaExchangeAlt],
];

function iconForSector(name) {
  const match = sectorIconRules.find(([regex]) => regex.test(name));
  return match ? match[1] : FaIndustry;
}

function toTitleCase(slug) {
  return slug
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

// ---- date helpers ----
function getDateParts(dateStr = '') {
  const parts = dateStr.split(' ');
  const dayPart = parts[0] || '--';
  const restPart = parts.slice(1).join(' ');
  const monthPart = (restPart.split(',')[0] || '').split('-')[0].trim();
  const yearMatch = dateStr.match(/(20\d{2})/);
  const year = yearMatch ? yearMatch[1] : '2026';
  return { dayPart, monthPart, year };
}

function toDateObj(dateStr = '') {
  const { dayPart, monthPart, year } = getDateParts(dateStr);
  const cleanDay = dayPart.replace(/[^0-9]/g, '') || '1';
  const d = new Date(`${monthPart} ${cleanDay}, ${year}`);
  return isNaN(d.getTime()) ? null : d;
}

function isEventUpcoming(dateStr) {
  const d = toDateObj(dateStr);
  if (!d) return true;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return d.getTime() >= today.getTime();
}

function toTimestamp(dateStr = '') {
  const d = toDateObj(dateStr);
  return d ? d.getTime() : 0;
}

// ---- contact helpers ----
function telHref(phone = '') {
  const digits = String(phone).replace(/[^\d+]/g, '');
  if (!digits) return '';
  return digits.startsWith('+') ? digits : `+91${digits.replace(/^0+/, '')}`;
}

function whatsappHref(phone = '') {
  const digits = String(phone).replace(/\D/g, '');
  if (!digits) return '';
  return digits.length === 10 ? `91${digits}` : digits;
}

function mapsUrl(office) {
  if (office?.mapUrl) return office.mapUrl;
  const q = office?.mapQuery || (office?.lines || []).join(' ');
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;
}

// ---- default fallbacks ----
const defaultPublications = [];
const defaultPressReleases = [];
const defaultPressCoverage = [];
const defaultEvents = [];

const defaultStateContent = {
  focusItems: ['Viksit Bharat 2047', 'Ease of Doing Business', 'Sustainable Development'],
  intro: 'A focused ASSOCHAM platform strengthening the state’s industrial ecosystem through policy advocacy, investment engagement, MSME growth, infrastructure dialogue, and sustainable development.',
  why: 'This council works closely with the Government and industry stakeholders to advance policy clarity, sector action and long-term competitiveness for the state. Detailed content for this council is coming soon.',
  overview: defaultOverview,
  sectors: [],
  leadership: [],
  initiatives: [],
  priorities: [],
  publications: [],
  pressReleases: [],
  pressCoverage: [],
  events: [],
};

const SERIF = {
  fontFamily: 'Fraunces, Georgia, "Times New Roman", serif',
};

// ---- Breadcrumb ----
function StateBreadcrumb({ stateLabel }) {
  return (
    <nav
      aria-label="Breadcrumb"
      className="absolute left-4 top-4 z-20 hidden sm:left-8 sm:top-6 sm:block"
    >
      <ol className="flex flex-wrap items-center gap-2 rounded-full border border-white/15 bg-white/80 px-4 py-2 text-[11px] font-bold uppercase tracking-wide text-[#141419] shadow-lg shadow-black/10 backdrop-blur-md">
        <li>
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 transition-colors hover:text-[#DA2128]"
          >
            <svg
              viewBox="0 0 24 24"
              className="h-3.5 w-3.5"
              fill="none"
              stroke="currentColor"
              strokeWidth={2.2}
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M3 10.5 12 3l9 7.5" />
              <path d="M5 10v10h14V10" />
              <path d="M9 20v-6h6v6" />
            </svg>
            Home
          </Link>
        </li>
        <li className="text-black/30">&rsaquo;</li>
        <li>
          <Link to="/states" className="transition-colors hover:text-[#DA2128]">
            States
          </Link>
        </li>
        <li className="text-black/30">&rsaquo;</li>
        <li className="rounded-full bg-[#DA2128] px-3 py-1 text-white">{stateLabel}</li>
      </ol>
    </nav>
  );
}

// ========================== MAIN COMPONENT ==========================
export default function StatePage() {
  // ---- Route slug ----
  const { stateSlug } = useParams();
  const location = useLocation();
  const slug = stateSlug || location.pathname.replace(/^\//, '');
  const data = statesData[slug] || defaultStateContent;

  const name = data.name || `${stateNames[slug] || toTitleCase(slug)} State Development Council`;
  const stateLabel = stateNames[slug] || toTitleCase(slug || 'State');
  const overviewParagraphs = data.overview && data.overview.length > 0 ? data.overview : defaultOverview;
  const initiatives = data.initiatives && data.initiatives.length > 0 ? data.initiatives : defaultInitiatives;
  const priorities = data.priorities && data.priorities.length > 0 ? data.priorities : defaultPriorities;
  const PUBLICATIONS = data.publications || defaultPublications;
  const PRESS_RELEASES = data.pressReleases || defaultPressReleases;
  const PRESS_COVERAGE = data.pressCoverage || defaultPressCoverage;
  const EVENTS = data.events || defaultEvents;

  // ---- State HoD & Office (static) ----
  const hod = useMemo(() => getStateHod(slug), [slug]);
  const hasNamedHod = Boolean(hod && hod.name && hod.name !== defaultHod.name);
  const hodPhoneHref = telHref(hod?.phone || defaultHod.phone);
  const hodWaNumber = whatsappHref(hod?.phone || '');
  const hodEmail = hod?.email || defaultHod.email;
  const office = useMemo(() => getStateOffice(slug), [slug]);
  const officePhone = office.phone || defaultOffice.phone;
  const officePhoneHref = office.phoneHref || `tel:${telHref(officePhone)}`;
  const officeEmail = office.email || defaultOffice.email;

  // ---- UI state (events, press, scroll) ----
  const [eventTab, setEventTab] = useState('all');
  const [eventKeyword, setEventKeyword] = useState('');
  const [eventTag, setEventTag] = useState('');
  const [eventPlace, setEventPlace] = useState('');
  const [eventAnimKey, setEventAnimKey] = useState(0);
  const [eventsVisible, setEventsVisible] = useState(2);
  const EVENTS_STEP = 2;

  const [pressTab, setPressTab] = useState('releases');
  const [pressKeyword, setPressKeyword] = useState('');
  const [pressSort, setPressSort] = useState('newest');
  const [pressPage, setPressPage] = useState(1);
  const pressResultsRef = useRef(null);
  const PRESS_PAGE_SIZE = 5;

  const [submitted, setSubmitted] = useState(false);
  const [progress, setProgress] = useState(0);

  // ---- Data from API ----
  const [regionData, setRegionData] = useState(null);
  // const [leadershipData, setLeadershipData] = useState([]); // <-- new state for leadership

  // // ---- Fetch region data and leadership ----
  // useEffect(() => {
  //   let active = true;
  //   async function fetchData() {
  //     try {
  //       // Fetch region details
  //       const region = await getRegionBySlug(slug);
  //       if (active && region) setRegionData(region);

  //       // Fetch leadership
  //       const leaders = await getCouncilLeadership(slug);
  //       if (active && leaders.length) setLeadershipData(leaders);
  //     } catch (error) {
  //       console.error('Error fetching data:', error);
  //     }
  //   }
  //   fetchData();
  //   return () => { active = false; };
  // }, [slug]);

  // // ---- Build final leadership list: API data if available, else static data ----
  // const finalLeadership = leadershipData.length > 0 ? leadershipData : data.leadership;

  const [leadershipData, setLeadershipData] = useState([]);

useEffect(() => {
  let active = true;
  async function fetchData() {
    try {
      const region = await getRegionBySlug(slug);
      if (active && region) setRegionData(region);

      const leaders = await getCouncilLeadership(slug);
      if (active && leaders.length) setLeadershipData(leaders);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  fetchData();
  return () => { active = false; };
}, [slug]);

const finalLeadership = leadershipData.length > 0 ? leadershipData : data.leadership;

  // ---- Scroll progress ----
  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(h > 0 ? (window.scrollY / h) * 100 : 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToOverview = (e) => {
    e?.preventDefault();
    document.getElementById('overview')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  // ---- Press logic ----
  const pressSource = pressTab === 'releases' ? PRESS_RELEASES : PRESS_COVERAGE;
  const pressFiltered = useMemo(() => {
    const kw = pressKeyword.trim().toLowerCase();
    let list = pressSource.filter((item) => {
      if (!kw) return true;
      const hay = `${item.title} ${item.excerpt || ''}`.toLowerCase();
      return hay.includes(kw);
    });
    list = [...list].sort((a, b) => {
      const ta = toTimestamp(a.date);
      const tb = toTimestamp(b.date);
      return pressSort === 'newest' ? tb - ta : ta - tb;
    });
    return list;
  }, [pressSource, pressKeyword, pressSort]);

  useEffect(() => setPressPage(1), [pressTab, pressKeyword, pressSort]);

  const pressTotalPages = Math.max(1, Math.ceil(pressFiltered.length / PRESS_PAGE_SIZE));
  const pressClampedPage = Math.min(pressPage, pressTotalPages);
  const pressStart = (pressClampedPage - 1) * PRESS_PAGE_SIZE;
  const pressPageItems = pressFiltered.slice(pressStart, pressStart + PRESS_PAGE_SIZE);

  const scrollToPressResults = () =>
    pressResultsRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });

  const changePressPage = (n) => {
    setPressPage(n);
    scrollToPressResults();
  };

  // ---- Hero image & overview ----
  const heroImageFinal = regionData?.header_banner_img || heroImage;
  const overviewImageFinal = regionData?.image || data.overviewImage || overviewDefaultImg;
  const overviewTitleFinal = regionData?.title || name;
  const overviewTextFinal = regionData?.long_description
    ? [regionData.long_description]
    : overviewParagraphs;

  // ---- Events filters ----
  const eventTags = useMemo(
    () => Array.from(new Set(EVENTS.map((e) => e.tag).filter(Boolean))),
    [EVENTS]
  );
  const eventPlaces = useMemo(
    () => Array.from(new Set(EVENTS.map((e) => e.place).filter(Boolean))),
    [EVENTS]
  );
  const filteredEvents = useMemo(() => {
    const kw = eventKeyword.trim().toLowerCase();
    return EVENTS.filter((e) => {
      const upcoming = isEventUpcoming(e.date);
      if (eventTab === 'forthcoming' && !upcoming) return false;
      if (eventTab === 'past' && upcoming) return false;
      if (eventTag && e.tag !== eventTag) return false;
      if (eventPlace && e.place !== eventPlace) return false;
      if (kw) {
        const hay = `${e.title} ${e.text} ${e.tag || ''} ${e.place || ''}`.toLowerCase();
        if (!hay.includes(kw)) return false;
      }
      return true;
    });
  }, [eventTab, eventTag, eventPlace, eventKeyword, EVENTS]);

  useEffect(() => {
    setEventAnimKey((k) => k + 1);
  }, [eventTab, eventTag, eventPlace]);

  useEffect(() => {
    setEventsVisible(2);
  }, [eventTab, eventTag, eventPlace, eventKeyword]);

  const clearEventFilters = () => {
    setEventKeyword('');
    setEventTag('');
    setEventPlace('');
    setEventTab('all');
    setEventAnimKey((k) => k + 1);
  };

  const visibleEvents = filteredEvents.slice(0, eventsVisible);
  const hasMoreEvents = eventsVisible < filteredEvents.length;
  const loadMoreEvents = () =>
    setEventsVisible((v) => Math.min(v + EVENTS_STEP, filteredEvents.length));

  // ---- Contact form ----
  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    window.setTimeout(() => setSubmitted(false), 5000);
  };

  const sectionEyebrow = (label, color = '#DB6400') => (
    <p className="text-xs font-semibold uppercase tracking-[0.35em]" style={{ color }}>
      {label}
    </p>
  );

  // ---- Render ----
  return (
    <main className="min-h-screen overflow-hidden bg-[#FAF7F2] text-[#241A16] selection:bg-[#DA2128] selection:text-white">
      <style>{`
        html { scroll-behavior: smooth; }
        ::selection { background:#DA2128; color:#fff; }
        ::-webkit-scrollbar { width:10px; height:10px; }
        ::-webkit-scrollbar-track { background:#FEF7F4; }
        ::-webkit-scrollbar-thumb { background:linear-gradient(#DA2128,#DB6400); border-radius:9999px; }
        .event-fade-up { animation: st-fade-up 0.6s cubic-bezier(.2,.8,.2,1) both; }
        @keyframes st-fade-up { 0% { opacity: 0; transform: translateY(22px); } 100% { opacity: 1; transform: translateY(0); } }
        .event-live-pill { animation: st-pulse-glow 2.4s infinite; }
        @keyframes st-pulse-glow { 0%, 100% { box-shadow: 0 0 0 0 rgba(245,156,0,0.3); } 50% { box-shadow: 0 0 0 10px rgba(245,156,0,0); } }
        @keyframes st-float { 0%,100%{transform:translateY(0) rotate(0)} 50%{transform:translateY(-16px) rotate(3deg)} }
        @keyframes st-float-slow { 0%,100%{transform:translate(0,0)} 50%{transform:translate(10px,-22px)} }
        @keyframes st-blob { 0%,100%{border-radius:62% 38% 46% 54% / 55% 48% 52% 45%} 50%{border-radius:42% 58% 66% 34% / 38% 62% 38% 62%} }
        @keyframes st-pulse-ring { 0%{transform:scale(.85);opacity:.7} 70%{transform:scale(1.5);opacity:0} 100%{opacity:0} }
        @keyframes st-kenburns { 0%{transform:scale(1.02) translate(0,0)} 100%{transform:scale(1.16) translate(1.2%,-1.2%)} }
        @keyframes st-scroll-dot { 0%{transform:translateY(0);opacity:.9} 70%{transform:translateY(14px);opacity:0} 100%{transform:translateY(0);opacity:0} }
        @keyframes st-pub-slide { 0%,100%{background-position:0% 50%} 50%{background-position:100% 50%} }
        @keyframes st-shine { 0%{transform:translateX(-120%) skewX(-20deg)} 60%,100%{transform:translateX(240%) skewX(-20deg)} }
        .anim-st-float{animation:st-float 7s ease-in-out infinite}
        .anim-st-float-slow{animation:st-float-slow 11s ease-in-out infinite}
        .anim-st-blob{animation:st-blob 14s ease-in-out infinite}
        .anim-st-pulse-ring{animation:st-pulse-ring 2.6s cubic-bezier(.22,.61,.36,1) infinite}
        .anim-st-kenburns{animation:st-kenburns 26s ease-in-out infinite alternate;will-change:transform}
        .anim-st-scroll-dot{animation:st-scroll-dot 1.8s cubic-bezier(.45,.05,.55,.95) infinite}
        .st-pub-card-bg{background:linear-gradient(120deg,#DA2128 0%,#C81E24 18%,#DB6400 42%,#F59C00 62%,#DB6400 82%,#DA2128 100%);background-size:300% 100%;animation:st-pub-slide 9s ease-in-out infinite}
        .st-shine-parent{position:relative;overflow:hidden}
        .st-shine-parent::after{content:"";position:absolute;top:0;bottom:0;left:0;width:45%;background:linear-gradient(90deg,transparent,rgba(255,255,255,.45),transparent);transform:translateX(-120%) skewX(-20deg)}
        .st-shine-parent:hover::after{animation:st-shine 1s ease-out}
        .font-heading { font-family: 'Fraunces', Georgia, serif; }
        .sector-section { scroll-margin-top: 2rem; }
        @media (prefers-reduced-motion: reduce){*,*::before,*::after{animation-duration:.001ms!important;animation-iteration-count:1!important;transition-duration:.001ms!important}}
      `}</style>

      {/* Scroll progress bar */}
      <div className="fixed inset-x-0 top-0 z-[60] h-1">
        <div
          className="h-full bg-gradient-to-r from-[#DA2128] via-[#DB6400] to-[#F59C00] transition-[width] duration-150"
          style={{ width: `${progress}%` }}
        />
      </div>

      {/* Back to top */}
      <button
        type="button"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        aria-label="Back to top"
        className={`fixed bottom-7 right-7 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-[#DA2128] text-white shadow-xl shadow-[#DA2128]/35 transition-all duration-300 hover:-translate-y-1 hover:bg-[#DB6400] ${
          progress > 8 ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-6 opacity-0'
        }`}
      >
        <FaArrowUp className="h-4 w-4" />
      </button>

      {/* ==================== HERO ==================== */}
      <section id="top" className="relative isolate flex min-h-[70vh] flex-col overflow-hidden bg-stone-900">
        <div className="absolute inset-0">
          <img
            src={heroImageFinal}
            alt={`${name} banner`}
            className="anim-st-kenburns h-full w-full object-cover brightness-[1.25] saturate-[1.05]"
          />
          <div className="absolute inset-0 bg-black/20" />
          <div className="absolute inset-0 bg-[radial-gradient(60%_50%_at_50%_45%,rgba(0,0,0,0.45),transparent_75%)]" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-black/30" />
        </div>

        <motion.div
          aria-hidden="true"
          className="pointer-events-none absolute -right-32 -top-40 h-[26rem] w-[26rem] rounded-full border-[40px] border-[#F59C00]/20"
          animate={{ rotate: 360 }}
          transition={{ duration: 35, repeat: Infinity, ease: 'linear' }}
        />
        <div className="anim-st-blob anim-st-float pointer-events-none absolute -left-24 bottom-10 h-72 w-72 bg-[#DA2128]/25 blur-3xl" />
        <div className="anim-st-blob anim-st-float-slow pointer-events-none absolute right-[12%] top-[18%] h-64 w-64 bg-[#F59C00]/20 blur-3xl" />
        <div className="anim-st-pulse-ring pointer-events-none absolute right-[16%] top-[30%] h-24 w-24 rounded-full border border-white/20" />
        <div className="anim-st-pulse-ring pointer-events-none absolute left-[11%] top-[42%] h-14 w-14 rounded-full border border-[#F59C00]/40" />

        <StateBreadcrumb stateLabel={stateLabel} />

        <motion.div
          variants={HERO_CONTAINER}
          initial="hidden"
          animate="show"
          className="relative z-10 mx-auto flex w-full max-w-7xl flex-1 flex-col items-center justify-center px-6 py-24 text-center"
        >
          <motion.div variants={HERO_ITEM}>
            <span className="inline-flex items-center gap-2.5 rounded-full border border-white/25 bg-white/10 px-5 py-2 text-[10.5px] font-bold uppercase tracking-[0.28em] text-white shadow-lg backdrop-blur-md">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#F59C00] opacity-80" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-[#F59C00]" />
              </span>
              Industry Policy Forum
            </span>
          </motion.div>

          <motion.h1
            variants={HERO_ITEM}
            style={SERIF}
            className="mt-7 max-w-4xl text-3xl font-medium leading-[1.12] tracking-tight text-white drop-shadow-[0_4px_24px_rgba(0,0,0,0.35)] md:text-5xl lg:text-6xl"
          >
            {overviewTitleFinal}
          </motion.h1>

          <motion.div variants={HERO_ITEM} className="mt-8 flex items-center justify-center gap-3">
            <span className="h-px w-16 bg-gradient-to-r from-transparent to-white/70" />
            <motion.span
              animate={{ rotate: 360 }}
              transition={{ duration: 14, repeat: Infinity, ease: 'linear' }}
              className="h-2.5 w-2.5 rotate-45 bg-gradient-to-br from-[#F59C00] to-[#DA2128]"
            />
            <span className="h-px w-16 bg-gradient-to-l from-transparent to-white/70" />
          </motion.div>

          <motion.div variants={HERO_ITEM} className="mt-12">
            <button
              type="button"
              onClick={scrollToOverview}
              aria-label="Scroll to overview"
              className="flex flex-col items-center gap-1.5 text-white/60 transition-colors duration-300 hover:text-white"
            >
              <span className="text-[9px] font-extrabold uppercase tracking-[0.34em]">Scroll</span>
              <span className="flex h-9 w-[22px] items-start justify-center rounded-full border-2 border-white/40 p-1">
                <span className="anim-st-scroll-dot h-2 w-[5px] rounded-full bg-gradient-to-b from-[#F59C00] to-[#DA2128]" />
              </span>
            </button>
          </motion.div>
        </motion.div>
      </section>

      {/* ==================== OVERVIEW ==================== */}
      <section
        id="overview"
        className="sector-section relative z-10 -mt-10 scroll-mt-6 rounded-t-[44px] bg-white py-16 lg:py-24"
      >
        <div className="relative mx-auto max-w-7xl px-6 lg:px-12">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeUp}
            className="mb-8 w-full lg:float-left lg:mb-8 lg:mr-10 lg:w-[340px]"
          >
            <div className="relative">
              <div className="overflow-hidden rounded-[28px] border-4 border-white bg-white shadow-2xl shadow-stone-900/15">
                <img
                  src={overviewImageFinal}
                  alt={name}
                  className="h-[360px] w-full object-cover transition-transform duration-[1400ms] hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="anim-st-float absolute -bottom-6 -right-3 w-56 rounded-2xl border border-stone-100 bg-white p-4 shadow-2xl">
                <p className="text-[11px] font-extrabold uppercase tracking-[0.2em] text-[#DA2128]">
                  State Council
                </p>
                <p className="mt-1 text-[14.5px] font-bold leading-snug text-stone-900" style={SERIF}>
                  {name}
                </p>
              </div>
              <div className="anim-st-float-slow absolute -left-5 -top-6 hidden w-32 overflow-hidden rounded-2xl border-4 border-white shadow-xl sm:block">
                <div className="st-pub-card-bg flex h-20 w-full items-center justify-center text-white">
                  <FaIndustry className="h-6 w-6 opacity-90" />
                </div>
              </div>
            </div>
          </motion.div>

          <p className="text-xs font-semibold uppercase tracking-[0.35em] text-[#DB6400]">Overview</p>
          <h2
            className="mt-3 text-2xl font-medium leading-[1.25] tracking-tight text-[#241A16] md:text-4xl"
            style={SERIF}
          >
            {/* Shaping India&apos;s{' '} */}
            <span className="text-[#DA2128]">
              {name.replace(/State (Development )?Council/i, '').trim()}
            </span>
          </h2>

          <div className="mt-6 space-y-4 border-l-2 border-[#DA2128]/20 pl-5">
            {regionData?.long_description ? (
              <div
                className="prose prose-stone max-w-none text-[15.5px] leading-relaxed text-stone-600 [&_p]:mb-4"
                dangerouslySetInnerHTML={{ __html: regionData.long_description }}
              />
            ) : (
              overviewParagraphs.map((p, i) => (
                <motion.p
                  key={i}
                  initial={{ opacity: 0, x: 15 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.1 + i * 0.08 }}
                  className="text-[15.5px] leading-relaxed text-stone-600"
                >
                  {i === 0 && p.includes('ASSOCHAM') ? (
                    <>
                      <span className="font-bold text-stone-900">ASSOCHAM</span>
                      {p.replace('ASSOCHAM', '')}
                    </>
                  ) : (
                    p
                  )}
                </motion.p>
              ))
            )}
          </div>

          {data.sectors && data.sectors.length > 0 && (
            <div className="mt-8 grid gap-3 sm:grid-cols-2">
              {data.sectors.slice(0, 6).map((sectorName, i) => (
                <div
                  key={i}
                  className="flex items-start gap-2.5 rounded-2xl bg-[#FAF7F2] p-3.5 ring-1 ring-stone-200 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-[#DA2128]/5 hover:ring-[#DA2128]/30"
                >
                  <FaCheck className="mt-1 h-3.5 w-3.5 shrink-0 text-[#DA2128]" />
                  <p className="text-[13px] font-medium leading-relaxed text-stone-700">{sectorName}</p>
                </div>
              ))}
            </div>
          )}
          <div className="clear-both" />
        </div>
      </section>

      {/* ==================== COUNCIL LEADERSHIP ==================== */}
      <section
        id="councils"
        className="sector-section relative scroll-mt-6 overflow-hidden bg-white py-20 lg:py-24"
      >
        <div className="pointer-events-none absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-[#FAF7F2] to-transparent" />
        <div className="anim-st-blob anim-st-float-slow pointer-events-none absolute -right-32 bottom-0 h-80 w-80 bg-[#F59C00]/10 blur-3xl" />
        <div className="relative mx-auto max-w-7xl px-6 lg:px-12">
          <div className="mb-2">
            <p className="text-xs font-semibold uppercase tracking-[0.35em] text-[#DB6400]">Councils</p>
            <h2
              className="mt-3 text-2xl font-medium leading-[1.25] tracking-tight text-[#241A16] md:text-4xl"
              style={SERIF}
            >
              Council Leadership
            </h2>
          </div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            {/* Use finalLeadership (API data if available, else static) */}
            <CouncilLeadership members={finalLeadership} councilName={name} />
          </motion.div>
        </div>
      </section>

      {/* ==================== SECTORS ==================== */}
      {data.sectors && data.sectors.length > 0 && (
        <section id="sectors" className="relative bg-[#FEF7F4] py-16 lg:py-20">
          <div className="mx-auto max-w-7xl px-6 lg:px-12">
            <div className="mb-12 flex flex-col justify-between gap-6 md:flex-row md:items-end">
              <div>
                <p className="text-xs font-semibold uppercase tracking-[0.35em] text-[#DB6400]">Sectoral Engine</p>
                <h2
                  className="mt-3 text-2xl font-medium leading-[1.25] tracking-tight text-[#241A16] md:text-4xl"
                  style={SERIF}
                >
                  Focused committees for focused outcomes.
                </h2>
              </div>
              <p className="max-w-md text-sm leading-relaxed text-[#241A16]/75 font-normal">
                Sector sub-committees help convert member inputs into state-specific policy recommendations,
                promotion opportunities and business interactions.
              </p>
            </div>
            <div className="grid border-t border-l border-[#241A16]/10 sm:grid-cols-2 lg:grid-cols-4">
              {data.sectors.map((sectorName, index) => {
                const Icon = iconForSector(sectorName);
                return (
                  <motion.div
                    key={sectorName}
                    className="group relative flex min-h-[160px] flex-col justify-between border-r border-b border-[#241A16]/10 bg-white/60 p-6 transition-all duration-300 hover:bg-[#DA2128]"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.04 }}
                  >
                    <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-[#DA2128]/10 text-[#DA2128] transition-all duration-300 group-hover:bg-white/20 group-hover:text-white group-hover:scale-105">
                      <Icon className="text-xl" />
                    </div>
                    <p
                      className="mt-6 text-base font-medium tracking-tight text-[#241A16] transition-colors duration-300 group-hover:text-white"
                      style={SERIF}
                    >
                      {sectorName}
                    </p>
                  </motion.div>
                );
              })}
            </div>
          </div>
        </section>
      )}

      {/* ==================== EVENTS ==================== */}
      <section id="events" className="relative scroll-mt-20 overflow-hidden bg-white py-16 lg:py-20">
        <div className="pointer-events-none absolute -right-24 top-10 h-72 w-72 rounded-full bg-[#F59C00]/10 blur-3xl" />
        <div className="pointer-events-none absolute -left-24 bottom-0 h-72 w-72 rounded-full bg-[#DA2128]/10 blur-3xl" />
        <div className="relative mx-auto max-w-7xl px-6 lg:px-12">
          <div className="mb-10 max-w-2xl">
            {sectionEyebrow('Engagements & Events', '#DB6400')}
            <h2
              className="mt-3 text-2xl font-medium leading-[1.25] tracking-tight text-[#241A16] md:text-4xl"
              style={SERIF}
            >
              Recent &amp; Upcoming Initiatives
            </h2>
          </div>
          <div className="grid gap-6 lg:grid-cols-[300px_minmax(0,1fr)] xl:grid-cols-[320px_minmax(0,1fr)]">
            {/* Sidebar */}
            <motion.aside
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="rounded-[26px] border border-[#DA2128]/10 bg-[#FAF7F2] p-5 shadow-[0_18px_44px_rgba(218,33,40,0.08)] lg:sticky lg:top-24 lg:h-fit"
            >
              <div className="mb-5 flex items-center justify-between border-b border-[#DA2128]/10 pb-3.5">
                <div>
                  <p className="text-[0.7rem] font-semibold uppercase tracking-[0.22em] text-[#DB6400]">Filter by</p>
                  <h3 className="mt-1 text-xl font-bold text-stone-900" style={SERIF}>Events Search</h3>
                </div>
                <div className="rounded-xl bg-gradient-to-br from-[#FFE3DA] to-[#FFE7CF] p-2 text-[#DA2128]">
                  <FaSlidersH className="h-4 w-4" />
                </div>
              </div>
              <div className="space-y-3.5">
                <div className="space-y-1.5">
                  <label className="text-[0.8rem] font-bold text-stone-700">Keywords</label>
                  <div className="relative">
                    <FaSearch className="pointer-events-none absolute left-3.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-[#DA2128]" />
                    <input
                      type="text"
                      value={eventKeyword}
                      onChange={(e) => setEventKeyword(e.target.value)}
                      placeholder="Search by title, place..."
                      className="w-full rounded-xl border border-[#DA2128]/10 bg-white py-2.5 pl-10 pr-3.5 text-[0.8rem] font-medium text-stone-700 transition duration-300 placeholder:text-stone-400 hover:border-[#DA2128]/30 focus:border-[#DA2128] focus:outline-none focus:ring-2 focus:ring-[#DA2128]/10"
                    />
                  </div>
                </div>
                <div className="space-y-1.5">
                  <label className="text-[0.8rem] font-bold text-stone-700">Status</label>
                  <div className="flex gap-1.5 rounded-xl border border-[#DA2128]/10 bg-white p-1">
                    {[
                      ['all', 'All'],
                      ['forthcoming', 'Upcoming'],
                      ['past', 'Past'],
                    ].map(([v, l]) => (
                      <button
                        key={v}
                        type="button"
                        onClick={() => setEventTab(v)}
                        className={`flex-1 rounded-lg px-2 py-2 text-[0.75rem] font-bold transition duration-300 ${
                          eventTab === v
                            ? 'bg-gradient-to-r from-[#DA2128] to-[#F59C00] text-white shadow-md'
                            : 'text-stone-500 hover:bg-[#FAF7F2]'
                        }`}
                      >
                        {l}
                      </button>
                    ))}
                  </div>
                </div>
                {eventTags.length > 0 && (
                  <div className="space-y-1.5">
                    <label className="text-[0.8rem] font-bold text-stone-700">Category</label>
                    <div className="relative">
                      <FaTag className="pointer-events-none absolute left-3.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-[#DA2128]" />
                      <select
                        value={eventTag}
                        onChange={(e) => setEventTag(e.target.value)}
                        className="w-full appearance-none rounded-xl border border-[#DA2128]/10 bg-white py-2.5 pl-10 pr-9 text-[0.8rem] font-medium text-stone-700 transition duration-300 hover:border-[#DA2128]/30 focus:border-[#DA2128] focus:outline-none focus:ring-2 focus:ring-[#DA2128]/10"
                      >
                        <option value="">All categories</option>
                        {eventTags.map((t) => (
                          <option key={t} value={t}>{t}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}
                {eventPlaces.length > 0 && (
                  <div className="space-y-1.5">
                    <label className="text-[0.8rem] font-bold text-stone-700">Location</label>
                    <div className="relative">
                      <FaMapMarkerAlt className="pointer-events-none absolute left-3.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-[#DA2128]" />
                      <select
                        value={eventPlace}
                        onChange={(e) => setEventPlace(e.target.value)}
                        className="w-full appearance-none rounded-xl border border-[#DA2128]/10 bg-white py-2.5 pl-10 pr-9 text-[0.8rem] font-medium text-stone-700 transition duration-300 hover:border-[#DA2128]/30 focus:border-[#DA2128] focus:outline-none focus:ring-2 focus:ring-[#DA2128]/10"
                      >
                        <option value="">All locations</option>
                        {eventPlaces.map((p) => (
                          <option key={p} value={p}>{p}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}
              </div>
              <button
                type="button"
                onClick={clearEventFilters}
                className="mt-5 inline-flex w-full items-center justify-center gap-1.5 rounded-xl border border-[#DA2128]/20 bg-white px-4 py-2.5 text-[0.8rem] font-bold text-[#DA2128] transition duration-300 hover:bg-[#FEF7F4]"
              >
                <FaTimes className="h-3.5 w-3.5" />
                Clear filters
              </button>
            </motion.aside>
            {/* Main list */}
            <div>
              <div className="flex flex-wrap items-center justify-between gap-3 pb-5">
                <span className="text-[12.5px] font-semibold text-stone-500">
                  {filteredEvents.length === 0
                    ? EVENTS.length === 0
                      ? 'No events published yet for this council'
                      : 'No events match your filters'
                    : `Showing ${Math.min(eventsVisible, filteredEvents.length)} of ${filteredEvents.length} event${
                        filteredEvents.length > 1 ? 's' : ''
                      }`}
                </span>
              </div>
              <div key={eventAnimKey} className="grid gap-6">
                {filteredEvents.length === 0 ? (
                  <div className="rounded-[24px] border border-dashed border-[#DA2128]/25 bg-[#FAF7F2] p-10 text-center">
                    <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-gradient-to-br from-[#DA2128] to-[#F59C00] text-white shadow-lg shadow-[#DA2128]/25">
                      <FaSearch className="h-6 w-6" />
                    </div>
                    <h4 className="mt-4 text-lg font-bold text-stone-900" style={SERIF}>
                      {EVENTS.length === 0 ? 'No engagements published yet' : 'No matching events found'}
                    </h4>
                    <p className="mx-auto mt-2 max-w-sm text-[13px] leading-relaxed text-stone-500">
                      {EVENTS.length === 0
                        ? "Check back soon for this council's upcoming and past engagements."
                        : 'Try clearing a filter or switching the status tab to see more initiatives.'}
                    </p>
                    {EVENTS.length > 0 && (
                      <button
                        type="button"
                        onClick={clearEventFilters}
                        className="mt-5 inline-flex items-center gap-1.5 rounded-full bg-gradient-to-r from-[#DA2128] to-[#F59C00] px-5 py-2.5 text-[12.5px] font-bold text-white shadow-lg shadow-[#DA2128]/25 transition hover:shadow-[#DA2128]/40"
                      >
                        Reset all filters
                      </button>
                    )}
                  </div>
                ) : (
                  visibleEvents.map((event, i) => (
                    <StateEventCard key={`${event.title}-${eventAnimKey}-${i}`} event={event} index={i} />
                  ))
                )}
              </div>
              {hasMoreEvents && (
                <div className="mt-8 text-center">
                  <button
                    type="button"
                    onClick={loadMoreEvents}
                    className="st-shine-parent inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-[#DA2128] to-[#F59C00] px-8 py-3 text-[13px] font-bold text-white shadow-lg shadow-[#DA2128]/30 transition-all hover:-translate-y-0.5 hover:shadow-[#DA2128]/45"
                  >
                    Load More Events
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* ==================== PRESS RELEASES & COVERAGE ==================== */}
      <section
        id="press"
        className="relative z-10 -mt-10 scroll-mt-20 overflow-hidden rounded-t-[44px] bg-[#FAF7F2] py-16 lg:py-20"
      >
        <div className="pointer-events-none absolute -left-24 bottom-0 h-72 w-72 rounded-full bg-[#DA2128]/10 blur-3xl" />
        <div className="relative mx-auto max-w-7xl px-6 lg:px-12">
          <div className="mb-10 max-w-2xl">
            {sectionEyebrow('Newsroom', '#DB6400')}
            <h2
              className="mt-3 text-2xl font-medium leading-[1.25] tracking-tight text-[#241A16] md:text-4xl"
              style={SERIF}
            >
              Press Release &amp; <span className="text-[#DA2128]">Press Coverage</span>
            </h2>
          </div>
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="rounded-2xl border border-stone-200 bg-white p-4 shadow-[0_10px_40px_-24px_rgba(218,33,40,0.35)] sm:p-5"
          >
            <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
              <div className="inline-flex w-fit rounded-full bg-stone-100 p-1">
                {[
                  { key: 'releases', label: 'Press Releases', count: PRESS_RELEASES.length },
                  { key: 'coverage', label: 'Press Coverage', count: PRESS_COVERAGE.length },
                ].map((t) => (
                  <button
                    key={t.key}
                    type="button"
                    onClick={() => setPressTab(t.key)}
                    className={`relative rounded-full px-5 py-2.5 text-[12.5px] font-bold uppercase tracking-[0.06em] transition-all duration-300 ${
                      pressTab === t.key
                        ? 'bg-white text-[#DA2128] shadow-md'
                        : 'text-stone-500 hover:text-stone-700'
                    }`}
                  >
                    {t.label}
                    <span
                      className={`ml-2 rounded-full px-2 py-0.5 text-[10px] ${
                        pressTab === t.key ? 'bg-[#DA2128]/10 text-[#DA2128]' : 'bg-stone-200 text-stone-500'
                      }`}
                    >
                      {t.count}
                    </span>
                  </button>
                ))}
              </div>
              <div className="flex flex-1 flex-col gap-3 sm:flex-row sm:items-center lg:max-w-xl">
                <div className="relative flex-1">
                  <FaSearch className="pointer-events-none absolute left-3.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-[#DA2128]" />
                  <input
                    type="text"
                    value={pressKeyword}
                    onChange={(e) => setPressKeyword(e.target.value)}
                    placeholder="Search press releases & coverage..."
                    className="w-full rounded-xl border border-stone-200 bg-[#FAF7F2] py-2.5 pl-10 pr-3.5 text-[13px] font-medium text-stone-700 transition duration-300 placeholder:text-stone-400 hover:border-[#DA2128]/30 focus:border-[#DA2128] focus:bg-white focus:outline-none focus:ring-2 focus:ring-[#DA2128]/10"
                  />
                </div>
                <div className="flex shrink-0 items-center gap-2">
                  <div className="flex overflow-hidden rounded-xl text-[11.5px] font-bold ring-1 ring-stone-200">
                    {[
                      ['newest', 'Newest'],
                      ['oldest', 'Oldest'],
                    ].map(([v, l]) => (
                      <button
                        key={v}
                        type="button"
                        onClick={() => setPressSort(v)}
                        className={`px-3.5 py-2.5 transition-colors ${
                          pressSort === v
                            ? 'bg-gradient-to-r from-[#DA2128] to-[#DB6400] text-white'
                            : 'bg-white text-stone-500 hover:text-[#DA2128]'
                        }`}
                      >
                        {l}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
          <div ref={pressResultsRef} className="mt-10 scroll-mt-32">
            <div className="flex flex-wrap items-center justify-between gap-3 border-b-2 border-stone-900/90 pb-4">
              <h3 className="flex items-center gap-2.5 text-xl font-bold text-stone-900 sm:text-2xl" style={SERIF}>
                {pressTab === 'releases' ? 'Press Releases' : 'Press Coverage'}
                <button
                  type="button"
                  title="Subscribe via RSS"
                  className="text-[#DA2128] transition-colors hover:text-[#DB6400]"
                  onClick={(e) => e.preventDefault()}
                >
                  <FaRss className="h-4 w-4" />
                </button>
              </h3>
              <span className="text-[12.5px] font-semibold text-stone-400">
                {pressFiltered.length === 0
                  ? 'No matching results'
                  : `Showing ${pressStart + 1}–${Math.min(
                      pressStart + PRESS_PAGE_SIZE,
                      pressFiltered.length
                    )} of ${pressFiltered.length}`}
              </span>
            </div>
            {pressPageItems.length > 0 ? (
              pressPageItems.map((item, i) => (
                <motion.article
                  key={`${pressTab}-${item.title}-${i}`}
                  layout
                  initial={{ opacity: 0, y: 18 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.35, delay: i * 0.05 }}
                  className="group flex flex-col gap-4 border-b border-stone-200 py-6 sm:flex-row sm:items-center sm:justify-between"
                >
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2.5">
                      <span className="inline-flex items-center gap-1.5 rounded-full bg-[#FEF7F4] px-2.5 py-1 text-[10.5px] font-extrabold uppercase tracking-[0.14em] text-[#DA2128]">
                        <FaCalendarAlt className="h-3 w-3" />
                        {item.date}
                      </span>
                      <span className="inline-flex rounded-full border border-stone-200 px-2.5 py-1 text-[10.5px] font-bold uppercase tracking-[0.1em] text-stone-500">
                        {pressTab === 'releases' ? 'Release' : 'Coverage'}
                      </span>
                    </div>
                    <h4
                      className="mt-3 text-[17px] font-bold leading-snug text-stone-900 transition-colors group-hover:text-[#DA2128] sm:text-[18px]"
                      style={SERIF}
                    >
                      {item.title}
                    </h4>
                    <p className="mt-2 text-[13.5px] leading-relaxed text-stone-600">{item.excerpt}</p>
                  </div>
                  <a
                    href="#"
                    className="inline-flex shrink-0 items-center gap-1.5 self-start rounded-full border border-[#DA2128]/25 px-4 py-2 text-[12.5px] font-bold text-[#DA2128] transition-all duration-300 hover:bg-[#DA2128] hover:text-white sm:self-center"
                  >
                    Read more
                  </a>
                </motion.article>
              ))
            ) : (
              <div className="flex flex-col items-center py-16 text-center">
                <div className="grid h-16 w-16 place-items-center rounded-3xl bg-[#FEF7F4]">
                  <FaSearch className="h-7 w-7 text-[#DA2128]" />
                </div>
                <h4 className="mt-5 text-lg font-bold text-stone-900" style={SERIF}>
                  {pressSource.length === 0 ? 'Nothing published yet' : 'No results found'}
                </h4>
                <p className="mt-2 max-w-sm text-[13px] text-stone-500">
                  {pressSource.length === 0
                    ? "This council hasn't shared a press release or coverage item yet."
                    : 'Nothing matches your search. Try a different keyword or clear it to see everything.'}
                </p>
                {pressKeyword && (
                  <button
                    type="button"
                    onClick={() => setPressKeyword('')}
                    className="mt-5 rounded-full bg-gradient-to-r from-[#DA2128] to-[#DB6400] px-6 py-2.5 text-[12.5px] font-bold text-white shadow-lg shadow-[#DA2128]/25 transition-all hover:shadow-[#DA2128]/40"
                  >
                    Clear search
                  </button>
                )}
              </div>
            )}
            {pressTotalPages > 1 && (
              <div className="mt-10 flex items-center justify-center gap-2">
                <button
                  disabled={pressClampedPage === 1}
                  onClick={() => changePressPage(pressClampedPage - 1)}
                  className="grid h-10 w-10 place-items-center rounded-xl text-stone-500 ring-1 ring-stone-200 transition-all hover:text-[#DA2128] hover:ring-[#DA2128] disabled:pointer-events-none disabled:opacity-35"
                  aria-label="Previous page"
                >
                  <FaChevronLeft className="h-4 w-4" />
                </button>
                {Array.from({ length: pressTotalPages }, (_, i) => i + 1).map((n) => (
                  <button
                    key={n}
                    onClick={() => changePressPage(n)}
                    className={`relative h-10 w-10 rounded-xl text-[13px] font-extrabold transition-all ${
                      n === pressClampedPage
                        ? 'text-white'
                        : 'text-stone-500 ring-1 ring-stone-200 hover:text-[#DA2128] hover:ring-[#DA2128]'
                    }`}
                  >
                    {n === pressClampedPage && (
                      <motion.span
                        layoutId="press-page-pill"
                        className="absolute inset-0 rounded-xl bg-gradient-to-br from-[#DA2128] to-[#DB6400] shadow-lg shadow-[#DA2128]/30"
                        transition={{ type: 'spring', stiffness: 420, damping: 32 }}
                      />
                    )}
                    <span className="relative">{n}</span>
                  </button>
                ))}
                <button
                  disabled={pressClampedPage === pressTotalPages}
                  onClick={() => changePressPage(pressClampedPage + 1)}
                  className="grid h-10 w-10 place-items-center rounded-xl text-stone-500 ring-1 ring-stone-200 transition-all hover:text-[#DA2128] hover:ring-[#DA2128] disabled:pointer-events-none disabled:opacity-35"
                  aria-label="Next page"
                >
                  <FaChevronRight className="h-4 w-4" />
                </button>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* ==================== REPORTS ==================== */}
      <section
        id="reports"
        className="relative overflow-hidden bg-gradient-to-b from-[#FEF7F4] via-[#FAF7F2] to-[#FEF7F4] py-16 lg:py-20"
      >
        <div className="pointer-events-none absolute -right-24 top-10 h-72 w-72 rounded-full bg-[#F59C00]/10 blur-3xl" />
        <div className="anim-st-blob anim-st-float pointer-events-none absolute -left-24 bottom-10 h-64 w-64 bg-[#DA2128]/10 blur-3xl" />
        <div className="relative mx-auto max-w-7xl px-6 lg:px-12">
          <div className="mb-12 max-w-2xl">
            {sectionEyebrow('Reports & Knowledge Hub', '#DB6400')}
            <h2
              className="mt-3 text-2xl font-medium leading-[1.25] tracking-tight text-[#241A16] md:text-4xl"
              style={SERIF}
            >
              Publications &amp; Reports
            </h2>
            <p className="mt-4 text-base leading-relaxed text-[#241A16]/75 font-normal">
              Research, policy notes and sector reports prepared by the council to inform decisions and shape the
              state&apos;s growth agenda.
            </p>
          </div>
          {PUBLICATIONS.length > 0 ? (
            <div className="mt-6 grid gap-7 lg:grid-cols-3">
              {PUBLICATIONS.map((p, i) => (
                <motion.article
                  key={p.title}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.08 }}
                  className="group relative flex h-full flex-col overflow-hidden rounded-3xl border border-stone-200 bg-white transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl hover:shadow-[#DA2128]/10"
                >
                  <div className="st-pub-card-bg relative h-36 overflow-hidden">
                    <svg
                      className="absolute inset-0 h-full w-full text-white/20"
                      viewBox="0 0 400 160"
                      preserveAspectRatio="none"
                      aria-hidden="true"
                    >
                      <path d="M0 120 Q60 90 120 118 T240 116 T400 96 L400 160 L0 160Z" fill="currentColor" />
                      <path d="M0 138 Q80 112 160 136 T320 130 T400 124 L400 160 L0 160Z" fill="currentColor" opacity="0.6" />
                    </svg>
                    <div className="absolute left-6 top-5 flex flex-col gap-2">
                      <span className="w-max rounded-full bg-white/20 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.14em] text-white backdrop-blur">
                        {p.date}
                      </span>
                      <span className="w-max rounded-full bg-white px-3 py-1 text-[11px] font-bold text-[#DA2128]">
                        {p.partner}
                      </span>
                    </div>
                  </div>
                  <div className="flex flex-1 flex-col p-7">
                    <h3
                      className="text-[19px] font-bold leading-snug text-stone-900 transition-colors group-hover:text-[#DA2128]"
                      style={SERIF}
                    >
                      {p.title}
                    </h3>
                    <p className="mt-3 flex-1 text-[14px] leading-relaxed text-stone-600">{p.text}</p>
                    <div className="mt-6 flex items-center justify-between gap-3">
                      <button
                        type="button"
                        className="st-shine-parent inline-flex items-center gap-2 rounded-full border border-[#DA2128]/25 bg-[#FEF7F4] px-5 py-2.5 text-[12.5px] font-bold text-[#DA2128] transition-all duration-300 hover:bg-[#DA2128] hover:text-white"
                      >
                        Download PDF
                        <FaDownload className="h-3.5 w-3.5" />
                      </button>
                      <span className="text-[11.5px] font-semibold uppercase tracking-wide text-stone-400">
                        {p.pages}
                      </span>
                    </div>
                  </div>
                </motion.article>
              ))}
            </div>
          ) : (
            <div className="mt-6 flex flex-col items-center rounded-[24px] border border-dashed border-[#DA2128]/25 bg-white/60 py-16 text-center">
              <div className="grid h-16 w-16 place-items-center rounded-3xl bg-[#FEF7F4]">
                <FaLightbulb className="h-7 w-7 text-[#DA2128]" />
              </div>
              <h4 className="mt-5 text-lg font-bold text-stone-900" style={SERIF}>
                Publications coming soon
              </h4>
              <p className="mt-2 max-w-sm text-[13px] text-stone-500">
                This council hasn&apos;t published a report yet. Check back soon, or explore other sections above.
              </p>
            </div>
          )}
        </div>
      </section>

      {/* ==================== CONTACT US ==================== */}
      <section id="contact" className="relative scroll-mt-20 overflow-hidden bg-gradient-to-b from-[#FAF7F2] to-[#FFFBF7] py-16 lg:py-20">
        <div className="pointer-events-none absolute -right-24 top-10 h-72 w-72 rounded-full bg-[#F59C00]/10 blur-3xl" />
        <div className="anim-st-blob anim-st-float-slow pointer-events-none absolute -left-24 bottom-8 h-64 w-64 bg-[#DA2128]/10 blur-3xl" />
        <div className="relative mx-auto max-w-7xl px-6 lg:px-12">
          <div className="grid gap-10 lg:grid-cols-2">
            <div>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="mb-3 inline-flex items-center gap-2"
              >
                <div className="h-[2px] w-6 rounded-full bg-[#DA2128]" />
                <span className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#DA2128]">Contact</span>
              </motion.div>
              <motion.h2
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.1 }}
                className="mb-3 text-3xl font-bold leading-[1.1] tracking-tight sm:text-4xl text-stone-900"
                style={SERIF}
              >
                Contact <span className="text-[#DA2128]">Us</span>
              </motion.h2>
              <p className="mb-6 text-base leading-relaxed text-[#241A16]/75 font-normal">
                For queries related to the {name}, reach out to the secretariat. Our team will respond within 48
                hours.
              </p>

              <motion.div
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.15 }}
                className="w-full max-w-md rounded-2xl border border-stone-100 bg-white p-5 shadow-sm font-sans"
              >
                <div className="space-y-5">
                  {/* HoD */}
                  <div className="flex items-start gap-3.5">
                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#FDF2F2] text-sm font-bold text-[#C0262D]">
                      {(hod?.name || defaultHod?.name || 'H').charAt(0).toUpperCase()}
                    </div>
                    <div className="min-w-0 flex-1">
                      <h4 className="text-[14px] font-extrabold text-stone-900 leading-snug">
                        {hasNamedHod ? 'ASSOCHAM State Head' : 'Council Secretariat'}
                      </h4>
                      <p className="text-[14px] font-bold text-[#C0262D]">{hod?.name || defaultHod.name}</p>
                      <p className="text-[12px] text-stone-500">{hod?.title || `Nodal Officer — ${name}`}</p>
                    </div>
                  </div>
                  {/* Address */}
                  <div className="flex items-start gap-3.5">
                    <a
                      href={mapsUrl(office)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="group flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#FDF2F2] text-[#C0262D] transition-colors hover:bg-[#C0262D] hover:text-white"
                    >
                      <FaRegBuilding className="h-4 w-4" />
                    </a>
                    <div className="min-w-0 flex-1">
                      <h4 className="text-[14px] font-extrabold text-stone-900 leading-snug">
                        {office.city ? `Address (${office.city})` : 'Address'}
                      </h4>
                      <div className="text-[12.5px] leading-relaxed text-stone-600">
                        {office.lines.map((line, i) => (
                          <span key={i} className="block">{line}</span>
                        ))}
                      </div>
                    </div>
                  </div>
                  {/* Email */}
                  <div className="flex items-start gap-3.5">
                    <a
                      href={`mailto:${hodEmail}?subject=${encodeURIComponent(`Query — ${name}`)}`}
                      className="group flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#FDF2F2] text-[#C0262D] transition-colors hover:bg-[#C0262D] hover:text-white"
                    >
                      <FaEnvelope className="h-4 w-4" />
                    </a>
                    <div className="min-w-0 flex-1">
                      <h4 className="text-[14px] font-extrabold text-stone-900 leading-snug">Email</h4>
                      <a
                        href={`mailto:${hodEmail}?subject=${encodeURIComponent(`Query — ${name}`)}`}
                        className="block truncate text-[13px] font-bold text-[#C0262D] hover:underline"
                      >
                        {hodEmail}
                      </a>
                      <p className="text-[11.5px] text-stone-500">For queries related to {stateLabel || 'Council'}.</p>
                    </div>
                  </div>
                  {/* Phone */}
                  <div className="flex items-start gap-3.5">
                    <a
                      href={`tel:${hodPhoneHref}`}
                      className="group flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#FDF2F2] text-[#C0262D] transition-colors hover:bg-[#C0262D] hover:text-white"
                    >
                      <FaPhone className="h-4 w-4" />
                    </a>
                    <div className="min-w-0 flex-1">
                      <h4 className="text-[14px] font-extrabold text-stone-900 leading-snug">Phone Number</h4>
                      <a
                        href={`tel:${hodPhoneHref}`}
                        className="block text-[13px] font-bold text-[#C0262D] hover:underline"
                      >
                        {hod?.phone || defaultHod.phone}
                      </a>
                      <p className="text-[11.5px] text-stone-500">Mon–Fri, 9:30 AM – 6:00 PM IST</p>
                    </div>
                  </div>
                  {hodWaNumber && hasNamedHod && (
                    <div className="pt-1 pl-[50px]">
                      <a
                        href={`https://wa.me/${hodWaNumber}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-1.5 text-[12px] font-bold text-emerald-600 hover:underline"
                      >
                        <FaWhatsapp className="h-3.5 w-3.5" /> WhatsApp
                      </a>
                    </div>
                  )}
                </div>
              </motion.div>
            </div>
            <QueryForm />
          </div>
        </div>
      </section>
    </main>
  );
}

// ---- Helper Components (CountUp, StateCalendarBadge, StateEventCard) ----
// These remain exactly as they were in the original file.
// I have omitted them here for brevity, but they are required in the actual file.
// Please ensure you copy them from your existing StatePage.jsx.

function CountUp({ value, duration = 1500 }) {
  const [display, setDisplay] = useState(0);
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    let started = false;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || started) return;
          started = true;
          const start = performance.now();
          const tick = (now) => {
            const p = Math.min((now - start) / duration, 1);
            const eased = 1 - Math.pow(1 - p, 3);
            setDisplay(Math.round(eased * value));
            if (p < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
        });
      },
      { threshold: 0.4 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [value, duration]);
  return <span ref={ref}>{display}</span>;
}

function StateCalendarBadge({ date, active }) {
  const { dayPart, monthPart, year } = getDateParts(date);
  return (
    <div className="relative mx-auto flex w-[88px] shrink-0 flex-col overflow-hidden rounded-[18px] border border-white/80 bg-white shadow-[0_10px_28px_rgba(219,38,40,0.12)] transition-all duration-500 group-hover:-translate-y-1.5 group-hover:rotate-[-1deg] group-hover:shadow-[0_18px_40px_rgba(219,38,40,0.18)] sm:mx-0">
      <div className="absolute left-3 top-0 h-2.5 w-2.5 -translate-y-1/2 rounded-full border border-[#DA2128]/30 bg-[#FEF7F4] transition duration-500 group-hover:bg-[#F59C00]" />
      <div className="absolute right-3 top-0 h-2.5 w-2.5 -translate-y-1/2 rounded-full border border-[#DA2128]/30 bg-[#FEF7F4] transition duration-500 group-hover:bg-[#F59C00]" />
      <div className="relative bg-gradient-to-br from-white to-[#FAF7F2] px-2.5 py-3 text-center">
        <div className="font-heading text-[1.55rem] font-black leading-none text-stone-900" style={SERIF}>
          {dayPart}
        </div>
        <div className="mt-1.5 text-[0.65rem] font-extrabold uppercase tracking-[0.22em] text-[#DB6400]">
          {monthPart}
        </div>
      </div>
      <div
        className={`relative px-2.5 py-2 text-center text-[0.7rem] font-extrabold tracking-[0.18em] text-white ${
          active ? 'bg-gradient-to-r from-[#DA2128] to-[#F59C00]' : 'bg-gradient-to-r from-stone-500 to-stone-600'
        }`}
      >
        <span className="relative z-10">{year}</span>
      </div>
    </div>
  );
}

function StateEventCard({ event, index }) {
  const active = isEventUpcoming(event.date);
  const delay = `${Math.min(index * 70, 600)}ms`;
  return (
    <article
      style={{ animationDelay: delay }}
      className="event-fade-up group relative overflow-hidden rounded-[24px] border border-[#DA2128]/10 bg-white p-4 shadow-[0_12px_32px_rgba(218,33,40,0.07)] transition-all duration-500 hover:-translate-y-1.5 hover:border-[#DA2128]/25 hover:shadow-[0_20px_48px_rgba(218,33,40,0.14)] sm:p-5"
    >
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(245,156,0,0.12),transparent_32%),radial-gradient(circle_at_bottom_left,rgba(218,33,40,0.1),transparent_35%)] opacity-80 transition-opacity duration-500 group-hover:opacity-100" />
      <div className="relative flex flex-col gap-4 sm:flex-row sm:items-start">
        <StateCalendarBadge date={event.date} active={active} />
        <div className="min-w-0 flex-1 space-y-3">
          <div className="flex flex-wrap items-center gap-2">
            <span className="inline-flex rounded-full bg-[#FAF7F2] px-2.5 py-1 text-[0.65rem] font-extrabold uppercase tracking-[0.18em] text-[#DA2128] transition duration-300 group-hover:scale-105">
              {event.tag || 'Event'}
            </span>
            {event.place && (
              <span className="inline-flex rounded-full border border-[#DB6400]/25 bg-[#FEF7F4] px-2.5 py-1 text-[0.7rem] font-bold text-[#DB6400] transition duration-300 group-hover:-translate-y-0.5">
                {event.place}
              </span>
            )}
            {active ? (
              <span className="event-live-pill inline-flex items-center gap-1.5 rounded-full bg-[#FFF0EC] px-2.5 py-1 text-[0.65rem] font-extrabold uppercase tracking-[0.18em] text-[#DA2128]">
                <span className="relative flex h-2 w-2">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#DA2128] opacity-75" />
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-[#DA2128]" />
                </span>
                Upcoming
              </span>
            ) : (
              <span className="inline-flex items-center gap-1.5 rounded-full border border-stone-300 bg-stone-50 px-2.5 py-1 text-[0.65rem] font-extrabold uppercase tracking-[0.18em] text-stone-500">
                Archived
              </span>
            )}
          </div>
          <h3
            className="text-[1.05rem] font-extrabold leading-snug text-stone-900 transition-all duration-500 group-hover:translate-x-0.5 group-hover:text-[#DA2128] sm:text-[1.15rem]"
            style={SERIF}
          >
            {event.title}
          </h3>
          <p className="text-[13.5px] leading-relaxed text-stone-600">{event.text}</p>
          {event.highlight && (
            <div className="flex items-start gap-3 rounded-2xl bg-[#FAF7F2] p-3.5">
              <FaCheck className="mt-0.5 h-4 w-4 shrink-0 text-[#DA2128]" />
              <p className="text-[13px] font-medium leading-relaxed text-stone-700">{event.highlight}</p>
            </div>
          )}
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex items-center gap-2.5 rounded-full bg-[#FFFDFC] px-3 py-1.5 text-[0.8rem] font-semibold text-stone-600 shadow-sm transition duration-300 group-hover:shadow-md">
              <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-gradient-to-br from-[#DA2128] to-[#F59C00] text-white shadow-[0_6px_14px_rgba(218,33,40,0.22)]">
                <FaCalendarAlt className="h-3.5 w-3.5" />
              </span>
              <span>{event.date}</span>
            </div>
            <button
              type="button"
              className="inline-flex w-fit items-center gap-1.5 rounded-full bg-gradient-to-r from-[#DA2128] to-[#F59C00] px-4 py-2 text-[0.8rem] font-bold text-white shadow-[0_10px_22px_rgba(218,33,40,0.22)] transition-all duration-300 hover:scale-[1.03] hover:shadow-[0_14px_28px_rgba(218,33,40,0.3)] active:scale-[0.98]"
            >
              {active ? 'Register Interest' : 'View Highlights'}
            </button>
          </div>
        </div>
      </div>
    </article>
  );
}